var my_money_format = {
  formatMoney : function(cents, currency_format) {
    
     cents=cents*100;
   var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   var formatString=currency_format;
   format_str=formatString.match(placeholderRegex)[1];
   function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
   }
 
   function formatWithDelimiters(number, precision, thousands, decimal) {
     precision = defaultOption(precision, 2);
     thousands = defaultOption(thousands, ',');
     decimal   = defaultOption(decimal, '.');
 
     if (isNaN(number) || number == null) { return 0; }
 
     number = (number/100.0).toFixed(precision);
 
     var parts   = number.split('.'),
         dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
         cents   = parts[1] ? (decimal + parts[1]) : '';
 
     return dollars + cents;
   }
 
   switch(format_str) {
     case 'amount':
       value = formatWithDelimiters(cents, 2);
       break;
     case 'amount_no_decimals':
       value = formatWithDelimiters(cents, 0);
       break;
     case 'amount_with_comma_separator':
       value = formatWithDelimiters(cents, 2, '.', ',');
       break;
     case 'amount_no_decimals_with_comma_separator':
       value = formatWithDelimiters(cents, 0, '.', ',');
       break;
      default:
         value = formatWithDelimiters(cents, 2);
   }
   return value;
   //return formatString.replace(placeholderRegex, value);
 }}; 
 var poweredby_html = '';
 var poweredby_html2 = '';
(function(){
 //console.log=function(){};
 var dis_app_plan_id=0;
 var dis_analtys_required='Y';
 var page ='';
 var voucher_btntxt='APPLY COUPON';
 var cpn_btntxt="APPLY";
 var cpn_empty_err = '';
 var cpn_invld_err = '';
 var cpn_not_applicable='';
 var cpn_popup_not_select_err = '';
 var cpn_popup_not_valid_to_itm_err = '';
 var cpn_popup_itm_amnt_insufnt_err = '';
 var cpn_min_quantity_err = '';
 var coupon_body = ''; 
 var cpnpop_body = '';
 var cpnapply_body = '';
 var msgcpn_body = '';
 var replace_avail = '';
 var css_include = '';
 var cpn_style_arr = [];
 var crtdwr_class = "";
 var radius_text = "";
 var radius_btn = "";
 var radius_popup="";
 var pop_bgcolor =  "";
 var pop_header_text_color = "";
 var voucher_bgcolor ="";
 var voucher_txtcolor =  "";
 var pop_headertxt="";
 var avl_status = "";
 var avl_text ="";
 var cpn_data =[];
 var err_message_setting ='';
 var voila_div_align='';
 var avl_coupons='';
 var respons_cls='';
 var pop_loader_img="<div class='lds-dual-ring'></div>";
 var cart_token='';
 var desktop_width=1000;
 var discnt_applied_msg='';
 var is_custom_checkout_button='';
 var custom_checkout_button_cls_names='';
 var free_shipping_text='';
 var popup_coupons_enb_dis='';
 var coupons_check_count=0;
 var ori_cpn_title='';
 var cpn_txbox_width=0;
 var cpn_btn_width=0;
 var cpn_txt_style='';
 var cpn_btn_style='';
 var btn_padding='';
 var summary_html='';
 var is_total_details=0;
 var total_cart_price_disp=0;
 var actual_check_out_url='';
 var is_direct_validation='';
 var original_cart_total=0;
var discount_cstm_txt="Discount";
var total_cstm_txt="Total";
 var currency_format='{{amount}}';
 var pop_applied_suc_text='';
 var pop_save_cpn_text='';
 var pop_chkout_btn_text='';
 var apply_logo_color='';
 var feat_cart_cpn_status='';
 var feat_cart_cpn_text='';
 var feat_cart_cpn_code='';
 var hero_cpn_font_weight='';
 /*var avl_txtcolor ='';
 var avl_txtsize='';*/
 var is_popup_link_position_top='';
 var btn_pding_top_style='';
 var coupon_count =0;
 var   applied_msg_style='color:#769e46;';
 var dis_txt_box_btn='';
 var hero_cpn_txt_clr='#000';
 var ios_link_issue_stores=['sticker-foot.myshopify.com','el-the-cook.myshopify.com','fynnushop.myshopify.com','the-indian-ethnic-company.myshopify.com','provalo-cosmetics.myshopify.com'];
 var cpns_link_click_issues=['breezedecor-in.myshopify.com','provalo-cosmetics.myshopify.com'];
 var link_button_above_stores=['fourthfrontier.myshopify.com','fourth-frontier-india.myshopify.com','fourth-frontier-uk.myshopify.com','saadaa-design.myshopify.com'];
var fourth_stores=['fourthfrontier.myshopify.com','fourth-frontier-india.myshopify.com','fourth-frontier-uk.myshopify.com'];
var right_left_stores=['dilli999.myshopify.com','hair-styleing.myshopify.com'];
var attrCartDraw = [];
var btn_margin_issue='';
var eolallc_store_height_added=0;
var global_cpns_list=[];
var global_api_data=null;
var global_app_enable='';
var is_freeshipping=0;
var http_dom='https://';
var entire_gloabal_api_data=null;
var auto_discount_code='';
var wallet_check_out_url='';
var wallet_check_out_shops=['dilli999.myshopify.com'];
var is_cart_change_action=0;

var cart_drawer_issues_stores=['odara-jewellery.myshopify.com','sa3cosmetic.myshopify.com','nxndnstuffs.myshopify.com','vapouroxide.myshopify.com','crystallineme-uk.myshopify.com','crystallineme-de.myshopify.com','eiffeltextile.myshopify.com','vvegano.myshopify.com',
'lakdi-furniture-store.myshopify.com','aastey.myshopify.com','smartivity-in.myshopify.com',
'thebearhouseindia.myshopify.com','snackamor.myshopify.com','the-amyra-store.myshopify.com','quecy-com.myshopify.com',
'ldu-letsdressup-staging.myshopify.com','ldu-letsdressup.myshopify.com','super-portraits.myshopify.com','fancy-fluff-india.myshopify.com',
'the-indian-garage.myshopify.com','bombay-shaving.myshopify.com','trymaylillies.myshopify.com','skinbae-in.myshopify.com'];


  var getCurrentScript = function () {
try {
     if ( document.currentScript && ( document.currentScript.src !== '' ) )
         return document.currentScript.src;
     var scripts = document.getElementsByTagName( 'script' ),
         str = scripts[scripts.length - 1].src;
     if ( str !== '' )
         return src;
     return new Error().stack.match(/(https?:[^:]*)/)[0];
}
catch(err) {
  return 'discountoncart.com';
 
 if ((document.head.innerHTML.includes('localhost/voila'))||(document.body.innerHTML.includes('localhost/voila')))
 {
    
     return 'localhost/voila';
 }
 
 return 'discountoncart.com';
}
 
 };

 var getCurrentScriptPath = function () {
     var script = getCurrentScript(),
         path = script.substring( 0, script.lastIndexOf( '/' ) );
     return path;
 };

 var getEnvURL = function () {

   var check_dummy=true;
   var demo_shop = "voila-power-coupons-on-cart-demo";
  
   if ( window.location.origin.includes(demo_shop)==true)
   {
     check_dummy=false;
     return 'indiaroyals.in';
   }
   var eUrl='';
   finalPath= 'discountoncart.com';
   try{
    eUrl=getCurrentScriptPath();
   }
   catch(ex)
   {
    return  finalPath;
   }
   var substring="localhost"
 
   if (eUrl.indexOf(substring) >= 0)
   {
      finalPath= 'localhost/voila';
   }
   else if (eUrl.indexOf("ngrok.io") >= 0)
   {
      finalPath= 'localhost/voila';
   }
   else{
     finalPath= 'discountoncart.com';
   }
     return  finalPath;
   
 };
var manageDiscountifyApp = function($){ 
 
  const expiryTime=1200000;
  var urlPath=getEnvURL();

 
$('head').append('<link rel="stylesheet" rel="nofollow" href="'+http_dom+urlPath +'/frontend/cart_discountify.min.css?v=1.3.5" type="text/css" />');   
var api_path =http_dom+urlPath +'/ajax';
var loader = "<div class='progload'></div>";
var shop_domain = Shopify.shop;

const cur_path = window.location.pathname;
page = cur_path.substring(cur_path.lastIndexOf("/") + 1); 
  
  if (cur_path.indexOf(`/checkouts/`)>0)
  {
    page='checkout';
    Shopify.shop=Shopify.Checkout.apiHost;
    shop_domain=Shopify.Checkout.apiHost;
    Shopify.currency={active: Shopify.Checkout.currency};
  }
  else{
    page = cur_path.substring(cur_path.lastIndexOf("/") + 1); 
  }

var shop_data = {shop_domain: shop_domain };
var apply_logo =''; 
var f_json = '';
try{
  if ($('script[id="shopify-features"]').length>0)
  {
    f_json =JSON.parse( $($('script[id="shopify-features"]')[0]).text() );
  }
 
}
catch(ex)
{
  
}
var sh_acc_token=f_json.accessToken;
var err_data;
var footer_height;
var txtbox_status ;
var mouse_down_check_outs=['fourth-frontier-india.myshopify.com','fourth-frontier-uk.myshopify.com'];
 var txtbox_title ;
 var txtbox_placeholder_title;
 var avl_txtcolor;
 var avl_txtsize;
 var cpn_btnbgcolor;
 var cpn_btntxtcolor;
 var cpn_txtbox_title_color;
 var cpn_avl_hov_txtcolor;
 var chkbtn_bgcolor;
 var chkbtn_txtcolor;
 var is_radius;
 var is_cpn_txtbox_border;
 var is_sucess_popup;
 var pop_cpn_sel_color;
 var p_width;
 var txt_radius_text_border = "";
 var btn_radius_btn = "";


 var left_align_shops=['pawfectface.myshopify.com'];
 var text_lign_desc='right';
 var main_body_right='';
 var textbox_width='';
 var app_target_parent='';
 var txt_box_height="";
 var main_padding_top="";
 var btn_height="";
 var default_text_cpn_dropdown="Select Coupon";
 var border_color_cpn_dropdown="#3A3A3A";
 var relish_shops=['relish-official.myshopify.com','relish-belgium.myshopify.com','relish-international.myshopify.com'];
 var is_main_body_right='';
 var price_issue_stores=['floryo.myshopify.com','workoutspecialist.myshopify.com'];
 let prev_subtotal='';
 if (relish_shops.includes(shop_domain))
{
 $('head').append(`
 <style>
 .discountify_modal
 {
   z-index:2147483649 !important
 }
 .discountify_pop_body{
   
 width: 100% !important;

 }
</style>`);
}
function display_popup_cpns_based_on_conditions(is_show_popup=0)
{
 if ($('#discountify_modal').length==0)
 {
   $('body').append(cpnpop_body);
   $('#discountify_modal').hide();
   $('body').find('.discountify_pop_body').html(avl_coupons);
 
 }
 if ($('#discountify_modal').find(`[data-show-condition=on]`).length==0)
 {
   if (is_show_popup==1)
   {
     toggle_popup();
   }
   return;
 }
 if ($('.coupon_grid').length==0)
 {
   if (is_show_popup==1)
   {
     toggle_popup();
   }
   return;
 }

 $.getJSON('/cart.js', function(cart) { 
   if (cart.items.length>0)
    {
     var cart_price = (Math.round(cart.total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);
     if (shop_domain=='bsc-women.myshopify.com')
      {
        cart_price = (Math.round(cart.original_total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);

        let cart_level_discount= (Math.round(cart.total_discount+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);
        if (cart_level_discount>0)
        {
          t_discount=cart_level_discount -t_discount;
          discnt_val= t_discount;
          discount_round = t_discount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
          discount_round=my_money_format.formatMoney(discount_round,currency_format);
     
       
        }
      }
      if (price_issue_stores.includes(shop_domain))
      {
        cart_price = (Math.round(cart.original_total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);

       
      }
     var invalid_cpns_count=0;
     $('#discountify_modal').find(`[data-show-condition=on]`).each(function()
     {
       var con_val=parseInt($(this).attr('data-condition-value'));
           if ($(this).attr('data-condition-type')=="total_item")
           {
               if (cart.item_count < con_val)
               {
                 $(this).hide();
                 invalid_cpns_count++;
               }
               else{
                 $(this).show();
               }
           }
           else{
             
             if ( cart_price <con_val)
             {
               $(this).hide();
               invalid_cpns_count++;
             }
             else{
               $(this).show();
             }

           }
     });
    }
   if ($('.coupon_grid').length==invalid_cpns_count)
   {
     $('.discount_availibility').hide();
   }
   else{
     $('.discount_availibility').show();
    

     if ((shop_domain=='xaestheticnation.myshopify.com'))
     {
       $('.show_availablity').text( $('.coupon_grid').length-invalid_cpns_count + " COUPONS HERE" );

     }
     else{
       replace_avail = avl_text.replace("[available coupons]",$('.coupon_grid').length-invalid_cpns_count+" ");
       $('.show_availablity').text(replace_avail);
     }

   }
   if (is_show_popup==1)
   {
     toggle_popup();
   }
});
}
function attach_again_popuevents()
{
  if (shop_domain=='ldu-letsdressup.myshopify.com')
  {
    
      $('body').on('click',".discountify_modal .discountify_popup_close", function (e) { e.preventDefault(); $(".discountify_modal").remove(); open_mini_cart_drw(false); });
      $('body').on('click',".discpon_wrap .discpon_close", function (e) { e.preventDefault(); $(".discpon_wrap").remove(); open_mini_cart_drw(false); });
      $('body').on('click',".discountify_snackbar .action_close", function (e) { e.preventDefault(); $(".discountify_snackbar").remove(); });
    
      $('body').on('click',".coupon_grid", function (e) {
        $(this).find('.coupon_check').prop("checked", true);
      
      });
  }
  
  
}
function toggle_popup()
{
 var ajx_popup = document.getElementById("discountify_modal");
 var ajax_close = document.getElementsByClassName("discountify_popup_close")[0];
 ajx_popup.style.display = "flex";
 set_popup_height();
 attach_again_popuevents();
 if (shop_domain=='the-amyra-store.myshopify.com')
 {
   
    $('.Drawer__Close').click();
    
 }
 if (relish_shops.includes(shop_domain))
 {
   relish_scroll();
    
 }
}
 
function relish_scroll()
{
  $('.Drawer__Close').click();
  return;
  var lastY=0;
         var touch_move_proc=false;
        
          $('.discountify_pop_body').on('touchmove',function(e){
         
          if (touch_move_proc==true)
          {
              return;
          }
          touch_move_proc=true;
          var currentY = e.originalEvent.touches[0].clientY;
          var sc_top_val=0;
           if(currentY > lastY){
                    
                 
              sc_top_val=  $('.discountify_pop_body')[0].scrollTop-20;  
              if (sc_top_val<=0)
              {
                  sc_top_val=0;
              }
              
          
           }else if(currentY < lastY){


            sc_top_val=  $('.discountify_pop_body')[0].scrollTop+20;   
                    if (sc_top_val>=$('.discountify_pop_body')[0].scrollHeight)
              {
                  sc_top_val=$('.discountify_pop_body')[0].scrollHeight;
              }
              
           }
           if ( $('.discountify_pop_body')[0].scrollTop !=sc_top_val)
           {
                $('.discountify_pop_body')[0].scrollTop=sc_top_val;
           }
             
           lastY = currentY;
          touch_move_proc=false;
             
          });
}
function set_main_data(api_data)
{



 if ((shop_domain=='sassy-panda.myshopify.com'))
 {
   btn_margin_issue='margin:0px 0px !important;';
 }
  err_data = api_data['error_mesgs'];
 cpn_empty_err = api_data['error_mesgs'][0].err_msg;
 cpn_invld_err = api_data['error_mesgs'][1].err_msg;
 cpn_popup_not_select_err = api_data['error_mesgs'][2].err_msg;
 cpn_popup_not_valid_to_itm_err = api_data['error_mesgs'][3].err_msg;
 cpn_popup_itm_amnt_insufnt_err = api_data['error_mesgs'][4].err_msg;
 cpn_min_quantity_err = api_data['error_mesgs'][5].err_msg;
 cpn_not_applicable= api_data['error_mesgs'][6].err_msg;
 if (cpn_not_applicable=='')
 {
    cpn_not_applicable='Coupon not applicable';
   }

  footer_height = "height:62px";
 apply_logo_color='';
if (shop_domain=='tvcool.myshopify.com')
{
 apply_logo_color="fill=white";
 is_popup_link_position_top='on';
}
if (link_button_above_stores.includes(shop_domain))
 {
   is_popup_link_position_top='on';

 }

  apply_logo = '<svg '+ apply_logo_color+' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class=\"cpn_svg\"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>';
 if (shop_domain=='rad-mad-bad.myshopify.com')
 {
  apply_logo="";
 }
  currency_format=api_data['shop_data']['money_with_currency_format'];
 if (right_left_stores.includes(shop_domain))
 {
   currency_format= "{{amount}} ₪";
 }

 is_main_body_right=cpn_data.main_body_right;
  avl_status = cpn_data.cpn_avl_status ? cpn_data.cpn_avl_status : "";
  txtbox_status = cpn_data.cpn_txtbox_status ? cpn_data.cpn_txtbox_status : "";
  txtbox_title = cpn_data.cpn_txtbox_title ? cpn_data.cpn_txtbox_title : "";
 txtbox_placeholder_title = cpn_data.cpn_txtbox_placeholder_title ? cpn_data.cpn_txtbox_placeholder_title : "Discount Code";
  avl_text = cpn_data.cpn_avl_text ? cpn_data.cpn_avl_text : "";
  avl_txtcolor = cpn_data.cpn_avl_txtcolor ? "color:"+cpn_data.cpn_avl_txtcolor+";" : "";
  avl_txtsize = cpn_data.cpn_avl_text_size ? "font-size:"+cpn_data.cpn_avl_text_size+"px!important;" : "";
  if (shop_domain=='packie-1.myshopify.com') 
  {
    if ($(window).width()<800)
    {
      avl_txtsize='font-size:12.6px';
    }
   
  } 
  cpn_btntxt = cpn_data.cpn_apply_btn_text ? cpn_data.cpn_apply_btn_text : "APPLY";
  cpn_btnbgcolor = cpn_data.cpn_apply_btn_bgcolor ? "background:"+cpn_data.cpn_apply_btn_bgcolor+"!important;" : "";
 discnt_applied_msg=cpn_data.discnt_applied_msg;
  cpn_btntxtcolor = cpn_data.cpn_apply_btn_txtcolor ? "color:"+cpn_data.cpn_apply_btn_txtcolor+"!important;" : "";
  pop_headertxt = cpn_data.pop_header_text ? cpn_data.pop_header_text : "Select a coupon from the list";
   voucher_btntxt = cpn_data.pop_btn_text ? cpn_data.pop_btn_text : "APPLY COUPON";
  voucher_bgcolor = cpn_data.pop_btn_bgcolor ? "background:"+cpn_data.pop_btn_bgcolor+"!important;border-color:"+cpn_data.pop_btn_bgcolor+"!important;" : "";
  voucher_txtcolor = cpn_data.pop_btn_txtcolor ? "color:"+cpn_data.pop_btn_txtcolor+"!important;" : "";
  
  cpn_txtbox_title_color = cpn_data.cpn_txtbox_color ? "color:"+cpn_data.cpn_txtbox_color+";" : "";
  cpn_avl_hov_txtcolor = cpn_data.cpn_avl_hov_txtcolor ? "color:"+cpn_data.cpn_avl_hov_txtcolor+"!important;" : "";
    pop_bgcolor = cpn_data.pop_bgcolor ? "background:"+cpn_data.pop_bgcolor+"!important;border-color:"+cpn_data.pop_bgcolor+"!important; " : "";
    pop_header_text_color = cpn_data.pop_header_text_color ? "color:"+cpn_data.pop_header_text_color+"!important;" : "";
  chkbtn_bgcolor = cpn_data.chkbtn_bgcolor ? "background:"+cpn_data.chkbtn_bgcolor+"!important;" : "";
chkbtn_txtcolor = cpn_data.chkbtn_txtcolor ? "color:"+cpn_data.chkbtn_txtcolor+"!important;" : "";
 cpn_style_arr = cpn_data.cpn_avl_style ? cpn_data.cpn_avl_style.split(',') : "";
  is_radius = cpn_data.cpn_btn_radius ? cpn_data.cpn_btn_radius : "";
 is_cpn_txtbox_border = cpn_data.cpn_apply_txtbox_bodrcolor ? "border-color:"+cpn_data.cpn_apply_txtbox_bodrcolor+"!important;" : "";
 is_sucess_popup = cpn_data.calc_pop_up ? cpn_data.calc_pop_up : "";
  err_message_setting = cpn_data.err_message_setting ? cpn_data.err_message_setting : "INLINE";
   is_custom_checkout_button = cpn_data.is_custom_checkout_button;
  custom_checkout_button_cls_names = cpn_data.custom_checkout_button_cls_names;
  free_shipping_text= cpn_data.free_shipping_text;
  popup_coupons_enb_dis=cpn_data.popup_coupons_enb_dis;
  if (popup_coupons_enb_dis=='on')
  {
    global_cpns_list=api_data['coupons_list'];
  }
  cpn_txbox_width = cpn_data.cpn_txbox_width;
  cpn_btn_width = cpn_data.cpn_btnbox_width ;
  pop_cpn_sel_color='#71a326';
  pop_cpn_sel_color = cpn_data.pop_cpn_sel_color ? cpn_data.pop_cpn_sel_color : "#71a326";
  is_direct_validation=cpn_data.is_direct_validation;

  discount_cstm_txt=cpn_data.discount_cstm_txt;
  total_cstm_txt=cpn_data.total_cstm_txt;

  pop_applied_suc_text=empty_check_replace_text(cpn_data.pop_applied_suc_text,"[Coupon Code] APPLIED SUCCESSFULLY");
  pop_save_cpn_text=empty_check_replace_text(cpn_data.pop_save_cpn_text,"Saving with this coupon");;
  pop_chkout_btn_text=empty_check_replace_text(cpn_data.pop_chkout_btn_text,"CHECKOUT");


  feat_cart_cpn_status=cpn_data.feat_cart_cpn_status;
  feat_cart_cpn_text=cpn_data.feat_cart_cpn_text;
  feat_cart_cpn_code=cpn_data.feat_cart_cpn_code;
  hero_cpn_txt_clr=cpn_data.hero_cpn_txt_clr;
  if(cpn_data.hero_cpn_font_weight !== ''){
  hero_cpn_font_weight=cpn_data.hero_cpn_font_weight;
  } else {
   hero_cpn_font_weight = "400";
  }
  if(cpn_data.default_text_cpn_dropdown !== '') {
   default_text_cpn_dropdown = cpn_data.default_text_cpn_dropdown;
   }
   if(cpn_data.border_color_cpn_dropdown !== '') {
    border_color_cpn_dropdown = cpn_data.border_color_cpn_dropdown;
    }
  if (cpn_data.dis_sub_toal=="1")
  {
    is_total_details=1;
  }
  if (cpn_txbox_width!='0')
  {
    if (cpn_txbox_width.includes('%'))
    {
      cpn_txt_style=" width:"+cpn_txbox_width +" !important";
    }
    else{
      cpn_txt_style=" width:"+cpn_txbox_width +"px !important";
    }
   
    
  }
  if (cpn_btn_width!='0')
  {
    
    if (cpn_btn_width.includes('%'))
    {
      cpn_btn_style="max-width:"+ cpn_btn_width+" !important; ";
      cpn_btn_style+=" width:"+cpn_btn_width +" !important";
    }
    else{
      cpn_btn_style="max-width:"+ cpn_btn_width+"px !important; ";
      cpn_btn_style+=" width:"+cpn_btn_width +"px !important";
    }
   
   
   p_width=17;
   btn_padding="padding-left:"+ p_width+"px !important;";
    
  }
  set_powerd_text(api_data);
  prepare_popup_html_assign(api_data);
  set_radius(api_data);
  set_text_style(api_data);
  
  set_style_headers(api_data);
  
  set_place_target(api_data);
}

function refresh_discount_values(main_ct_id)
{
  if (shop_domain==='packie-1.myshopify.com')
  {
    if ( $(main_ct_id).find('.discountify_discount_wrap').length>0)
    {
      
        let elem_hide=$('#slidecarthq').find('.footer-row');
        if (prev_subtotal !=$(elem_hide).html())
        {
          prev_subtotal=$(elem_hide).html();
          manage_coupon_storage();
        }
        
    }
  }
}
      
function add_discount_box(main_ct_id,target_id,btn_tg_id,place_type,settimeout)
{
  if ( $(main_ct_id).find(target_id).length>0)
   {

      refresh_discount_values(main_ct_id);
       if ( $(main_ct_id).find('.discountify_discount_wrap').length==0)
       {
             if (btn_tg_id=="")
             {
                if (place_type=='before')
                {
                      $(main_ct_id).find(target_id).before(coupon_body);
                      setTimeout(() => {
                        manage_coupon_storage();
                      }, settimeout);
                }
                else{
                        $(main_ct_id).find(target_id).after(coupon_body);
                        setTimeout(() => {
                          manage_coupon_storage();
                        }, settimeout);
                  }
             }
             else{
               if (place_type=='before')
               {
                  $(main_ct_id).find(target_id).find(btn_tg_id).before(coupon_body);
                    setTimeout(() => {
                      manage_coupon_storage();
                    }, settimeout);
               }
               else{
                      $(main_ct_id).find(target_id).after(btn_tg_id).before(coupon_body);
                      setTimeout(() => {
                        manage_coupon_storage();
                        }, settimeout);
                  }
              
             }
             
       }

   }
 
}

function setup_slidecart_issues_store(main_ct_id,target_id,btn_tg_id,place_type,settimeout)
{
   $(main_ct_id).on('DOMSubtreeModified',function(){
    add_discount_box(main_ct_id,target_id,btn_tg_id,place_type,settimeout);
 });



}


      
function common_drawer_issues_store(main_ct_id,target_id,btn_tg_id,place_type)
{


   $(main_ct_id).on('DOMSubtreeModified',function(){
   
   if ( $(main_ct_id).find(target_id).length>0)
   {
       if ( $(main_ct_id).find('.discountify_discount_wrap').length==0)
       {
             if (btn_tg_id=="")
             {
               if (place_type=='before')
               {
                 $(main_ct_id).find(target_id).before(coupon_body);
                 setTimeout(() => {
                  manage_coupon_storage();
                }, 100);
               }
               else{

                if (shop_domain=='ldu-letsdressup.myshopify.com')
                {
                  if ( $(main_ct_id).find('.discountify_discount_wrap').length==0)
                  {
                   setTimeout(() => {
                      if ( $(main_ct_id).find('.discountify_discount_wrap').length==0)
                      {
                    
                      
                        $(main_ct_id).find(target_id).after(coupon_body);
                        manage_coupon_storage();
                      }
                    
                   }, 500);
                  }
                }
                else{
                  $(main_ct_id).find(target_id).after(coupon_body);
                  setTimeout(() => {
                    manage_coupon_storage();
                  }, 100);
                }
                
               }
              
             }
             else{
               if (place_type=='before')
               {
                 if (shop_domain=='snackamor.myshopify.com')
                 {
                    setTimeout(() => {
                     
                      if ( $(main_ct_id).find('.discountify_discount_wrap').length==0)
                      {
                     
                        $(main_ct_id).find(target_id).find(btn_tg_id).before(coupon_body);
                      }
                     
                    }, 1000);
                 }
                 else{
                  $(main_ct_id).find(target_id).find(btn_tg_id).before(coupon_body);
                  setTimeout(() => {
                    manage_coupon_storage();
                  }, 100);
                 }
                
               }
               else{
                 $(main_ct_id).find(target_id).after(btn_tg_id).before(coupon_body);
                 setTimeout(() => {
                  manage_coupon_storage();
                }, 100);
               }
              
             }
             
       }

   }
 
  
 });



}

       



       function zeropiu_store(api_data)
       {
        
         attrCartDraw.push('.actions,.btn-actions');
       //  $('#dropdown-cart').find(".btn-checkout").prop("onclick", null).off('click');     
           $('body').on('mousedown',".btn-checkout", function (e) {
             e.preventDefault();
             process_to_checkout(e);
           });

           $('#dropdown-cart').on('DOMSubtreeModified',function(){
        
           if ( $('#dropdown-cart').find('.btn-actions').length>0)
           {
               if ( $('#dropdown-cart').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#dropdown-cart').find('.btn-actions')[0]).before(coupon_body);
                
               //  $('#dropdown-cart').find(".btn-checkout").prop("onclick", null).off('click');    
                 $('#dropdown-cart').find(".btn-checkout").on('click',function(){
                  
                   e.preventDefault();
                   process_to_checkout(e);
                 });
                 $('#dropdown-cart').find(".btn-checkout").on('mousedown',function(){
                  
                   e.preventDefault();
                   process_to_checkout(e);
                 })
                // $('#dropdown-cart').find('.btn-checkout').attr("href", "#");
                
               }
             
               
           }
          
         });
       }
      
       function mamilie_store_cart(api_data)
       {
       
           var re_clas_name='#sidebar-cart';
           $('#sidebar-cart').on('DOMSubtreeModified',function(){
           
             if ( $(re_clas_name).find('.Cart__Checkout').length>0)
           {
               if ( $(re_clas_name).find('.discountify_discount_wrap').length==0)
               {
                 $( $(re_clas_name).find('.Cart__Checkout')[0]).before(coupon_body);
                
                 $('body').on('mousedown',".Cart__Checkout", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
           });

           $('#shopify-section-cart-template').on('DOMSubtreeModified',function(){
        
             if ( $('#shopify-section-cart-template').find("[name='checkout']").length>0)
             {
                 if (  $('#shopify-section-cart-template').find('.discountify_discount_wrap').length==0)
                 {
                   $( $('#shopify-section-cart-template').find("[name='checkout']")[0]).before(coupon_body);
                   
                   $('body').on('mousedown',"[name='checkout']", function (e) {
                     e.preventDefault();
                     process_to_checkout(e);
                   });
                 }
               
                 
             }
            
           });
          
       }

       function acuadot_store(api_data)
       {
        
        
           $('#CartDrawer').on('DOMSubtreeModified',function(){
        
           if ( $('#CartDrawer').find("[name='checkout']").length>0)
           {
               if (  $('#CartDrawer').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#CartDrawer').find("[name='checkout']")[0]).before(coupon_body);
                 
                 $('body').on('mousedown',"[name='checkout']", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
          
         });
       }

       function artemis_store(api_data)
       {
        
        
           $('#CartDrawer').on('DOMSubtreeModified',function(){
        
           if ( $('#CartDrawer').find("[name='checkout']").length>0)
           {
               if (  $('#CartDrawer').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#CartDrawer').find("[name='checkout']")[0]).before(coupon_body);
                 
                 $('body').on('mousedown',"[name='checkout']", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
          
         });
       }
       function foreverkidz_store(api_data)
       {
        
        
           $('#CartDrawer').on('DOMSubtreeModified',function(){
        
           if ( $('#CartDrawer').find("[name='checkout']").length>0)
           {
               if (  $('#CartDrawer').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#CartDrawer').find("[name='checkout']")[0]).before(coupon_body);
                 
                 $('body').on('mousedown',"[name='checkout']", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
          
         });
       }
       function andrea_morando_store(api_data)
       {
        
        
           $('#CartDrawer').on('DOMSubtreeModified',function(){
        
           if ( $('#CartDrawer').find("[name='checkout']").length>0)
           {
               if (  $('#CartDrawer').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#CartDrawer').find("[name='checkout']")[0]).before(coupon_body);
                 
                 $('body').on('mousedown',"[name='checkout']", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
          
         });
       }
     
       function relish_store(api_data)
       {
           var re_clas_name='.Cart.Drawer__Content';
           $('#sidebar-cart').on('DOMSubtreeModified',function(){
          
             if ( $(re_clas_name).find('.Cart__Checkout').length>0)
           {
               if ( $(re_clas_name).find('.discountify_discount_wrap').length==0)
               {
                 $( $(re_clas_name).find('.Cart__Checkout')[0]).before(coupon_body);
                
                 relish_scroll();
                 $('body').on('mousedown',".Cart__Checkout", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
                 });
               }
             
               
           }
           });
          
       }

       function unicoar_store(api_data)
       {
           var re_clas_name='.Cart.Drawer__Content';
           $('#mini-cart').on('DOMSubtreeModified',function(){
          
             if ( $('#mini-cart').find('.ajax-cart__buttons').length>0)
           {
             

             if ( $('.cart-page').find('.discountify_discount_wrap').length==0)
             {
               $( $('.cart-page').find('.ajax-cart__buttons')[0]).before(coupon_body);

             }

               if ( $('#mini-cart').find('.discountify_discount_wrap').length==0)
               {
                 $( $('#mini-cart').find('.ajax-cart__buttons')[0]).before(coupon_body);
                
                 
               }
               $('body').on('mousedown',".ajax-cart__button-submit", function (e) {
                 e.preventDefault();
                 process_to_checkout(e);
               });

               
           }
           });
          
       }
       
       
       function eolallc_store_cart(api_data)
       {
        
           $('#ajaxifyCart').on('DOMSubtreeModified',function(){

             setTimeout(() => {
               if ( $(this).find("[name='checkout']").length>0)
               {
                   if ( $(this).find('.discountify_discount_wrap').length==0)
                   {
                                           
                     $( $(this).find("[name='checkout']")[0]).before(coupon_body);
                     if (eolallc_store_height_added==0)
                     {
                       $('#ajaxifyCart').height($('#ajaxifyCart').height()+270);
                       $('#ajaxifyDrawer').height( $('#ajaxifyCart').height());
                         
                         $('#ajaxifyDrawer').find('.cart-row').last().css('max-height','800px');
                         $('#ajaxifyDrawer').find('.cart-row').last().css('height','800px')
                         eolallc_store_height_added=1;
                      
                     }
                    
                    
                     $('body').on('mousedown',"[name='checkout']", function (e) {
                       e.preventDefault();
                       process_to_checkout(e);
                     });
                   }
                 
                   
               }
               
             }, 500);
             
            
           });
          
       }
      
       function valentina_rio_store_cart(api_data)
       {
        
         var re_clas_name='#CartDrawer';
         $('#CartDrawer').on('DOMSubtreeModified',function(){
        
           if ( $(re_clas_name).find('.cart__checkout').length>0)
         {
             if ( $(re_clas_name).find('.discountify_discount_wrap').length==0)
             {
               $( $(re_clas_name).find('.cart__checkout')[0]).before(coupon_body);
              
               $('body').on('mousedown',".cart__checkout", function (e) {
                 e.preventDefault();
                 process_to_checkout(e);
               });
             }
           
             
         }
         });
        
          
       }
       
     
       function rarefood_store_minicart()
       {
           var re_clas_name='#monster-upsell-cart';
           $('#monster-upsell-cart').on('DOMSubtreeModified',function(){
           
             if ( $(re_clas_name).find('.mu-checkout-btn').length>0)
           {
               if ( $(re_clas_name).find('.discountify_discount_wrap').length==0)
               {
                 $( $(re_clas_name).find('.mu-checkout-btn')[0]).before(coupon_body);
                
                 $( $(re_clas_name).find('.mu-checkout-btn')).on('click',function(){
                   e.preventDefault();
                   process_to_checkout(e);
                 })
                   
               }
             
               
           }
           });
          
       }

      
         function applyCopuonBasedOnCondtionItems(is_direct_validation,discnt_cookie)
         {
            
            $.getJSON('/cart.js', function(cart) { 
              if (cart.items.length>0)
              {
                  if (is_direct_validation=='on')
                  {
                    direct_validation(discnt_cookie.couponData.title,false,true);
                    return;
                  }
                  setPriceRules();
              }
              else{
                localStorage.removeItem("dscnt_cookie");
              }
            });
         }
         function setPriceRules(discnt_cookie)
         {
          var api_path =http_dom+urlPath +'/ajax';
          var shop_data = {shop_domain: Shopify.shop };
            $.getJSON(api_path+"/get_pricerules.php?priceruleid="+discnt_cookie.couponID,shop_data, function(cpn_data) { 
              if(cpn_data){ 
              $.each(cpn_data, function(i, v) {
                if(cpn_data[i].id == discnt_cookie.couponID){
                    setTimeout(function(){ calculate_discounts(cpn_data[i],'',0,1); }, 500);
                  }
              });
              }
            });
         }
         function getCookie(cname) {
          let name = cname + "=";
          let decodedCookie ='';
          try{
            decodedCookie= decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
          }
          catch(ex)
          {

          }
          
        
          return "";
        }
       function manage_coupon_storage(){
        if (shop_domain=='tatasimplybetter.myshopify.com')
        {
          if (page != 'cart')
          {
            if ($('.cusapppromo').length==0)
            {
              $('.discount_availibility').before('<div class="cusapppromo">Apply Promo Code</div>');
            }
          }
      
         
        }
        if ( page=='checkout')
        {
          return;
         }
         set_auto_discount_code_stoarge();
         var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie")); 
         
          if(discnt_cookie !== null){ 
              if(Shopify.shop == discnt_cookie.shop ){  
                if(discnt_cookie.couponID){
                    applyCopuonBasedOnCondtionItems(is_direct_validation,discnt_cookie)
                  }
              }  
           }
          
           else{
             if ((shop_domain !='xaestheticnation.myshopify.com'))
             {
              /* $.getJSON('/cart.js', function(cart) { 
                 if (cart.items.length>0)
                  {
                      revlaidate_coupon_code('+',true);
                  }
              
              });*/
             }
             $('.discountify_discount_wrap').find('.lds-dual-ring').hide();
           }
           
          
       }


function iselemetVisible(element) {
 const $element = $(element);
 return (
     $element.css('display') !== 'none'
     && $element.css('visibility') !== 'hidden'
     && $element.css('opacity') !== 0
 );
}
function set_place_target(api_data)
{
  
  let  app_target='';
 if(page =='cart'){
   voila_div_align="text-align:right !important;"
   app_target = $($('[type=submit][name=checkout]')[$('[type=submit][name=checkout]').length - 1]);
   if ($('[type=submit][name=checkout]').length==0)
   {
     app_target =$($('[name=checkout]')[$('[name=checkout]').length - 1]);
   }
   if ( ($('[type=submit][name=checkout]').length==0) &&($('[name=checkout]').length ==0))
   {
       app_target = $($('.checkout__button')[$('.checkout__button').length - 1]);
   }
   if(Shopify.shop == "shingora.myshopify.com") { 
     app_target=$($('#checkout')[0]);
      app_target.before(coupon_body); 
    
   }
     
   else if (shop_domain=='duroflex-world.myshopify.com')
   {
     var mar_duro='';
     
     if($( window ).width() > 1100)
     {
       mar_duro='margin-top: -140px;';
     }
       voila_div_align="text-align:right !important;"+mar_duro;
       app_target =   app_target = $( $('.cart-checkout')[0]);
       
   }
  
 
  
 } else {
   app_target = $($('[type=submit][name=checkout]')[$('[type=submit][name=checkout]').length - 1]);
   if ($('[type=submit][name=checkout]').length==0)
   {
       app_target = $($('.checkout__button')[$('.checkout__button').length - 1]);
   }
   crtdwr_class = " discountify_crtdwer";
 }
 if(Shopify.shop == "shingora.myshopify.com") { 
   app_target='';
   if (page =='cart')
   {
    app_target=$($('#checkout')[0]);
    app_target.before(coupon_body); 
   }
  
 }
 if(Shopify.shop == "saltyjewels.myshopify.com") { 
  app_target='';
  if (page !='cart')
  {
   app_target=$($('#checkout2')[0]);
   app_target.before(coupon_body); 
  }
 
}

 
 
 try{
   app_target_parent = app_target.parent();
   $(app_target_parent.children()).each(function() {
       if($(this).attr('name') && $(this).attr('name').indexOf('update') !== -1){
         app_target = $(this);
       }
   });
 }
 catch(err)
 {

 }
 
 
}
function set_style_headers(api_data)
{
 
  if ( page=='checkout')
  {
    $('head').append(`<style type="text/css">
                        .discountify_pop_footer,.discountify_pop_body{width: 97% !important;}
                        .check_vl {padding:1px !important}
                        .check_label_vl .check_vl:after { left:20% !important}
                        .discountify_discount_wrap {padding:0px !important}
                        </style>`);
   }
 $('head').append(`<style type="text/css">
 .ms_vl_drp_cls{clear:both;box-sizing:border-box;min-width:250px;}
 .ms_vl_rd_change{height: auto !important;}
 .radio_cpn{font-weight: 600;font-size: 16px;color:${hero_cpn_txt_clr};
 text-transform: uppercase;letter-spacing: inherit;} 
 .dscnt_availability{'+css_include +'}
 .def_radius{border-radius:2px !important}
 .discountify_discount_wrap .discountify_coupon .show_availablity:hover {${cpn_avl_hov_txtcolor}}
 .discountify_discount_wrap .discountify_coupon .show_availablity {${css_include}}
 .coupon_check:checked + span + span {color: ${pop_cpn_sel_color} !important;border-color: ${pop_cpn_sel_color} !important;}
 .pwdby_holder{display: flex;float:right;padding:10px 10px 0;font-weight:400;}
 .pwdby_holder span{font-size:12px;padding-left:3px;line-height:normal;color:#3a3a3a !important;}
 .desktop_pwd{display:flex;}.mobile_pwd{display:none;}.pwdlink{color:#777 !important; text-decoration:none !important;}
 .pwdlink:hover{color:#EE2176 !important;}.discountify_manual .dscnt_manual_applybtn{padding:5px 16px 3px !important;}
 .progload{display:inline-block !important}
 .main_cpn_hide{display:none !important}
 .discountify_status_msg{margin-top:10px !important;margin-bottom:10px !important;}
 .cart__ctas{display:inline-block !important;width:100% !important}
 .cart__ctas .discountify_discount_wrap{line-height:18px !important}
 </style>`);

 $('head').append('<style type="text/css">@media only screen and (max-width:649px) {.desktop_pwd{display:none;}.mobile_pwd{display:flex;align-items: center;justify-content: center;}.discountify_modal .discountify_pop_footer {'+footer_height+' !important;}.pwdby_holder{float:none;}}</style>');
 if (shop_domain == "octics-fashion.myshopify.com") { 
   $('head').append(`<style type="text/css">.ms-vl-drp_sel{background-image:none !important;width:100% !important} 
   .discountify_aply_voucher{margin:0px 0px !important};
   .discountify_manual{width:100% !important}
   .discountify_manual .dscnt_manual_btnwrap, .discountify_manual .dscnt_manual_fldwrap {
     -webkit-flex: none !important;
     flex: none !important;
 }
 .btn.dscnt_manual_applybtn.discountify_aply_voucher:hover{
   background-color: #fff !important;
 }
 .btn:hover{
   background-color: #fff !important;
 }
 .#side_cart .footer{
   height:300px !important;
 }
   </style>`);
 }
 if (shop_domain=='vw-vanity-wagon.myshopify.com')
   {
     $('head').append(`<style type="text/css">.dis_tot{font-family:Roboto, sans-serif !important;} 
     .spn_dis_dt{font-family:Questrial, sans-serif}.spn_total_dt{font-family:Questrial, sans-serif}
     .dscnt_manual_fldwrap{ width:320px !important;max-width:100% !important} .dscnt_manual_btnwrap{width:80px !important;max-width:80px !important}</style>`);
   }

   if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
   {
    $('head').append(`<style type="text/css">
    .dscnt_manual_fldwrap,.dscnt_manual_btnwrap,.cpn_svg {display:inline-block !important}
    .discountify_modal {z-index: 9999999999 !important;}
    .discountify_manual,.discount_availibility,.discountify_status_msg{text-align:center !important}
    .dscnt_manual_field {text-align:left !important} 
    .discountify_txtbox_title{display:none !important}
    </style>`);
   }
   if (shop_domain=='ldu-letsdressup.myshopify.com')
   {
    $('head').append(`<style type="text/css">
    .dscnt_manual_fldwrap,.dscnt_manual_btnwrap,.cpn_svg {display:inline-block !important}
    .discountify_modal {z-index: 9999999999 !important;}
    .discountify_manual,.discount_availibility,.discountify_status_msg{text-align:center !important}
    .dscnt_manual_field {text-align:left !important} 
    .discountify_txtbox_title{display:none !important}
    </style>`);
   }
   if (shop_domain=='foreverkidz1.myshopify.com')
   {
     /*$('head').append(`<style type="text/css">
     .discountify_modal{z-index:9999999999 !important;}
     </style>`);*/
   }
  
 if (shop_domain=='mondokoro.myshopify.com')
   {
     $('head').append(`<style type="text/css"> .discountify_manual_wrap{width:100% !important}</style>`);
   }
   if (shop_domain=='cptoothbrush.myshopify.com')
   {
     $('head').append(`<style type="text/css"> .check_vl {display:inline-block !important}.progload{display:inline-block !important}</style>`);
   }
 if (shop_domain=='club-nouveau.myshopify.com')
   {
        if (page !='cart')
      {
         respons_cls='at_wdth';
           
       }
   }
   if (shop_domain=='nunmun.myshopify.com')
   {
     $('head').append(`<style type="text/css">.discountify_aply_voucher{line-height:0px !important} .apply_voucher_btn{line-height:0px !important} 
     .discountify_aply_voucher:{background-color:#111111!important}
                                             .discountify_aply_voucher:hover{background-color:#727272 !important}</style>`);
   }
   else if (shop_domain=='noorbyjyoti.myshopify.com')
   {
     $('head').append(`<style type="text/css">.progload{border: 3px solid red !important;}</style>`);
   }
   else if (shop_domain=='rare-food-shop.myshopify.com')
   {
     $('head').append(`<style type="text/css"> .discountify_manual .dscnt_manual_applybtn{background-color:rgb(50,50,50) !important}
     .progload{border-width:3px !important} .dscnt_availability svg{ display:inline !important;vertical-align !important}</style> `);
   }
   else if (shop_domain=='apextrimmer.myshopify.com')
   {
     $('head').append('<style type="text/css"> .cpn_tag_close{color:#f50909 !important} .radio_cpn{color:white !important}</style>');
   }
   else if (shop_domain=='bombay-shaving.myshopify.com')
   {
     $('head').append('<style type="text/css"> .dscnt_manual_applybtn{margin:0px 0px !important}.ms_vl_drp_cls{display:inline-block !important;text-align:right !important;}</style>');
   }
   else if (shop_domain=='julz-shop561.myshopify.com')
   {
     $('head').append('<style type="text/css"> .ms_vl_drp_cls{float:right !important;}</style>');
   }

   else if (shop_domain=='bsc-women.myshopify.com')
   {
     $('head').append('<style type="text/css"> .check_label_vl input {opacity:2 !important}</style>');
   }
   else if (shop_domain=='salesify-demo.myshopify.com')
   {
     $('head').append('<style type="text/css"> .radio_cpn{margin-bottom:10px !important}</style>');
   }
   else if (shop_domain=='ldu-letsdressup.myshopify.com')
   {
      if($(window).width()<500)
      {
        $('head').append(`<style type="text/css"> .coupon_description>p{margin:0px 0px !important}
        .discountify_modal .discountify_pop_body {
          max-height: 580px !important;
      }
        </style>`);
      }
     
   }
   else if (fourth_stores.includes(shop_domain))
   {
     $('head').append(`<style type="text/css">
      .radio_cpn{margin-bottom:12px !important} .discountify_subtotal_sec{padding-top:12px !important}</style>`);
      if ($(window).width()<700)
      {
       $('head').append(`<style type="text/css">
         .discountify_manual_wrap {
            display: inline-block;
               }</style>`);
       
      }
     
   }
   
   
 

  if (left_align_shops.includes(Shopify.shop)==true)
  {
      text_lign_desc='left';
  }
 if ((shop_domain=='crystallineme-uk.myshopify.com'))
{
      text_lign_desc='center';
  }
if (is_main_body_right=='on')
{
main_body_right='text-align:right;';
textbox_width='width:65% !important;'
if (shop_domain=='salesify-demo.myshopify.com')
{
textbox_width='width:190px !important;'
}
if (shop_domain=='rad-mad-bad.myshopify.com')
{
textbox_width='width:190px !important;'
}
}

if (textbox_width=='')
{
if (cpn_txt_style=='')
{
cpn_txt_style=" width:182px !important;"
}
if (shop_domain==='triyah.myshopify.com')
{
 // cpn_txt_style=" width:132px !important;";
}
textbox_width=cpn_txt_style;
btn_pding_top_style='padding-top:2.9px !important;';
}
if (shop_domain=='slightwordshome.myshopify.com')
{
  btn_pding_top_style='padding-top:10.9px !important;';
}

if (shop_domain=='isindia.myshopify.com')
{
txt_box_height="height:42px !important;";
main_padding_top="padding-top:0px !important;";
}
if ((shop_domain=='tvcool.myshopify.com')||(shop_domain=='viralim.myshopify.com'))
{
btn_height="height:44px !important;";

}
if ((shop_domain=='crystallineme-uk.myshopify.com'))
{
    $('head').append(`<style type="text/css"> 
    .discountify_discount_wrap{margin-left:-12px !important;padding-top:0px !important}
    .discount_availibility{ padding-left:10px !important}
    .discountify_status_msg{padding-left:10px !important}
    .discountify_status{padding-left:10px !important}
    </style>`);

}

set_total_styles();
}
function set_total_styles()
{
  var font_weight='600';
    var totl_width= $('.discountify_manual').width();
   var div_tbl_tot_max_width='100px !important;'
           var div_tbl_tot_width=totl_width ;
  var t_left_txt_color='#777777 !important';
            var t_right_txt_color='#777777 !important';
            var div_tbl_tot_min_width='min-width:280px !important;';
            if(shop_domain=='jaipurkurti-com.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#3a517b !important';
              font_weight=500;
            }
            var cpn_sel_color_style='';
            if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
              cpn_sel_color_style='color:#072a40 !important;';
            }
            if (shop_domain=='ldu-letsdressup.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
              cpn_sel_color_style='color:#072a40 !important;';
            }
            if (shop_domain=='the-amyra-store.myshopify.com')
            {
              if ($(window).width()<500)
              {
                div_tbl_tot_min_width='';
              }
            
            }
            var left_tot_font_size="font-size:18px !important;";
            var right_tot_font_size="font-size:18px !important;";
            var right_strike_tot_font_size="font-size:12px !important;";
            if (shop_domain=='livspace-store-sgp.myshopify.com')
            {
              left_tot_font_size="font-size:24px !important;";
              right_tot_font_size="font-size:24px !important;";
              right_strike_tot_font_size="font-size:18px !important;";
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
            }
            if (shop_domain=='fynnushop.myshopify.com')
            {
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_width="100% !important;";
            }
            if (shop_domain=='fancy-fluff-india.myshopify.com')
            {
              if ($(window).width() <500)
              {
                div_tbl_tot_max_width="100% !important;";
                div_tbl_tot_width="100% !important;";
                div_tbl_tot_min_width='min-width:90% !important;'
              }
              
            }

            if (shop_domain=='skinbae-in.myshopify.com')
            {
              if ($(window).width() <500)
              {
                div_tbl_tot_max_width="100% !important;";
                div_tbl_tot_width="100% !important;";
                div_tbl_tot_min_width='min-width:90% !important;'
              }
              
            }
            if (shop_domain=='bombay-shaving.myshopify.com')
            {
              $('.dscnt_manual_field').val(ori_cpn_title);
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_width="100% !important;";
              div_tbl_tot_min_width='min-width:90% !important;';
              left_tot_font_size="font-size:14px !important;";
              right_tot_font_size="font-size:14px !important;";
              if (page=='cart')
              {
                if ($(window).width()>500)
                {
                  div_tbl_tot_max_width="35% !important;";
                  div_tbl_tot_min_width='min-width:35% !important;';

                }
              }
             
             
             
              
            }
            if (shop_domain=='crystallineme-de.myshopify.com')
            {
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_min_width='min-width:100% !important;';
              left_tot_font_size="14px";
            }
           

            if (entire_gloabal_api_data.discountify_coupon.t_right_txt_color !='')
            {
              t_right_txt_color=entire_gloabal_api_data.discountify_coupon.t_right_txt_color;
            }
            if (entire_gloabal_api_data.discountify_coupon.t_left_txt_color !='')
            {
              t_left_txt_color=entire_gloabal_api_data.discountify_coupon.t_left_txt_color;
            }
            if (entire_gloabal_api_data.discountify_coupon.right_strike_tot_font_size !='')
            {
              right_strike_tot_font_size=entire_gloabal_api_data.discountify_coupon.right_strike_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.right_tot_font_size !='')
            {
              right_tot_font_size=entire_gloabal_api_data.discountify_coupon.right_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.left_tot_font_size !='')
            {
              left_tot_font_size=entire_gloabal_api_data.discountify_coupon.left_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.div_tbl_tot_min_width !='')
            {
              div_tbl_tot_min_width=entire_gloabal_api_data.discountify_coupon.div_tbl_tot_min_width;
            }
            if (entire_gloabal_api_data.discountify_coupon.div_tbl_tot_max_width !='')
            {
              div_tbl_tot_max_width=entire_gloabal_api_data.discountify_coupon.div_tbl_tot_max_width;
            }
            let total_left_width='25%';
            let total_right_width='75%';
            if (shop_domain==='9twentyfivej.myshopify.com'){
               total_left_width='55%';
               total_right_width='45%';
              if ($(window).width()<800)
              {
                total_left_width='58%';
                total_right_width='42%';
              }
            }
       
            if (shop_domain==='identiti-com.myshopify.com'){
              font_weight='normal';

            }
            let left_disc_font_weight=font_weight;
            let right_disc_font_weight=font_weight;
            let left_total_font_weight=font_weight;
            let right_total_font_weight=font_weight;
            if (shop_domain=='packie-1.myshopify.com')
            {
              left_disc_font_weight="normal";
              right_disc_font_weight="normal";
              if ($(window).width()<800)
              {
                right_tot_font_size="font-size:14px;";
                left_tot_font_size="font-size:14px;";
               
              }
              
            }
            let next_linse_dsictont='<br/>';
            let right_discount_styles=`padding-top: 7px;text-align:right;font-weight:${right_disc_font_weight};
                                      ${right_tot_font_size}
                                      width:35% !important;
                                      float:left;color:${t_right_txt_color} `;
            
            let discount_in_same_line_stores=['packie-1.myshopify.com'];
            
            if (discount_in_same_line_stores.includes(shop_domain))
            {
              next_linse_dsictont="";
            }

            let totls_styles=
            `    
            .div_tbl_tot{
              max-width:${div_tbl_tot_max_width}
              ${div_tbl_tot_min_width}
              text-align:left;
              display: inline-block;
              width:${div_tbl_tot_width}
            }
            .dis_tot_main{
              font-weight:${left_disc_font_weight};
              ${left_tot_font_size}
              display: inline-block;width:65% !important;
              float:left;color:${t_left_txt_color}
            }
            .cpn_dcnt_price{
              ${cpn_sel_color_style}
              background-color: rgba(113, 113, 113, .11);
              padding: 4px;border-radius: 4px;line-height: 20px;
              margin-left:0px !important
            }
            .cpn_tag_close{font-weight:${left_disc_font_weight};font-size:12px !important;cursor:pointer}
            .spn_dis_dt{${right_discount_styles}}
            .second_line_text
            {
              padding-top: 7px;
              font-weight:${font_weight};
              ${left_tot_font_size}
              text-align:left;clear:both;width:${total_left_width} !important;
              float:left;
              color:${t_left_txt_color}
            }
            .spn_total_dt{padding-top: 7px;text-align:right;
              font-weight:${font_weight};
              font-size:18px !important;width:${total_right_width} !important;
              float:left;
              color:${t_right_txt_color}
          }
            .spn_fin_subtot{${right_strike_tot_font_size}text-decoration: line-through;
            font-weight:${font_weight}}
             .spn_fin_tot{font-weight:${font_weight};${right_tot_font_size}}
            `;

            $('head').append(`
            <style>
            ${totls_styles}
           </style>`);
}
function set_powerd_text(api_data)
{
 
 if (check_powered_by(api_data)==true) {
   footer_height = "height:100px";
   poweredby_html ="<div class=\"pwdby_holder desktop_pwd\"><img src=\"https://cdn.shopify.com/s/files/applications/c34ab93fb0cc992778a98364f29be2c1_200x200.png?1616328977\" width=\"14px\" height=\"14px\"><span style=\"\"><a target=\"_blank\" href=\"https://apps.shopify.com/available-discount-coupon-list-on-cart-page\" class=\"pwdlink\">Powered by Voila</a></span></div>";
   poweredby_html2 = "<div class=\"pwdby_holder mobile_pwd\"><img src=\"https://cdn.shopify.com/s/files/applications/c34ab93fb0cc992778a98364f29be2c1_200x200.png?1616328977\" width=\"14px\" height=\"14px\"><span style=\"\"><a target=\"_blank\" href=\"https://apps.shopify.com/available-discount-coupon-list-on-cart-page\" class=\"pwdlink\">Powered by Voila</a></span></div>";
 }
}
function set_text_style(api_data)
{
 if(cpn_style_arr){
   if(cpn_style_arr.includes("BOLD")){css_include += "font-weight:bold !important;"}
   if(cpn_style_arr.includes("400")){css_include += "font-weight:400 !important;"}
   if(cpn_style_arr.includes("600")){css_include += "font-weight:600 !important;"}
   if(cpn_style_arr.includes("800")){css_include += "font-weight:800 !important;"}
   if(cpn_style_arr.includes("ITALIC")){ css_include +="font-style: italic !important;"}
   if(cpn_style_arr.includes("UNDERLINE")==true)
     { 
       css_include +="text-decoration: underline !important;"
     }
   else{
     css_include +="text-decoration: none !important;"
   }
}
else{
 css_include +="text-decoration: none !important;"
}
}
function set_radius(api_data)
{
 if(is_radius)
 {
   radius_text = "intbr brlinpt";
   radius_btn = "intbr brrinpt";
   radius_popup="intbr";
 }
 else{
  
       if(Shopify.shop == "rare-food-shop.myshopify.com") 
       {
         txt_radius_text_border = "border-radius:3px !important;";
         btn_radius_btn = "border-radius:3px !important;";
       }
       else{
             if(Shopify.shop == "salesify-demo.myshopify.com") 
             {
             radius_text = "def_radius";
             radius_btn = "def_radius";
             }
       }
 }
}
function check_powered_by(api_data){
 if (api_data['charge_details'].plan_id==6)
 {
   return true;
 }
}
function prepare_cpn_cnt_link(api_data)
{
 if(coupon_count > 0)
 {
     var discountify_coupon_html='';
     var status_msg_html='';
     if (fourth_stores.includes(shop_domain))
     {
      // status_msg_html += "<div class=\"discountify_status_msg\" style='display:none;"+applied_msg_style+"'>"+ discnt_applied_msg +"</div>";
     }
     discountify_coupon_html +="<div class=\"discountify_coupon\">"+status_msg_html+"<div class=\"discount_availibility\">";
    
    if(avl_status == "on")
    { 
       if(coupon_count > 0 && coupon_count == 1) { 
            replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
            $(".coupon_check").prop("checked", true);
          
       } else { 
            replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
       }
          
       if(check_plan(api_data)==true)
        {
            if ((shop_domain=='xaestheticnation.myshopify.com'))
            {
             var ae_html='<span style="color:#ff6600">'+coupon_count + ' COUPONS </span>' +
                        '<span style="color:black">AVAILABLE</span>' ;
                        discountify_coupon_html +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"
              +apply_logo+"<span class=\"show_availablity\" style="+avl_txtcolor+avl_txtsize+">"
              +ae_html+"</span></a>";

            }
           else if (fourth_stores.includes(shop_domain))
            {
              var sp_fou_string="Get them now!"
               var sp_arr_lin_text= replace_avail.split(sp_fou_string);
               if (sp_arr_lin_text.length==2)
               {
                 var ae_html=`<span style="color:black;${avl_txtsize}">${sp_arr_lin_text[0]}</span>
                               <span style="text-decoration-thickness: 2px !important;text-decoration:underline;text-underline-offset: 0.35em;${avl_txtcolor}${avl_txtsize}">${sp_fou_string}</span>`;
                 discountify_coupon_html +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"
                   +apply_logo+"<span class=\"show_availablity\" >"
                   +ae_html+"</span></a>";

               }
               else{
                 discountify_coupon_html +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"+apply_logo+"<span class=\"show_availablity\" style="+avl_txtcolor+avl_txtsize+">"+replace_avail+"</span></a>";
               }
            

            }
            else{
              discountify_coupon_html +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"+apply_logo+"<span class=\"show_availablity\" style="+avl_txtcolor+avl_txtsize+">"+replace_avail+"</span></a>";

            }
            
          }
    }
   
    if (is_popup_link_position_top=='')
    {
      discountify_coupon_html +="</div></div><div style='"+dis_txt_box_btn +"' class='discountify_divider'></div>";
        coupon_body+=discountify_coupon_html;
    }
    else{
      coupon_body=discountify_coupon_html+coupon_body;
    }

 }

}

function prepare_drop_down_cpns(api_data,txtbox_status)
{
 var err_html='';
 if (txtbox_status!='on')
 {
   err_html=` <div style="display:none;" class="inln_msg"></div>`;
 }

 if (api_data.drp_cpns.length>0)
 {
   var opti_lts=`<option value='0'>${default_text_cpn_dropdown}</option>`;
   for(i=0;i<api_data.drp_cpns.length;i++)
   {
     opti_lts+=`<option value='${api_data.drp_cpns[i]['dropdown_cpn_code']}'>${api_data.drp_cpns[i]['dropdown_cpn_text']}</option>`;
   }
   var border_style_cpn_dropdown ="border:1px solid "+ border_color_cpn_dropdown +" !important;";
   var dpn_html=`<div  class="ms_vl_drp_cls" style="">
   <select class='ms-vl-drp_sel' style="min-width:250px !important;${border_style_cpn_dropdown}"  >
   ${opti_lts}
   </select></div>`;
   return dpn_html+err_html;
   
 }
 return '';
     
}
function preparer_target_body(api_data)
{
  let app_target=null;
  if (page=='checkout')
  {
    $('.field__input-btn-wrapper').after(coupon_body);
    $('.discountify_manual').hide();
    taget_found=true;
  }
 if (shop_domain=='artemis-aparels.myshopify.com')
 {
  applied_msg_style='color:#6716a1;font-weight:bold;'
 }
 if (shop_domain=='livspace-store-sgp.myshopify.com')
 {
  applied_msg_style='color:#e03b58;font-weight:bold;'
 }
 if (shop_domain=='masori.myshopify.com')
 {
  applied_msg_style='color:#54c63a;font-weight:bold;'
 }
 coupon_body += "<div class=\"discountify_status_msg\" style='display:none;"+applied_msg_style+"'>"+ discnt_applied_msg +"</div>";
 /*if (fourth_stores.includes(shop_domain)==false)
 {
   coupon_body += "<div class=\"discountify_status_msg\" style='display:none;"+applied_msg_style+"'>"+ discnt_applied_msg +"</div>";
 }
 */
 //coupon_body+=pop_loader_img;

 if (fourth_stores.includes(shop_domain))
 {
   coupon_body +="<div class=\"discountify_subtotal_sec\"></div>";
 }
    coupon_body +="<div class=\"discountify_status\"></div>"+
    
    "</div>";
    
  
  //   For Tangle Artidtry Starts
  //  && Shopify.shop == "houseofmakeup-bisou.myshopify.com"
  if(Shopify.shop == "shingora.myshopify.com") { 
    app_target='';
    if (page =='cart')
    {
     app_target=$($('#checkout')[0]);
     app_target.before(coupon_body); 
    }
   
  }
 else if(Shopify.shop == "tangle-artistry.myshopify.com") { 
        $("body").find(".ms-button-new").before(coupon_body);
    }
    else  if(Shopify.shop == "hind-kraft.myshopify.com") { 
        $("body").find(".textarea-button-cart").parent().before(coupon_body);
        $(".discountify_discount_wrap").css("text-align", "right");
    }
    else if(Shopify.shop == "farziengineers.myshopify.com") { 
      app_target.before(coupon_body); 
      if (page =='cart')
        {
            $(".dscnt_manual_fldwrap").css("width", "65%");
            $(".dscnt_manual_btnwrap").css("width", "35%");
            $(".dscnt_manual_applybtn").css("width", "78%");
            
        }
         if (page !='cart')
        {
            $(".dscnt_manual_fldwrap").css("width", "65%");
            $(".dscnt_manual_btnwrap").css("width", "35%");
            $(".dscnt_manual_applybtn").css("width", "90%");
            
        }
      
      $("body").find(".checkout").before(coupon_body);
    }
     else  if(Shopify.shop == "fashionaccessorieslife.myshopify.com") { 
        $(".actions").find(".btn-checkout").each(function(){
            $(this).before(coupon_body);
            $(".dscnt_manual_fldwrap").css("width", "65%");
            $(".dscnt_manual_btnwrap").css("width", "35%");
            $(".dscnt_manual_applybtn").css("width", "90%");
           $('.discountify_divider').hide();
        });
         app_target.before(coupon_body); 
        $(".discountify_discount_wrap").css("text-align", "right");
    }
    else if(Shopify.shop == "bombay-shaving.myshopify.com") { 
    
   
     for(var kl=0;kl<$('div.ms-voila-cart').length;kl++)
     {
       if( iselemetVisible( $('div.ms-voila-cart')[kl]))
       {
         $($('div.ms-voila-cart')[kl]).before(coupon_body);
       }
     }
     $('.cart__footer').find("[name='checkout']").before(coupon_body);
     
     $('.cart-update').before(coupon_body);
     common_drawer_issues_store('.shopify-section','.Cart__Taxes','','after');
     if ($('.cart__footer').find("[name='checkout']").length>0)
     {
       $('.ms_vl_drp_cls').css('display', 'inline-block !important');
       $('.ms_vl_drp_cls').css('text-align', 'right !important');
     }
     taget_found=true;
   }
      else if(Shopify.shop == "saltyjewels.myshopify.com") { 
  
      if (page=='cart')
      {
        $('#checkout2').before(coupon_body);
           taget_found=true;
      }
      else{
        $('#checkout2').before(coupon_body);
        taget_found=true;
      }
     
    }
   else  if (shop_domain=='the-beauty-sailor.myshopify.com')
   {
      if (page=='cart')
      {
        $('#cartCheckout').before(coupon_body);  
        $('#cartDWcheckout').before(coupon_body); 
        taget_found=true;
      }
     
   }
   else if(Shopify.shop == "theformularx-2.myshopify.com") { 
  
      
    if (page=='cart')
    {
      $('.cart__submit').before(coupon_body);
     
    }
    else{
      $('.hs-checkout-purchase').before(coupon_body);
    }
   
    //$('.mu-checkout-btn').before(coupon_body);
    taget_found=true;
  }
   else  if (shop_domain=='provalo-cosmetics.myshopify.com')
   {
      if (page=='cart')
      {
        $('.checkout-button').before(coupon_body);  
       
        $('.action-checkout').find('.button-viewcart').before(coupon_body);  
        taget_found=true;
      }
      else{
        $('.action-checkout').find('.button-viewcart').before(coupon_body);  
        taget_found=true;
      }
     
   }
   else if(Shopify.shop == "pure-home-living-gh.myshopify.com") { 
  
      
    if (page=='cart')
    {
      $('.enter-gift-card').before(coupon_body);
     
    }
    else{
      $('.t4s-btn__cart').before(coupon_body);
    }
   
    //$('.mu-checkout-btn').before(coupon_body);
    taget_found=true;
  }
   
   else  if (shop_domain=='holyfroots.myshopify.com')
   {
      if (page=='cart')
      {
        $('.cart-template__button').before(coupon_body);  
      }
      else{
        $('.cart__dropdown-action').before(coupon_body);
      }
      taget_found=true;
   }
   else  if (shop_domain=='taggdigital.myshopify.com')
   {
      if (page=='cart')
      {
        $('.cart__checkout').before(coupon_body);
        taget_found=true;
      }
      else{
        $('.minicart-sidebar').each(function(){
            $(this).find('.btn-checkout').parent().before(coupon_body);
            taget_found=true;
        })
      }
     
   }
   else if (shop_domain=='navinpetstore.myshopify.com')
  {
    if (page=='cart')
        {
          if ($('.main-content').find('.cart-checkout').length>1)
          {
            if ($(window).width()>1000)
            {
              $($('.main-content').find('.cart-checkout')[0]).before(coupon_body);
            }
             else{
              $($('.main-content').find('.cart-checkout')[1]).before(coupon_body);
             }
          }
         
        }
        taget_found=true;
  }
   
  else if (shop_domain=='mavshackin.myshopify.com')
  {
     if (page=='cart')
       {
         $('#cartCheckout').before(coupon_body);
         $('#cartDWcheckout').before(coupon_body);
         taget_found=true;
       }
  }
     else if(Shopify.shop == "nyumi-store.myshopify.com") { 
     if (page=='cart')
       {
               $('.cart-subtotal').before(coupon_body);
       }
       else{
   $('.minct_subtotal').before(coupon_body);
       }
            
      
         taget_found=true;
    
    //$('.mu-checkout-btn').before(coupon_body);
    taget_found=true;
  }
  else if (shop_domain=='tamilshop-de.myshopify.com')
   {
      if (page=='cart')
        {
          $('.checkout-button').before(coupon_body);
          taget_found=true;
        }
   }
   else if (shop_domain=='livspace-store-sgp.myshopify.com')
   {
        if (page=='cart')
        {
          if ($('.cart-checkout').length>1)
          {
            $($('.cart-checkout')[1]).before(coupon_body);
          }
          else{
            $('.cart-checkout').before(coupon_body);
          }
        }
      else{
        $('.atc-button--viewcart').before(coupon_body);
      }
     //$('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
   else if (shop_domain=='bloomdevelop.myshopify.com')
   {
    if (page==='cart')
    {
      let eleSide= document.querySelector('.cart-sidebar__footer');
      eleSide.insertAdjacentElement('beforebegin', coupon_body)

    }
    else{
      let eleSide= document.querySelector('cart-drawer-items');
      eleSide.insertAdjacentElement('afterend', coupon_body)

    }
     taget_found=true;
   }
   else if (shop_domain=='smartivity-in.myshopify.com')
   {
       if ($("p.buttons").length>0)
       {
            $('p.buttons').before(coupon_body);
       }
     $('.checkout-button').before(coupon_body);
     //$('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
 else  if (shop_domain==='triyah.myshopify.com')
  {
    if (page=='cart')
    {
      $("[name='checkout']").before(coupon_body);
      taget_found=true;
    }
    
  }
   else if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
   {
     /*if ($('#cart-notification-form').length>0)
     {
        $('#cart-notification-form').find("[name='checkout']").before(coupon_body);
     }*/
       if (page=='cart')
       {
        $('.js-contents').find('.totals').after(coupon_body);
       }
     taget_found=true;
   }
   else if (shop_domain=='ldu-letsdressup.myshopify.com')
   {
     /*if ($('#cart-notification-form').length>0)
     {
        $('#cart-notification-form').find("[name='checkout']").before(coupon_body);
     }*/
       if (page=='cart')
       {
          $('.tax-note').before(coupon_body);
       // $('.js-contents').find('.totals').after(coupon_body);
       }
     taget_found=true;
   }
   else if (shop_domain=='jaipurkurti-com.myshopify.com')
   {
       
      if (page=='cart')
      {
        $('.tt-shopcart-box').find("[name='checkout']").before(coupon_body);
      }
      else{
        if ($("#modalAddToCartProduct").length>0)
        {
         $("#modalAddToCartProduct").find('.tt-modal-addtocart').find('.tt-cart-total').after(coupon_body);
        }
        $("#modalAddToCartProduct").find('.dscnt_manual_btnwrap').css('margin-top','-20px');

        $('head').append(`
        <style>
        .discountify_crtdwer .discountify_manual .dscnt_manual_field {
          min-width: 222px !important;
          }
        </style>`);
        
        
        if ($(".tt-dropdown-menu").length>0)
        {
         $(".tt-dropdown-menu").find('.tt-cart-btn').before(coupon_body);
        }
      }
     taget_found=true;
   }
   else if(Shopify.shop == "octics-fashion.myshopify.com") { 
    
     $('.cart_total.cart_total_price.total-price-wrapper').after(coupon_body);
     //$('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
   
  else if(Shopify.shop == "plumgoodness-2.myshopify.com") { 
    if (page==='cart')
    {
      $('#shopify-section-cart-template').find('.cart__shipping').after(coupon_body);
      
    }
    else{
      $('#dropdown-cart').find('.total_cs_custom_dropcart').before(coupon_body);
     
    }
  }
   else if(Shopify.shop == "martiprodukt.myshopify.com") { 
    
    $('#cartDWcheckout').before(coupon_body);
    $('#cartCheckout').before(coupon_body);
    //$('.mu-checkout-btn').before(coupon_body);
    taget_found=true;
  }
   else if(Shopify.shop == "gritstones.myshopify.com") { 
    
    $('.btn-checkout').before(coupon_body);
    //$('.mu-checkout-btn').before(coupon_body);
    taget_found=true;
  }
  else if(Shopify.shop == "nitya-for-estelle.myshopify.com") { 
    
    $('#inlinecheckout-cart').before(coupon_body);
    $('.cart-update').before(coupon_body);
    taget_found=true;
  }
   else if(Shopify.shop == "sa3cosmetic.myshopify.com") { 
    
     $('.cartSummery').find('.cart__shipping').after(coupon_body);
     $('#cartDWcheckout').before(coupon_body);
     //$('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
   else if(Shopify.shop == "rare-food-shop.myshopify.com") { 
    
   
    
     $('.cart-checkout').find('button').before(coupon_body);
     $('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
   else if(Shopify.shop == "aulerth-staging.myshopify.com") { 
     $('.cart__foot-inner').find('.checkout_cart').before(coupon_body);
     if (page=='cart')
     {
       $('.cart__foot-inner').find("[name='checkout']").before(coupon_body);
     }
       taget_found=true;
   }
   else if(Shopify.shop == "nutramin-in.myshopify.com") { 
    
   
    
     $('.cart-checkout').find('button').before(coupon_body);
     //$('.mu-checkout-btn').before(coupon_body);
     taget_found=true;
   }
   else if(Shopify.shop == "unicoar.myshopify.com") { 
     $('.ajax-cart__buttons').each(function(){
      $(this).before(coupon_body);
    
       taget_found=true;
     });
    
   }
   else if (shop_domain=='schmucktesten.myshopify.com')
   {
        if (page!=='cart')
        {
          $('.js-drawer').find('.ajaxcart__footer-price').before(coupon_body);
          taget_found=true;
        }
   }
   
   else if(Shopify.shop == "silvertraq.myshopify.com") { 
     $('.quick-cart__discounts').before(coupon_body);
     $('.cart__footer-actions').before(coupon_body);
     taget_found=true;
     
   }
   else if (shop_domain=='cptoothbrush.myshopify.com')
   {
     $('.cart__ctas').before(coupon_body);
     $('.cart-notification__links').find("[name='checkout']").before(coupon_body);
     $('.cart__footer').find("[name='checkout']").before(coupon_body);
     
     taget_found=true;
   }
   else if (shop_domain=='natvral.myshopify.com')
   {
     
     $('.Cart__Checkout').before(coupon_body);
     
     taget_found=true;
   }
  else if (shop_domain=='bsc-women.myshopify.com')
   {

     $('.btn-checkout').before(coupon_body);
     $('.btn_checkout').before(coupon_body);
     
   /*  if ($('.footer-row').length>0)
     {
       $($('.footer-row')[0]).after(coupon_body);
     }
     if ($('.cart__ctas').length>0)
     {
       $($('.cart__ctas')[0]).before(coupon_body);
     }*/;
     if ($('.sticky-footer').length>0)
     {
       $( $($('.sticky-footer')[0]).find("[name='checkout']")[0]).unbind('click');
   
     }
     
  
    
  
    
     taget_found=true;
   }
   else if (shop_domain=='yahavful.myshopify.com')
   {
    
     $($('.cart-summary')[0]).after(coupon_body);
     
     $($('.to-checkout')[0]).before(coupon_body);
     taget_found=true;
   }
   else if(Shopify.shop == "valentina-rio.myshopify.com") { 
     $($('.cart__checkout')[0]).before(coupon_body);
     
     $($('#checkout')[0]).before(coupon_body);
     taget_found=true;
    
   }
   else if (shop_domain=='vapouroxide.myshopify.com')
   {
     if (page=='cart')
     {
      $($('.cart-recap__checkout')[0]).before(coupon_body);
      taget_found=true;
     }
     else{
      taget_found=true;
     }
     
   }
   else if ((shop_domain=='crystallineme-uk.myshopify.com'))
    {
         $($('.cart__subtotal')[0]).before(coupon_body);
        
        taget_found=true;
        
    
    }
    else if ((shop_domain=='masori.myshopify.com'))
    {
      if (page!='cart')
      {
        taget_found=true;
      }
        
        
    
    }
    else if ((shop_domain=='crystallineme-de.myshopify.com'))
    {
         $($('.cart__subtotal')[0]).before(coupon_body);
        
        taget_found=true;
        
    
    }
    else if ((shop_domain=='homegamesroom.myshopify.com'))
    {
         $($('.cart-checkout')[0]).before(coupon_body);
        
        taget_found=true;
        
    
    }
    else if ((shop_domain=='zevar-king.myshopify.com'))
    {
      if (page=='cart')
      {
        $('.continue-shopping--cart').before(coupon_body);
      }
      else{
        $('.cart-button-checkout').before(coupon_body);
      }
      
       
        taget_found=true;
        
    
    }
    else if ((shop_domain=='packie-1.myshopify.com'))
    {
      if (page==='cart')
      {
        $($('.checkout-buttons')[0]).before(coupon_body);
        
        taget_found=true;
      }
      else{
        $($('#slidecarthq').find('.footer-row')[0]).before(coupon_body);
        
        taget_found=true;
      }
        
        
    
    }
    else{
      var taget_found=false;
        if (is_custom_checkout_button==1)
        {
          //var app_target_temp = $($('.'+custom_checkout_button_cls_names)[$('[type=submit][name=checkout]').length - 1]);
          if (custom_checkout_button_cls_names!='')
          {
               var tgt_cls_name_arr = custom_checkout_button_cls_names.split(",");
               for(var ci=0;ci<tgt_cls_name_arr.length;ci++)
               {
               
                var tmp_app_target_temp;
               
                 if ((tgt_cls_name_arr[ci].charAt(0) ==".") ||(tgt_cls_name_arr[ci].charAt(0) =="#"))
                 {
                     tmp_app_target_temp= $(tgt_cls_name_arr[ci]);
                 }
                  else{
                    tmp_app_target_temp= $('.'+tgt_cls_name_arr[ci]);
                  } 

                  if (tmp_app_target_temp.length>=1)
                  {
                   
                    for(var tlg=0;tlg<tmp_app_target_temp.length;tlg++)
                    {

                        if (iselemetVisible($(tmp_app_target_temp)[tlg]))
                        {
                          taget_found=true;
                          app_target=$($(tmp_app_target_temp)[tlg]);
                          app_target.before(coupon_body); 
                        }
                    }
                  
                    
                  }

               }
             
          }
        
        }
     
        if (taget_found==false)
        {
          if (app_target!=null)
          {
            app_target.before(coupon_body); 
          }
          else{
              $('[name="checkout"]').before(coupon_body); 
          }
          
        }
        $('.discountify_discount_wrap').find('.lds-dual-ring').css("cssText", "padding-left: 0px !important;");
        $('.discountify_discount_wrap').find('.lds-dual-ring').hide();

    }

    

  // For Tangle Artidtry Ends
}
function change_widths_for_shops()
{
  if (shop_domain=='crystallineme-de.myshopify.com')
  {
    
        $('.dscnt_manual_fldwrap').width('152px');
        
  }

  if (shop_domain=='fancy-fluff-india.myshopify.com')
  {
    if ($(window).width() <500)
    {
        $('.dscnt_manual_fldwrap').width('70%');
        $('.dscnt_manual_field').width('100%');
    }
    
  }
  if (shop_domain=='buy-wow-health.myshopify.com')
  {
   
      $('.dscnt_manual_fldwrap').width('100%');
      $('.dscnt_manual_field').width('100%');
        
    
    
  }
  if (shop_domain=='skinbae-in.myshopify.com')
  {
    if ($(window).width() <500)
    {
      $('.dscnt_manual_fldwrap').width('70%');
      $('.dscnt_manual_field').width('100%');
        
    }
    
  }

  if(Shopify.shop == "fynnushop.myshopify.com") {
    if ($(window).width()<500) 
    {
      $('.dscnt_manual_fldwrap').width(240);
      $('.dscnt_manual_field').width(240);
    }
    
  }
 if(Shopify.shop == "mondokoro.myshopify.com") { 
   $('.dscnt_manual_fldwrap').width(240);
 }
 if(Shopify.shop == "uyyala-com.myshopify.com") { 
   $('.dscnt_manual_fldwrap').width(275);
   $('.dscnt_manual_field').attr('style',  $('.dscnt_manual_field').attr('style') + '; ' + 'border-right-width:0px !important;');
 }
 if(Shopify.shop == "valentina-rio.myshopify.com") { 
  
   $('.apply_voucher_btn').attr('style',  $('.apply_voucher_btn').attr('style') + '; ' + 'padding-top:0px !important;');
   $('.proceed_checkoutbtn').attr('style',  $('.proceed_checkoutbtn').attr('style') + '; ' + 'padding-top:1px !important;');
 }
 if(Shopify.shop == "silvertraq.myshopify.com") {
   $('.discountify_aply_voucher').attr('style',  $('.apply_voucher_btn').attr('style') + '; ' + ' position:relative !important;');
  $('.quick-cart__footer').find('.show_availablity').css('color','white');
  $('.inln_msg').width('100%'); 
 
 }

 if(Shopify.shop == "alphabootic.myshopify.com") 
 { 
   $('.dscnt_manual_fldwrap').each
   (
       function() {
       $(this).width(152);
     }
   );
   $('.radio_cpn').each
   (
       function() {
         $(this).find('label').first().css('margin-bottom','15px');
     }
   );
 }

   
 if ($('.discountify_manual_wrap').length>0)
 {
   if ($('.discountify_manual_wrap').width()>0)
   {
     var increase_width=0
     if (shop_domain=='bombay-shaving.myshopify.com')
     {
        increase_width=8

     }
     if (shop_domain=='murray-the-sockman.myshopify.com')
   {
    $('.dscnt_manual_field').css('width','100%');
     $('head').append(`<style type="text/css">.discountify_manual_wrap .discountify_manual .dscnt_manual_field{height:26px !important} .discountify_manual .dscnt_manual_applybtn{width:auto !important}  </style>`);
   }
     if(Shopify.shop == "ldu-letsdressup-staging.myshopify.com") { 
      
      $('.discountify_manual_wrap').css('width','100%');
      
      $('.dscnt_manual_fldwrap').css('width','70%');
      $('.dscnt_manual_btnwrap').css('width','30%');
      $('.discount_availibility').css('text-align','center');
      
    }
    if(Shopify.shop == "ldu-letsdressup.myshopify.com") { 
      
      $('.discountify_manual_wrap').css('width','100%');
      
      $('.dscnt_manual_fldwrap').css('width','70%');
      $('.dscnt_manual_btnwrap').css('width','30%');
      $('.discount_availibility').css('text-align','center');
      
    }
     if(Shopify.shop == "octics-fashion.myshopify.com") { 
       $('.ms_vl_drp_cls').css('width','100%');
     
       $('.ms-vl-drp_sel').css('width','100%');
       $('.discountify_manual_wrap').css('width','100%');
       
       $('.dscnt_manual_fldwrap').css('width','70%');
       $('.dscnt_manual_btnwrap').css('width','30%');
       
     }
    else  if (shop_domain=='livspace-store-sgp.myshopify.com')
   {
    $('.ms_vl_drp_cls').css('width','100%');
    $('.ms_vl_drp_cls').css('text-align', 'right');
     
    $('.ms-vl-drp_sel').css('width','200px');
    $('.ms-vl-drp_sel').css('height','35px');
    $('.discountify_discount_wrap').css('text-align', 'right');
   }
     else{
       $('.ms_vl_drp_cls').width($('.discountify_manual_wrap').width()+increase_width);
     
       $('.ms-vl-drp_sel').css('width','100%');
     }
     
     
   }

 }
 else{
      $('.ms_vl_drp_cls').css('width','100%');
      $('.ms-vl-drp_sel').css('width','100%');
 }
 if (shop_domain=='bsc-women.myshopify.com')
   {
    
    
     $('.sticky-footer').find('.discountify_discount_wrap').find('svg').css('display','inline-block');
     $('.sticky-footer').find('.discountify_discount_wrap').find('div').css('display','inline-block');
     $('.sticky-footer').find('.div_tbl_tot') .css('max-width','360px');
     $('.sticky-footer').find('.div_tbl_tot') .css('width','360px');
     $('.sticky-footer').find('.spn_fin_tot') .css('font-weight','600');
     $('.discountify_manual').css('max-width','360px');
     $('.div_tbl_tot') .css('max-width','360px')
     if ($('.discountify_tag').length==0)
     {
       $('.sticky-footer').find('.discountify_status_msg').hide();
     }

     $('[name="checkout"]').unbind('click');
     $(document).on('click','[name="checkout"]', function (e) 
     {
       e.preventDefault();
         e.stopPropagation(); 
         process_to_checkout(e)
     });
    
   
     
   }
   if (shop_domain=='aulerth.myshopify.com')
   {
     $('.dscnt_manual_fldwrap').width(230);
     $('.dscnt_manual_field').css('max-height','42px');
     $('.inln_msg').css('font-size','12px');
   }
 fourth_store_hide_sections();
}
function bombay_attach_click()
{
 $('.site-header__cart').on('click',function(){
   if (shop_domain=='bombay-shaving.myshopify.com')
   {
     //$($('div.ms-voila-cart')[0]).before(coupon_body);
     
 }

 });
}
function cart_drwser_isee_stores_prope()
{
 if (shop_domain=='odara-jewellery.myshopify.com')
   {
       $('.cart-popup-item').after(coupon_body);

       var observer = new MutationObserver(function(mutations) {
         console.log('vt works');
       });
       var target = document.querySelector('.cart-popup-wrapper');
       observer.observe(target, {
         attributes: true
       });

      
       // common_drawer_issues_store('.cart-popup-item','.cart-popup-item','','after');
   }
   if (shop_domain=='quecy-com.myshopify.com')
   {
     setTimeout(() => {
      common_drawer_issues_store('.slidecarthq','#slidecart-checkout-form','','before');
     }, 1000);
  
   }
   if (shop_domain=='trymaylillies.myshopify.com')
   {
       if ( $('#shopify-section-cart-drawer').find('.discountify_discount_wrap').length==0)
                  {
                        $('.cart-summary__buttons').before(coupon_body);
                  }
           
      common_drawer_issues_store('#shopify-section-cart-drawer','.cart-summary__buttons','','before');
    
   }
   if (shop_domain=='bombay-shaving.myshopify.com')
   {
     common_drawer_issues_store('#sidebar-cart','.Drawer__Footer','.Cart__Taxes','before');
      setTimeout(() => {
        manage_coupon_storage();
      }, 500);
   }
   if (shop_domain=='the-indian-garage.myshopify.com')
   {
     common_drawer_issues_store('#shopify-section-mini-cart','.checkout-button','','before');
   }
   if (shop_domain=='skinbae-in.myshopify.com')
   {
     common_drawer_issues_store('#CartDrawer','.cart__checkout','','before');
   }
   
   
   if (shop_domain=='fancy-fluff-india.myshopify.com')
   {
     common_drawer_issues_store('.widget_shopping_cart_content','.buttons','','before');
   }
   
   if (shop_domain=='super-portraits.myshopify.com')
   {
        common_drawer_issues_store('#CartDrawer','#CartContainer','.ajaxcart-checkout','before');
   }
   
   if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
   {
        common_drawer_issues_store('#slidecarthq','#slidecart-checkout-form','','before');
   }
   if (shop_domain=='ldu-letsdressup.myshopify.com')
   {
   
       common_drawer_issues_store('#main-cart-footer','.totals','','after');
     
   }
   if (shop_domain=='smartivity-in.myshopify.com')
   {
        common_drawer_issues_store('.sticky-footer','p.buttons','','before');
   
   }
   if (shop_domain=='the-amyra-store.myshopify.com')
   {
        common_drawer_issues_store('#sidebar-cart','.Cart__Checkout','','before');
        common_drawer_issues_store('#shopify-section-cart-template','.Cart__Checkout','','before');
     
   }
   if (shop_domain=='thebearhouseindia.myshopify.com')
   {
     common_drawer_issues_store('#CartContainer','.drawer__footer','.cart__checkout','before');
     
   }
   if (shop_domain=='snackamor.myshopify.com')
   {
     common_drawer_issues_store('.md-sidenav-right','.cart-total','.actions','before');
     
   }
   if (shop_domain=='lakdi-furniture-store.myshopify.com')
   {
     common_drawer_issues_store('#shopify-section-cart-template','.card__section','.cart-recap__checkout','before');
     common_drawer_issues_store('#mini-cart','.mini-cart__button-container','','before');
   }
   if (shop_domain=='sa3cosmetic.myshopify.com')
   {
     //common_drawer_issues_store('#shopify-section-cart-template','.cartSummery','.cart__shipping','after');
   }
   if (shop_domain=='nxndnstuffs.myshopify.com')
   {
     common_drawer_issues_store('#shopify-section-cart-template','.card__section','.cart-recap__checkout','before');
     common_drawer_issues_store('#mini-cart','.mini-cart__button-container','','before');
   }

   if (shop_domain=='aastey.myshopify.com')
   {
     common_drawer_issues_store('#dropdown-cart','.actions','','before');
     
   }
  
   if (shop_domain=='vapouroxide.myshopify.com')
   {
     common_drawer_issues_store('#shopify-section-cart-template','.card__section','.cart-recap__checkout','before');
     common_drawer_issues_store('#mini-cart','.mini-cart__button-container','','before');
   }
   if ((shop_domain=='crystallineme-uk.myshopify.com'))
    {
        common_drawer_issues_store('#MainContent','.cart__subtotal','','before');
        
    
    }
    if ((shop_domain=='crystallineme-de.myshopify.com'))
    {
        common_drawer_issues_store('#MainContent','.cart__subtotal','','before');
        
    
    }
    if ((shop_domain=='eiffeltextile.myshopify.com'))
    {
        common_drawer_issues_store('#mini-cart','.mini-cart__button-container','','before');
        
    
    }
    if ((shop_domain=='vvegano.myshopify.com'))
    {
        common_drawer_issues_store('.main-content-inner','.cart-checkout-bts','.cart-checkout-btn','before');
        
    
    }
    
   
}


function checkoutpage_modified(api_data)
{
    const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(added_node) {
          if ($(added_node).hasClass('order-summary__section--discount'))
          {
            if ( $('.sidebar__content').find('.field__input-btn-wrapper').find('.discountify_discount_wrap').length==0)
              {
                    
                    $('.sidebar__content').find('.field__input-btn-wrapper').after(coupon_body);
                $('.discountify_manual_wrap').hide();
              }
          }
     }); 
    
    });
});
  observer.observe(document.querySelector(".sidebar"), { subtree: true, childList: true });
}
function banaras_price_modified()
{
  $('#cart-form').on('DOMSubtreeModified',function(){
    console.log('price moddddd');
         manage_coupon_storage();
 });
  
}
function cart_drwer_load(api_data)
{
  if (page=='checkout')
  {
    checkoutpage_modified(api_data);
    return;
  }
  if (api_data.discountify_coupon.slide_setup=='on')
  {
    if (shop_domain=='banarasee.myshopify.com')
    {
      
        document.addEventListener('popupOpened', function(e){
          console.log('testing opened document');
          setTimeout(() => {
            add_discount_box(api_data.discountify_coupon.slide_main_section,
              api_data.discountify_coupon.slide_sub_section,'',
              api_data.discountify_coupon.slide_where,300);
             // banaras_price_modified();
          }, 300);

       }, false);

       document.addEventListener('updateCart', function(e){
        console.log('Update mmmmmmmm');
       manage_coupon_storage();

     }, false);
       
       

       return;
    }
    let dealy_thousant_stores=['bigbluemarbles.myshopify.com','navinpetstore.myshopify.com',
    'soul-nutritions.myshopify.com','kikihair1.myshopify.com','schmucktesten.myshopify.com',
    '3wliners.myshopify.com','wolfboxdashcamera.myshopify.com']
    if (dealy_thousant_stores.includes(shop_domain))
   {
      setTimeout(() => {
        setup_slidecart_issues_store(api_data.discountify_coupon.slide_main_section,
          api_data.discountify_coupon.slide_sub_section,'',
          api_data.discountify_coupon.slide_where,1000);
      }, 1000);
      let icart_drawer_stores=['3wliners.myshopify.com','wolfboxdashcamera.myshopify.com']
      if (icart_drawer_stores.includes(shop_domain))
      {
        setTimeout(() => {
          add_discount_box(api_data.discountify_coupon.slide_main_section,
            api_data.discountify_coupon.slide_sub_section,'',
            api_data.discountify_coupon.slide_where,300);
          // banaras_price_modified();
        }, 300);
      }
     
   }
   else{
    setup_slidecart_issues_store(api_data.discountify_coupon.slide_main_section,
      api_data.discountify_coupon.slide_sub_section,'',
      api_data.discountify_coupon.slide_where,500);
   }
   
   
  }
  if (api_data.discountify_coupon.cart_setup=='on')
  {
    setup_slidecart_issues_store(api_data.discountify_coupon.cart_main_section,
      api_data.discountify_coupon.cart_sub_section,'',
      api_data.discountify_coupon.cart_where,500);
   
  }
 if (cart_drawer_issues_stores.includes(shop_domain))
 {
    cart_drwser_isee_stores_prope()
   
 }

 if (shop_domain=='zeropiu-store.myshopify.com')
 {
   ///zeropiu_store(api_data);
 }
 if (relish_shops.includes(shop_domain))
 {
 relish_store(api_data);

 }
  
 if (shop_domain=='eolallc.myshopify.com')
 {
   eolallc_store_cart(api_data);

 }
 
 if (shop_domain=='valentina-rio.myshopify.com')
 {
   valentina_rio_store_cart(api_data);

 }
 if (shop_domain=='unicoar.myshopify.com')
 {
   unicoar_store(api_data);

 }
 if (shop_domain=='artemis-aparels.myshopify.com')
 {
   artemis_store(api_data);

 }
 if (shop_domain=='foreverkidz1.myshopify.com')
 {
   foreverkidz_store(api_data);

 }
 if (shop_domain=='acuadot.myshopify.com')
 {
   acuadot_store(api_data);

 }
 
 
 if (shop_domain=='mamilie.myshopify.com')
 {
   mamilie_store_cart();
 }
 
 if (shop_domain=='andrea-morando.myshopify.com')
 {
   andrea_morando_store(api_data);

 }
 
 
 
 
 
}
function prepare_popup_html_assign(api_data)
{
 if (shop_domain==='whats-up-wellness.myshopify.com')
 {
  return;
 }
 cpnpop_body +=`<div id=\"discountify_modal\" class=\"discountify_modal ajax_popup\" style=\"display: flex;\">
                <div class=\"discountify_modal_content\" style="${pop_bgcolor}">
                  <div class="header_icon">
                    <img loading="lazy" src="${http_dom+urlPath}/images/discounticon_new.webp">
                  </div>
                  <div class="popup_header">
                    <span class=\"discountify_popup_close\" style="${pop_header_text_color}">×</span>
                    <div class=\"ajx_popup_head\" style="${pop_header_text_color}">${pop_headertxt+poweredby_html}</div>
                </div>
               
                <div class=\"discountify_pop_body\"><div class=\"coupon_discounts\">`;
 var fott_btn_width='100%'
  if ($(window).width()>desktop_width)
  {
    fott_btn_width='30%';
  }
  cpnpop_body +="</div></div><div class=\"discountify_pop_footer\">"+
  "<div style='width:100% !important;' >";
  if ($(window).width()>desktop_width)
  {
    cpnpop_body +="<div style='' class=\"discountify_error\">&nbsp;</div>";
  }
  if (btn_margin_issue!='')
  {
   btn_margin_issue+='float:right !important;';
  }
  var pp_btn_padding='';
  if (shop_domain=='unicoar.myshopify.com')
  {
     pp_btn_padding='padding:0px 10px !important;height:47px !important;';

  }
  fott_btn_width="auto ";
  cpnpop_body += "<div style='text-align:center;width:"+fott_btn_width+" !important;'>"+
  "<button class=\"btn apply_voucher_btn "+radius_popup+" \" name=\"apply_voucher\" "+
  "style='"+pp_btn_padding+btn_margin_issue+voucher_bgcolor+voucher_txtcolor+"'>"+voucher_btntxt+ "</button> "+poweredby_html2+
  "</div></div></div></div>";
  setTimeout(function(){prepare_coupon_popup(api_path,shop_data,api_data);},1);
}
function prepare_cpn_pop_up(api_data)
{
 // setTimeout(function(){prepare_coupon_popup(api_path,shop_data,api_data);},5000);
 // prepare_coupon_popup(api_path,shop_data,api_data);
if( (is_sucess_popup == 'on') && (check_plan(api_data)==true))
  {
    var padding_top_expres='';
    if(Shopify.shop == "shingora.myshopify.com") { 
      padding_top_expres='padding-top:4px !important;';
    }
    msgcpn_body +="<section class=\"discpon_wrap\" id=\"discpon_ajax_popup\"><div class=\"voila_fireworks discpon_grid\"><span class=\"discpon_close\">×</span><div  style='margin-left:0px !important;margin-top:-30px !important' class=\"fire_before\"></div><div class=\"discpon_applied\"></div><div class=\"discpon_price\"><div class=\"discpon_price_pt\"></div><div class=\"discpon_price_txt\">"+pop_save_cpn_text+"</div></div><div class=\"discpon_hr\"></div><div class=\"discpon_success\">You have availed a total discount of Rs.75</div><button type=\"button\" class=\" proceed_checkoutbtn btn-red procees_tocheckout\"  style='margin-top:40px !important;"+padding_top_expres+chkbtn_bgcolor+chkbtn_txtcolor+";'>"+pop_chkout_btn_text +"</button></div></section>";
  }
  /*-- cart drawer --*/
 
   if(page !== 'cart'){
    window.setTimeout(function(){
      var elem_exist = document.getElementsByClassName("discountify_discount_wrap");
      if(elem_exist.length ===  0) {
          
          attrCartDraw.push("#sidebar-cart [name='checkout']", "#CartDrawer [name='checkout']", "#ajaxifyCart [name='checkout']", ".cart-drawer [name='checkout']","[name='checkout']", "#cart .mm-panels .cart__actions input.action_button");
         cart_drwer_load(api_data);
          $.each(attrCartDraw, function(ic, vc) {
              if($(vc).length > 0){
                 $(vc).before(coupon_body);
                 manage_coupon_storage();
                 return false;
              }
          });
      }
      }, 1000);

      cart_drwer_load(api_data)
   }
   else{

     cart_drwer_load(api_data)
   }
  
  /*-- cart drawer --*/

}
function empty_check_replace_text(actual_val,replace_text)
  {
    if (actual_val=='')
    {
      return replace_text;
    }
    return actual_val;
  }

  function prepare_textbox(feature_html,api_data,txtbox_status)
    {
    
     if (feature_html !='')
     {
       feature_html=feature_html+prepare_drop_down_cpns(api_data,txtbox_status);
     }
     
    
     
       if  ((shop_domain=='motiongrey.myshopify.com'))
       {
        
       coupon_body +="<div class=\"discountify_manual_wrap\">"+feature_html+
       "<div class=\"discountify_txtbox_title\" style='margin-top:0px;"+dis_txt_box_btn +"text-align:"+text_lign_desc+";max-width:100% !important;"+cpn_txtbox_title_color+"'>"+txtbox_title+"</div>"+
       "<div  style='"+dis_txt_box_btn +"width:100% !important;display:inline-block !important;float:left' class=\"discountify_manual\">"+
       "<div style='float:left;width:70% !important;' class=\"dscnt_manual_fldwrap\">"+
       "<input type=\"text\" name=\"coupon_discount\"  style='border-width:1px !important;margin-right:20px !important;"+txt_radius_text_border+txt_box_height+is_cpn_txtbox_border+"' class='dscnt_manual_field "+respons_cls+" "+radius_text+"' placeholder='"+txtbox_placeholder_title+"' autocomplete=\"off\" >"+
       "</div>"+
       "<div style='"+dis_txt_box_btn +"float:left;width:1% !important;display:inline-block !important'>&nbsp;</div>"+
       "<div style='"+dis_txt_box_btn +"float:left;width:29% !important"+cpn_btn_style +"' class=\"dscnt_manual_btnwrap\">"+
       "<button type=\"button\" class=\" btn dscnt_manual_applybtn discountify_aply_voucher "+radius_btn+" \" "+
       " style='padding-left:2px !important;padding-right:2px !important;"+btn_radius_btn +btn_pding_top_style+btn_padding+cpn_btnbgcolor+cpn_btntxtcolor+"'>"+cpn_btntxt+" </button></div></div><div style=\"display:none; \" class=\"inln_msg\"></div><div class=\"discountify_divider\"></div></div>";


       }
       else{
         if (shop_domain=='nunmun.myshopify.com')
         {
           cpn_btnbgcolor='';
         }
         if (shop_domain=='fynnushop.myshopify.com')
         {
            if ($(window).width()<500)
            {
              textbox_width="230px !important"
            }
         }
               
       coupon_body +="<div class=\"discountify_manual_wrap\">"+feature_html+
       "<div class=\"discountify_txtbox_title\" style='"+dis_txt_box_btn +"text-align:"+text_lign_desc+";max-width:100% !important;"+cpn_txtbox_title_color+"'>"+txtbox_title+"</div>"+
       "<div  style='"+dis_txt_box_btn +"width:100% !important' class=\"discountify_manual\">"+
       "<div style='"+dis_txt_box_btn+textbox_width +"' class=\"dscnt_manual_fldwrap\">"+
       "<input type=\"text\" name=\"coupon_discount\"  style='"+txt_radius_text_border+txt_box_height+is_cpn_txtbox_border+"' class='dscnt_manual_field "+respons_cls+" "+radius_text+"' placeholder='"+txtbox_placeholder_title+"' autocomplete=\"off\" >"+
       "</div>"+
       "<div style='"+dis_txt_box_btn+cpn_btn_style +"' class=\"dscnt_manual_btnwrap\">"+
       "<button type=\"button\" class=\" btn dscnt_manual_applybtn discountify_aply_voucher "+radius_btn+" \" "+
       " style='"+btn_height+btn_radius_btn +btn_pding_top_style+btn_padding+cpn_btnbgcolor+cpn_btntxtcolor+btn_margin_issue+"'>"+cpn_btntxt+" </button></div></div><div style=\"display:none; \" class=\"inln_msg\"></div>"+
       "<div style='"+dis_txt_box_btn +"' class=\"discountify_divider\"></div></div>";

       }

    }
    function feature_cpn_option(api_data,txtbox_status)
    {
      var hero_cpn_right_aligned_stoes=['apextrimmer.myshopify.com'];
      var hero_cpn_align='left';
      if (hero_cpn_right_aligned_stoes.includes(shop_domain))
      {
       hero_cpn_align='right';
      }

       var   feature_html='<div class="radio_cpn" style="height:25px !Important; text-align:'+ hero_cpn_align +' !important">'+ 
                       '<label style="cursor:pointer !important;height:12px !important"><input type="radio" name="rbfeature_discount" style="vertical-align:middle;" class="ms_vl_rd_change" value="'+feat_cart_cpn_code +'">'+
                        '<span class="ms_vl_radio_cpn_spn"  style="padding-left:3px !important; vertical-align:middle; font-weight:'+hero_cpn_font_weight+'">'+ feat_cart_cpn_text +'</span>'+
                        '<span style="font-size:14px; text-transform: lowercase;"></span>'+
                       '</label>'+  
                        '<label style="'+dis_txt_box_btn+'cursor:pointer !important;height:12px !important;display:none">'+
                          '<input type="radio" name="rbfeature_discount" value="defaultetxtbox" style="vertical-align:middle;" class="ms_vl_rd_change" checked>'+
                          '<span class="ms_vl_radio_cpn_spn"  style="padding-left:3px !important; vertical-align:middle; font-weight:'+hero_cpn_font_weight+'">Enter Code</span>'+
                        '<span style="font-size:14px; text-transform: lowercase;"></span>'+
                          '</label>'+
                          '</div>';
         prepare_textbox(feature_html,api_data,txtbox_status);
    }

    function all_acctions_events(api_data)
    {
     $('body').on('change',".ms_vl_rd_change", function (e) {
       
       if ($(this).val()=='defaultetxtbox')
       {
         $('.dscnt_manual_field').val('');
       }
       else{
         $('.dscnt_manual_field').val($(this).val());
         $('.discountify_aply_voucher').click();
       }
   });
   if (shop_domain=='5e00ac.myshopify.com') 
   {
      $('#checkout').on('click',function(e){
            e.preventDefault();
              e.stopPropagation(); 
              process_to_checkout(e)
      });
   }

var exclude_checkout_event_stores=['alienshirt-de.myshopify.com','bottle-of-italy.myshopify.com'];
   if(  mouse_down_check_outs.includes(Shopify.shop))  
   {
      
         
           $(document).on('mousedown',".cart__submit,.custom_cart_submit,a[href$='/checkout'],input[name$='checkout']", function (e) 
           {
             e.preventDefault();
               e.stopPropagation(); 
               process_to_checkout(e)
           });
          
   }
   else{
     
             if (ios_link_issue_stores.includes(shop_domain))
             {
                 $('body').on('click',".procees_tocheckout,.checkout__button", function (e) {
                   e.preventDefault();
                   process_to_checkout(e);
               });
             }
             else{
                   $('body').on('mousedown',".procees_tocheckout,.checkout__button,.mu-checkout-btn", function (e) {
                    if (exclude_checkout_event_stores.includes(shop_domain)===false)
                    {
                     e.preventDefault();
                     process_to_checkout(e);
                    }
                     
                 });
             }
    
   $('body').on('click', '[name="checkout"],.checkout__button', function(e) {
       // e.preventDefault();
       if (exclude_checkout_event_stores.includes(shop_domain)===false)
       {
       // e.preventDefault();
        process_to_checkout(e);
       }
        
     });
 if(Shopify.shop == "artemis-aparels.myshopify.com") { 
   $('body').on('mousedown','[name="checkout"]', function (e) {
     e.preventDefault();
   
     process_to_checkout(e);
   });
 }

   }
    

  
     if(Shopify.shop == "stepevoli.myshopify.com") { 
          $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function(e) {
             e.preventDefault();
             var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie")); 
             if(discnt_cookie !== null){ 
                
             var active_coupon = discnt_cookie.couponData.title;
             active_coupon=active_coupon.replace('%','%25');
           
               if(active_coupon){ 
                 update_coupon_analytics_checkout(active_coupon);
                 var checkout_url = "//"+Shopify.shop+"/checkout?discount="+active_coupon;
                 window.self.close();
                 var openedWindow = window.open(checkout_url,'_blank');
                 return false;
               }
             }
         });
     }

  
     if ((ios_link_issue_stores.includes(shop_domain))||
        ( cpns_link_click_issues.includes(shop_domain))
        )
     {
       $('body').on('click',".discountify_discount_apply_popup", function (e) {
        e.preventDefault();
        e.stopPropagation();
         attach_link_for_popup(e)
     
       });
     }

     if (!cpns_link_click_issues.includes(shop_domain))
     {
      $('body').on('mousedown',".discountify_discount_apply_popup", function (e) {
        e.preventDefault();
        e.stopPropagation();
         attach_link_for_popup(e)
     
       });
  

     }
  
     function attach_link_for_popup(e)
     {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(function () {
        link_click_popup_action();
      },10);
     
     }
     function link_click_popup_action()
     {
        if (shop_domain=='buy-wow-health.myshopify.com')
        {
          if ((page !== 'cart') && (page !== 'checkout'))
            {
             // $(".js-drawer-open-cart")[0].click();
            
          }
        
        }
      update_popup_impressions();
       $('.dscnt_manual_field').val('');
       $('.inln_msg').html('').hide();
          
          // $('body').append(cpnpop_body);
          /* if (popup_coupons_enb_dis=='on')
           {
             avl_coupons='';
           }*/
           if (avl_coupons=="")
           {
             $('body').find('.discountify_pop_body').html( pop_loader_img);
            

             setTimeout(function () {
              // prepare_coupon_popup(api_path,shop_data,api_data);
              display_popup_cpns_based_on_conditions(1);
            },10);
              
           }
           else{
             //$('body').find('.discountify_pop_body').html(avl_coupons);
             display_popup_cpns_based_on_conditions(1);
           }
           
       
     }
    
     $('body').on('click',".apply_voucher_btn", function (e) {
        
       e.preventDefault();
       e.stopPropagation();
       var bwidth= $(this).width();
       var bheight=$(this).height();
         $(".apply_voucher_btn").html(loader);
         $(this).width(bwidth);
         
       var sel_cpn = $("input[name='coupon_id']:checked").val();
       if(sel_cpn){
         setTimeout(function () { 
         if (is_direct_validation=='on')
         {
           
            direct_validation($("input[name='coupon_id']:checked").attr('data-coupon'),true,false);
           
             return;
         }
       },1);
       if (is_direct_validation=='on')
           {
             return ;
           }
         if (cpn_data.length==0)
         {
           discountify_snackbar("ERROR",'Coupon expired');
           $(".apply_voucher_btn").html(voucher_btntxt);
           change_pop_button_style();
           return;
         }
         cpn_data=null;
         setTimeout(function () { 
           
         $.getJSON(api_path+"/get_pricerules.php?priceruleid="+sel_cpn,shop_data, function(response) { 
           cpn_data=response;
           $.each(cpn_data, function(i, v) {
             var cpn_id = cpn_data[i].id;    
             if(cpn_id == sel_cpn){
               var cpn_type = cpn_data[i].value_type;
               setTimeout(function () {
                    calculate_discounts(cpn_data[i], msgcpn_body,1,0);
               },1);
              
                
             } 
          
         });},10);


  
         });
       } else {
         discountify_snackbar("ERROR",cpn_popup_not_select_err);
         
         
         
                $(".apply_voucher_btn").html(voucher_btntxt);
                change_pop_button_style();
       }
  
   });

   $('body').on('change',".ms-vl-drp_sel", function (e) 
   {
     $('.inln_msg').html('');
     $('.inln_msg').hide();
       if ($(this).val()!="0")
       {
         textbox_button_click(100,100,$(this).val(),$(this).val());
       };
   });
   $('body').on('click',".discountify_aply_voucher", function (e) 
   {
         $('.inln_msg').html('').hide();
         e.preventDefault();
         var check_exist = false;
         var sel_cpn ='';
         if ( $("input[name='coupon_discount']").length==1)
         {
           sel_cpn=$("input[name='coupon_discount']").val().toUpperCase();
         }
         else{
           $("input[name='coupon_discount']").each(function(txt_fc_index,txt_fc_item){
            var  tem_sel_val=$.trim($(txt_fc_item).val());
               if (tem_sel_val.length>0)
               {
                 sel_cpn=tem_sel_val.toUpperCase();
               }
          });
         }
          
         if(sel_cpn)
         {
           $("input[name='coupon_discount']").val(sel_cpn);
           var bwidth= $(this).width();
           var bheight=$(this).height();
          
           $(this).width(bwidth);
                       //$(this).css('width','100%');
             $(this).height(bheight);
             
             $(".discountify_aply_voucher").html(loader);

             if (shop_domain=='byaffya.myshopify.com')
             {
              
               textbox_button_click(bwidth,bheight,sel_cpn,sel_cpn);
              
             }
             else{
               $(".discountify_aply_voucher").html(loader);
               setTimeout(function () 
               {
                 textbox_button_click(bwidth,bheight,sel_cpn,sel_cpn);
               },10);
             }
                       
                         
       
     } 
     else 
     { discountify_snackbar("ERROR", cpn_empty_err); }
   }); 

    }
    function dumy_byaffya_click()
    {
     var check_exist = false;
     var sel_cpn ='';
     if ( $("input[name='coupon_discount']").length==1)
     {
       sel_cpn=$("input[name='coupon_discount']").val().toUpperCase();
     }
     else{
       $("input[name='coupon_discount']").each(function(txt_fc_index,txt_fc_item){
        var  tem_sel_val=$.trim($(txt_fc_item).val());
           if (tem_sel_val.length>0)
           {
             sel_cpn=tem_sel_val.toUpperCase();
           }
      });
     }
     var bwidth= $(this).width();
     var bheight=$(this).height();
    
     $(this).width(bwidth);
                 //$(this).css('width','100%');
       $(this).height(bheight);
       
       $(".discountify_aply_voucher").html(loader);
      
        
       
    }

function textbox_button_click(bwidth,bheight,sel_cpn,sel_cpn1)
{
 if (is_direct_validation=='on')
                               {
                                 direct_validation(sel_cpn,false,false)
                                   return;
                               }
                             $.getJSON(api_path+"/get_discount_coupon.php?code="+sel_cpn, shop_data, function(cpn_data) 
                             { 
                             
                             if(cpn_data.length>0)
                             { 
                               $.each(cpn_data, function(i, v) {
                               var cpn_title = cpn_data[i].title.toUpperCase(); 
                               cpn_data[i].title=sel_cpn.toUpperCase();
                               check_exist = true;        
                               var cpn_type = cpn_data[i].value_type; 
                               calculate_discounts(cpn_data[i],msgcpn_body,0,0);
                               
                               });
                               if(check_exist == false)
                               {
                                 discountify_snackbar("ERROR",cpn_invld_err);
                                   remove_style();
                                 $(".discountify_aply_voucher").html(cpn_btntxt);
                               }
                               
                             }
                             else{
                               if(check_exist == false)
                               {
                                   remove_style();
                                 discountify_snackbar("ERROR",cpn_invld_err);
                                 $(".discountify_aply_voucher").html(cpn_btntxt);
                               }

                             }
                         });
}
function update_popup_impressions()
{
  
 $.getJSON(api_path+"/popup_imperssion_intercom.php",shop_data, function(response) { 
 });
}
function onselection_couponclick_attach()
{
 $('.coupon_check').on('click',function(e)
 {
    
 });
}

function set_voila_data(key, value, ttl) {
 const now = new Date()

 // `item` is an object which contains the original value
 // as well as the time when it's supposed to expire
 const item = {
   value: value,
   expiry: now.getTime() + ttl,
 }
 sessionStorage.setItem(key, JSON.stringify(item))
}

function get_voila_data(key) {
 const itemStr = sessionStorage.getItem(key)

 // if the item doesn't exist, return null
 if (!itemStr) {
   call_voila_api();
   return;
 }

 const item = JSON.parse(itemStr)
 const now = new Date()

 // compare the expiry time of the item with the current time
 if (now.getTime() > item.expiry) {
   // If the item is expired, delete the item from storage
   // and return null
   sessionStorage.removeItem(key);
   call_voila_api();
 }
 main_data_call(JSON.parse(item.value));
}
function setLanguageData(api_data)
{
    if ((api_data['mult_lang_texts'] === null)|| (api_data.mult_lang_texts === undefined))
  {
    return;
  }
    if (shop_domain=='workoutspecialist.myshopify.com')
    {
      let lang_code=$("html").attr("lang");
      for(let k=0;k<api_data['mult_lang_texts'].length;k++)
      {
          if (api_data['mult_lang_texts'][k]['lang_code']===lang_code)
          {
            api_data['discountify_coupon']['cpn_apply_btn_text']=api_data['mult_lang_texts'][k]['pop_up_apply_btn_txt'];
            api_data['discountify_coupon']['cpn_avl_text']=api_data['mult_lang_texts'][k]['	cpn_pop_link_text'];
            api_data['discountify_coupon']['cpn_txtbox_placeholder_title']=api_data['mult_lang_texts'][k]['cpn_fld_placehld_txt'];
            api_data['discountify_coupon']['discnt_applied_msg']=api_data['mult_lang_texts'][k]['cpn_apply_suce'];
            api_data['discountify_coupon']['cpn_txtbox_title']=api_data['mult_lang_texts'][k]['cpn_fld_title'];

            api_data['discountify_coupon']['discount_cstm_txt']=api_data['mult_lang_texts'][k]['discount_txt'];
            api_data['discountify_coupon']['total_cstm_txt']=api_data['mult_lang_texts'][k]['total_txt'];
            api_data['discountify_coupon']['feat_cart_cpn_text']=api_data['mult_lang_texts'][k]['hero_cpn_txt'];
            api_data['discountify_coupon']['default_text_cpn_dropdown']=api_data['mult_lang_texts'][k]['coupon_drop_down_default_text'];
            
          }
      }
      for(let k=0;k<api_data['mult_lang_cpn_dropdowns_texts'].length;k++)
      {
        if (api_data['mult_lang_cpn_dropdowns_texts'][k]['coupon_screen_type']!='D'){
          continue;
        }
          if (api_data['mult_lang_cpn_dropdowns_texts'][k]['lang_code']!=lang_code)
          {
            continue;
          }

            for(let m=0;m<api_data.drp_cpns.length;m++)
            {
             
              if (api_data.drp_cpns[m]['dropdown_cpn_code']==api_data['mult_lang_cpn_dropdowns_texts'][k]['cpn_code'])
              {
                api_data.drp_cpns[m]['dropdown_cpn_text']=api_data['mult_lang_cpn_dropdowns_texts'][k]['cpn_description'];
              }
            }
            
          
      }
         
    }
}
function hideElements(isHide){
  let elem_hide=''
  let cart_elem_hide='';
  if (shop_domain==='workoutspecialist.myshopify.com')
  {
    elem_hide=$('.Cart__Discount');
  }
  if (shop_domain==='nyumi-store.myshopify.com')
  {
    elem_hide=$('.minct_subtotal');
    cart_elem_hide =$('.cart-subtotal');
  }
  if (shop_domain==='packie-1.myshopify.com')
  {
   
    elem_hide=$('#slidecarthq').find('.footer-row');
    prev_subtotal=$(elem_hide).html();
  }
  if (isHide)
  {
    $(elem_hide).hide();
    if (cart_elem_hide!='')
    {
      $(cart_elem_hide).hide();
    }
  }
  else{
    $(elem_hide).show();
  }
 
}
function main_data_call(api_data)
{
 if(api_data !== null) 
{  
 if(api_data['charge_details'] !== null)
 {     
   if( api_data['charge_details'].plan_status == 'active') 
   {
     cpn_data = api_data['discountify_coupon'];
      
       if(cpn_data !==null) {
         if(cpn_data.app_enable == '')
         {
           if (fourth_stores.includes(shop_domain))
           {
             $('[name="checkout_1"]').on('click',function(){
               window.location.replace('/checkout');
             });
           }
         }
         if(cpn_data.app_enable == 'on')
         {
          setLanguageData(api_data);
           global_app_enable='on';
           dis_analtys_required=cpn_data.analtys_required;
           dis_app_plan_id=api_data.charge_details.plan_id;
           set_main_data(api_data);
           if ((avl_status=='on')&& (popup_coupons_enb_dis=='on'))
           {
             global_api_data=api_data;
           }
          
           coupon_count = api_data['avl_cpns_count']['avl_cpns_count'];
         
           if(txtbox_status == "on") {
           }
           else{
             dis_txt_box_btn='display:none;max-height:2px !important';
           }
           if (shop_domain=='salesify-demo.myshopify.com')
           {
             if (page !='cart')
             {
               main_body_right='text-align:left !important;'
             }
           }
           coupon_body +="<div style='"+main_padding_top+main_body_right +"' class=\"discountify_discount_wrap"+crtdwr_class+"\"  style='"+voila_div_align+ "'>"; 
          if (feat_cart_cpn_status=='on')
          {
          
             feature_cpn_option(api_data,txtbox_status);
          }
          else{
             if(txtbox_status == "on") {
                 prepare_textbox('',api_data,txtbox_status);
             }
            var drp_html= prepare_drop_down_cpns(api_data,txtbox_status);
             coupon_body=drp_html+coupon_body; 
          }
          
         
          prepare_cpn_cnt_link(api_data);
        
          preparer_target_body(api_data);
         prepare_cpn_pop_up(api_data);
          
             /*-- cookie --*/
               manage_coupon_storage();
             /*-- cookie --*/
             all_acctions_events(api_data);
             setTimeout(() => {
               update_coupon_analytics('','');
             }, 2);
           
           if ( api_data['discountify_coupon'].impression_limit_reacehed =="on")
           {
             $('.dscnt_availability').hide();
           }
           
           bombay_attach_click();
           rarefood_store_minicart();
           change_widths_for_shops();
           change_widht_for_total();

          

           $('.js-drawer-open-cart').on('click',function(){
                 //manage_coupon_storage();
           });

         if (shop_domain=='tatasimplybetter.myshopify.com')
         {
          $('.discount_availibility').before('<div class="cusapppromo">Apply Promo Code</div>');
         }
         ovrrideStyels(api_data);
       

} 
}
} 
}
} 

}
function ovrrideStyels(api_data)
{
    $('head').append(`
    <style>
      ${api_data.discountify_coupon.styleoverride}
    </style>`
    ); 
 
}
function set_auto_discount_code_stoarge()
{
 var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie")); 
    if(discnt_cookie == null){ 
    if (auto_discount_code!='')
    {
      const dscnt_cookie_auto = {"shop": shop_domain, 
      "couponData":{title:auto_discount_code}, 
      "couponID":auto_discount_code}; 
    setWithExpiry('dscnt_cookie', JSON.stringify(dscnt_cookie_auto));
      
    }}
    let cookDiscountValue=getCookie('discount_code');
    if (cookDiscountValue!='')
    {
      const dscnt_cookie_auto = {"shop": shop_domain, 
      "couponData":{title:cookDiscountValue}, 
      "couponID":cookDiscountValue}; 
      setWithExpiry('dscnt_cookie', JSON.stringify(dscnt_cookie_auto));
    }
}
function call_voila_api()
{
 $.getJSON(api_path+"/get_customizer_api.php",shop_data, function(api_data) 
 { 
      entire_gloabal_api_data=api_data;
      if (shop_domain=='salesify-demo.myshopify.com')
      {
        //auto_discount_code='welcome10';
      }
      if (shop_domain=='buy-wow-health.myshopify.com')
      {
        //auto_discount_code='WOWFEST';
      }
      if (shop_domain=='tulip-storage.myshopify.com')
      {
        auto_discount_code='WEEKENDOFF';
      }

      

   
      
      settimeout_maina_apidata(api_data);
 });
 /*$.ajax({
   type: 'GET',
   url: api_path+"/get_customizer_api.php?shop_domain="+ shop_domain ,
   dataType: 'json',
 
   success: function(api_data){
     settimeout_maina_apidata(api_data);
   
   },
  error: function (request, status, error) {
     alert(request.responseText);
 }
});*/



}
$(document).ready(function() {
 $.ajaxSetup({ cache: false });
});
function settimeout_maina_apidata(api_data)
{
  let make_slow_stores=['theformularx-2.myshopify.com'];
  if (make_slow_stores.includes(shop_domain))
  {
    setTimeout(() => {
      main_data_call(api_data);
    }, 1000);
  }
 else if (shop_domain=='byaffya.myshopify.com')
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
 }
 else if (shop_domain=='jhakhasethnics.myshopify.com')
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 2000);
 }
 else if(Shopify.shop == "valentina-rio.myshopify.com")
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
 }
 else  if (shop_domain=='bsc-women.myshopify.com')
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
 }
  else if (shop_domain=='smartivity-in.myshopify.com')
   {
        setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
   }
 else  if (shop_domain=='natvral.myshopify.com')
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
 } 
 else  if (shop_domain=='quecy-com.myshopify.com')
 {
     setTimeout(() => {
       main_data_call(api_data);
     }, 1000);
 }
 else{
   if ((shop_domain=='beautyboxok.myshopify.com'))
   {
     if (page!='cart')
     {
       return;
     }
     
   }
   main_data_call(api_data);
 }

}
intiate_analytycs();
/* prepare functions */
if (shop_domain=='ldu-letsdressup.myshopify.com')
{
  setTimeout(() => {
    $('body').on('click',".discountify_modal .discountify_popup_close", function (e) { e.preventDefault(); $(".discountify_modal").remove(); open_mini_cart_drw(false); });
    $('body').on('click',".discpon_wrap .discpon_close", function (e) { e.preventDefault(); $(".discpon_wrap").remove(); open_mini_cart_drw(false); });
    $('body').on('click',".discountify_snackbar .action_close", function (e) { e.preventDefault(); $(".discountify_snackbar").remove(); });
   
  }, 300);
}
else{
  $('body').on('click',".discountify_modal .discountify_popup_close", function (e) { e.preventDefault(); $(".discountify_modal").remove(); open_mini_cart_drw(false); });
  $('body').on('click',".discpon_wrap .discpon_close", function (e) { e.preventDefault(); $(".discpon_wrap").remove(); open_mini_cart_drw(false); });
  $('body').on('click',".discountify_snackbar .action_close", function (e) { e.preventDefault(); $(".discountify_snackbar").remove(); });
 

}
  var $chkboxes = $('.coupon_check');
  
  $('body').on('click',".coupon_check", function (e) {
            
     $('.discountify_error').html('&nbsp;');   
     $('.discountify_error').hide(); 
   // $('.apply_voucher_btn').attr("disabled", true);
   $('div.coupon_grid').removeClass('slected_grid');
   if ($(this).is(':checked')) {
     $(this).parents('div.coupon_grid').addClass('slected_grid');
   }   
  

 });

 function open_mini_cart_drw(isfromcookie)
  {
    if(isfromcookie==true)
    {
      return;
    }
    if (shop_domain=='buy-wow-health.myshopify.com')
    {
      if(page !== 'cart')
       {
        if($('#CartDrawer').hasClass('drawer--is-open'))
        {
          return;
        }
        else{
          if ($('.js-drawer-open-cart').length>0)
           {
             setTimeout((function() {  $('.js-drawer-open-cart')[0].click();  }
             ), 10);
           }
          return;
        }
        
      }
      return;
    }
    if (shop_domain=='aastey.myshopify.com')
    {
      if(page !== 'cart')
       {
        $("#HeaderCartTrigger")[0].click();
        
      }
      return;
    }

    if (shop_domain=='masori.myshopify.com')
    {
      if(page !== 'cart')
       {
        $("#js-drawer-open-cart")[0].click();
        
      }
      return;
    }


    if (shop_domain=='the-amyra-store.myshopify.com')
    {
      if(page !== 'cart')
       {
        $(".Header__FlexItem").find(`[data-drawer-id='sidebar-cart']`)[0].click();
        
      }
      return;
    }

    if (shop_domain=='rad-mad-bad.myshopify.com')
    {
      if(page !== 'cart')
       {
          if ($('#HeaderCartTrigger').length>0)
          {
            setTimeout((function() {  $('#HeaderCartTrigger')[0].click();  }
            ), 10);
          }
      }
      return;
    }
       if(page !== 'cart')
       {
             
           if ($('.js-drawer-open-cart').length>0)
           {
             setTimeout((function() {  $('.js-drawer-open-cart')[0].click();  }
             ), 10);
           }
         
           if (relish_shops.includes(shop_domain))
           {
             $('a[href$="/cart"]')[0].click();
           }
       }
  }

 $('body').on('click',".coupon_grid", function (e) {
            
 e.preventDefault();
 e.stopPropagation();
   $(this).find('.coupon_check').prop("checked", true);

});
  
 function attach_coupon_row_click()
 {
   $('.coupon_grid').on('click',function(){
    
   })
 }
 function process_discount_main_home(e)
 {
  const discnt_cookie_abc = JSON.parse(getWithExpiry("dscnt_cookie"));
  let active_coupon_abc=''; 
  if(discnt_cookie_abc !== null){ 
      e.preventDefault();
  active_coupon_abc = discnt_cookie_abc.couponData.title;
  active_coupon_abc=active_coupon_abc.replace('%','%25');
      $.ajax({
        type: 'GET',
        url: '/discount/'+discnt_cookie_abc.couponData.title,
        dataType: 'text',
        async:false,
        success: function(response){
         
          window.location.replace('/checkout');
          return;
        }
      });
  }
  else{
    window.location.replace('/checkout');
    return;
  }
  
 }

  function process_to_checkout(e){
    if ( (shop_domain =='uncomplicated-clothing.myshopify.com'))
    {
      e.preventDefault();
        process_discount_main_home(e);
        return;
    }
    if ( (shop_domain =='tbf-india.myshopify.com'))
    {
        return;
    }
    if ( 
         (shop_domain =='buy-wow-health.myshopify.com')
      )
    {

      const discnt_cookie_abc = JSON.parse(getWithExpiry("dscnt_cookie")); 
      if(discnt_cookie_abc !== null){ 
          e.preventDefault();
      let active_coupon_abc = discnt_cookie_abc.couponData.title;
      active_coupon_abc=active_coupon_abc.replace('%','%25');
        update_coupon_analytics_checkout(active_coupon_abc);
         var chckout_url = "/checkout/?discount="+active_coupon_abc;
         // window.location.replace(chckout_url);
         // return;
      }
       
        
     window.location.replace('/checkout');
      return;
    }
  if ( (shop_domain=='nitya-for-estelle.myshopify.com')||
    (shop_domain=='odetstyle.myshopify.com')
  
      )
  {
    e.preventDefault();
    window.location.replace('/checkout');
    return;
  }
   if ( (shop_domain=='ldu-letsdressup-staging.myshopify.com')||
      (shop_domain =='ldu-letsdressup.myshopify.com') ||
      (shop_domain =='buy-wow-health.myshopify.com')
    )
    {
      return;
    }
   var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie")); 
   if(discnt_cookie !== null){ 
         e.preventDefault();
     var active_coupon = discnt_cookie.couponData.title;
         active_coupon=active_coupon.replace('%','%25');
       update_coupon_analytics_checkout(active_coupon);
     var chckout_url = "/checkout/?discount="+active_coupon;
     if (Shopify.shop == "whiskdom.myshopify.com")
     {
         if(  $('#date-delivery').val()=='')
         {
             return;
         }
         else{
             chckout_url = "/checkout/?shipping_address][address1]=&checkout[shipping_address][address2]=&checkout[shipping_address][city]=&checkout[shipping_address][company]=&checkout[shipping_address][country]=Singapore&checkout[shipping_address][province]=Singapore&checkout[shipping_address][zip]=159971&locale=en-SCALD&method=delivery&step=contact_information&discount="+active_coupon;
         }
     }
     window.location.replace(chckout_url);
   }
   else{
     var direc_cheout_shops=['bsc-women.myshopify.com','zeropiu-store.myshopify.com']
     if (direc_cheout_shops.includes(shop_domain))
     {
       window.location.replace('/checkout');
       return;
     }
     if(  mouse_down_check_outs.includes(Shopify.shop))  
     {
       $('[name="checkout"]').click();
     }
     else{
       window.location.replace('/checkout');
       return;
     }
   }
 }
 function remove_style()
 {
    $(".discountify_aply_voucher").css({width:"100%" });
 }
 function calculate_discounts(cpn_data, msgcpn_body='',isfrom_popup=1,is_from_cookie=0){
   var today_date = Date.parse(cuurentUTC());
   var cpn_starts = Date.parse(cpn_data.starts_at_UTC);
   var cpn_ends = Date.parse(cpn_data.ends_at_UTC);
   var cpn_title = "`"+cpn_data.title.toUpperCase()+"`";
   ori_cpn_title=cpn_data.title.toUpperCase();
  // if((today_date > cpn_starts)  && (today_date < cpn_ends)){
   $.getJSON('/cart.js', function(cart) { 
    
     cart_token=cart.token;
    
    var ajx_popup = document.getElementById("discountify_modal");      
    var cart_price = (Math.round(cart.total_price) / 100).toFixed(2);
    total_cart_price_disp=cart_price;
    var cal_price = '';
    var discount_price='';
    var mcart_price = '';
    var mcart_qty = '';
    var type = '';
    var cart_items = new Array();
    var RESPONSE = new Array();
    var applied_product = cpn_data.entitled_product_ids;
    var appled_collection = cpn_data.entitled_collection_ids;
    var price_range = cpn_data.prerequisite_subtotal_range; 
    var qnt_range = cpn_data.prerequisite_quantity_range;
    var buyxy_product = cpn_data.prerequisite_product_ids;
    var shopify_money_format = discountify_store_currency(Shopify.currency.active)+" ";
    var cart_item_count = cart.item_count;
    var cpn_type = cpn_data.value_type;
    if(cpn_type == "percentage"){
         type = "PERCENTAGE";
     } else if(cpn_type == "fixed_amount"){
         type = "FIXED";
     } 
     
    $.each(cart.items, function(i, v) { cart_items.push(cart.items[i].product_id); });
    if(cart_price > 0){ 
      if (cpn_data.is_custom_bogo==1)
      {
       RESPONSE.push({
         type: "BUY-XY", 
         discount:  0,
         payble_subtotal:  "",
         cart_total:  cart_price,
       });
       calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);

      }
     else if(buyxy_product.length > 0){
         RESPONSE.push({
           type: "BUY-XY", 
           discount:  0,
           payble_subtotal:  "",
           cart_total:  cart_price,
         });
         calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);
                 
     } else if(applied_product.length > 0){ 
          var check_product = applied_product.some((val) => cart_items.indexOf(val) !== -1);
          if(check_product == false){
              remove_style();
           change_pop_button_style();
              $(".apply_voucher_btn").html(voucher_btntxt);
              $(".discountify_aply_voucher").html(cpn_btntxt);
              discountify_snackbar("ERROR",""+cpn_title+" "+ cpn_popup_not_valid_to_itm_err);
              return false;
          } else { 
             var mcart_price = 0;
             var mcart_qty = 0;
             $.each(applied_product, function(ck,cv) { 
                 var check_exist = cart.items.filter(check => (check.product_id === cv));
                 if(check_exist.length > 0){
                     var parr = check_exist[0];
                     mcart_price += parr.line_price; 
                     mcart_qty += parr.quantity;
                 }
             });
             var price_t = (Math.round(mcart_price) / 100).toFixed(2);
             var qty_t = mcart_qty;
             if(price_range != null){ 
                 var range_price = parseFloat(price_range.greater_than_or_equal_to); 
                 if( price_t < range_price){
                     
                    discountify_snackbar("ERROR",cpn_popup_itm_amnt_insufnt_err);
                     remove_style();
                    $(".discountify_aply_voucher").html(cpn_btntxt);
                    
                    change_pop_button_style();
                    $(".apply_voucher_btn").html(voucher_btntxt);
                    return false;
                 }
             } else if(qnt_range != null){ 
                 var range_qty = qnt_range.greater_than_or_equal_to; 
                 if(qty_t < range_qty){
                     discountify_snackbar("ERROR",cpn_min_quantity_err);
                      remove_style();
                     $(".discountify_aply_voucher").html(cpn_btntxt);
                     change_pop_button_style();
                     $(".apply_voucher_btn").html(voucher_btntxt);
                         return false;
                 }
             } 
             if(type == "PERCENTAGE") { 
                 cal_price = (parseInt(cpn_data.value.replace(/-/g, ""))/100)*price_t;
                 RESPONSE.push({
                     type: "PERCENT", 
                     discount:  cal_price,
                     payble_subtotal:  cart_price - cal_price,
                     cart_total:  cart_price,
                 });
                 calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);
            } else if(type == "FIXED"){ 
                 cal_price = parseFloat(cpn_data.value.replace(/-/g, ""));
                 RESPONSE.push({
                     type: "PERCENT", 
                     discount:  cal_price,
                     payble_subtotal:  cart_price - cal_price,
                     cart_total:  cart_price,
                 });
                 calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);
             }
          }
     } else { 
         if(price_range != null){ 
             var range_price = parseFloat(price_range.greater_than_or_equal_to); 
             if( cart_price < range_price){
                discountify_snackbar("ERROR",cpn_popup_itm_amnt_insufnt_err);
                $(".discountify_aply_voucher").html(cpn_btntxt);
                 remove_style();
                change_pop_button_style();
                $(".apply_voucher_btn").html(voucher_btntxt);
                return false;
             } 
         } else if(qnt_range != null){ 
             var range_qty = qnt_range.greater_than_or_equal_to; 
             if(cart_item_count < range_qty){
                 discountify_snackbar("ERROR",cpn_min_quantity_err);
                  remove_style();
                 $(".discountify_aply_voucher").html(cpn_btntxt);
                 change_pop_button_style();
                 $(".apply_voucher_btn").html(voucher_btntxt);
                 return false;
             }
         } 
         if(type == "PERCENTAGE") { 
             cal_price = (parseInt(cpn_data.value.replace(/-/g, ""))/100)*cart_price;
             RESPONSE.push({
                 type: "PERCENT", 
                 discount:  cal_price,
                 payble_subtotal:  cart_price - cal_price,
                 cart_total:  cart_price,
             });
             calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);
         } else if(type == "FIXED"){ 
             cal_price = parseFloat(cpn_data.value.replace(/-/g, ""));
             RESPONSE.push({
                 type: "PERCENT", 
                 discount:  cal_price,
                 payble_subtotal:  cart_price - cal_price,
                 cart_total:  cart_price,
             });
             calculate_popup(RESPONSE,cpn_data,msgcpn_body,isfrom_popup,is_from_cookie);
         }
     }
    }
    });
  /* } else { 
     discountify_snackbar("ERROR",""+cpn_title+" discount code has been expired");
     localStorage.removeItem("dscnt_cookie");
     return false;
   }*/
 }
function bombay_total(isShow)
{
  if (shop_domain=='bombay-shaving.myshopify.com')
  {
    if (isShow==1)
    {
      $('div.ms-voila-cart').show();
    }
    else{
     $('div.ms-voila-cart').hide();
    }
  }
}
function delete_cookie(name) {
  try{
    document.cookie = "discount_code=;Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = "discount_code=;Path=/products; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
  catch(ex)
  {

  }
  
 
}
function removentAttach()
{
  delete_cookie('discount_code');
  let disCountAppliedEventStores=['bloomdevelop.myshopify.com',
  'pure-home-living-gh.myshopify.com','pflands-com.myshopify.com'];
  if (true)
  {
     const disCountRemovedEvent = new CustomEvent('disCountRemovedEvent',{
       detail:{
           
        }
     } );
     document.dispatchEvent(disCountRemovedEvent);
  }
}
function call_checkout_as_api()
{

  $.ajax({
    type: 'GET',
    url: '/checkout',
    dataType: 'text',
    async:true,
    success: function(response){
   
    }
  });
}

function remove_discount_code()
{
  $.ajax({
    type: 'GET',
    url: '/discount/+',
    dataType: 'text',
    async:true,
    success: function(response){
    delete_cookie('');
    let api_call_check_urls=['whats-up-wellness.myshopify.com','ease2dayy.myshopify.com']
     if (api_call_check_urls.includes(shop_domain))
     {
      call_checkout_as_api();
      return;
     }
      window.location.replace('/checkout');
      return;
    }
  });
}
 $('body').on('click',".discountify_tag button.cpn_tag_close", function (e) {
   

     
  e.preventDefault();
  e.stopPropagation();
  removing_coupon_complete(false);

 });
 function removing_coupon_complete(isLoading)
 {
    localStorage.removeItem("dscnt_cookie");
    let discount_cookie_remove_stroes=['whats-up-wellness.myshopify.com','swastik-pooja.myshopify.com','ease2dayy.myshopify.com','e9ffa3.myshopify.com']
    if (discount_cookie_remove_stroes.includes(shop_domain))
    {
      var c_coupon_code='';
    
     remove_discount_code();
     delete_cookie('');
    }
    if (shop_domain=='edrio-india.myshopify.com')
     {
       $('.total').show();
     }
 
    if (shop_domain=='artemis-aparels.myshopify.com')
      {
        $('.cart-cost').find('.money').text( $('.spn_fin_subtot').text());
      }
 
      if (shop_domain=='vw-vanity-wagon.myshopify.com')
      {
        $('.saso-cart-original-total').find('.money').text( $('.spn_fin_subtot').text());
      }
      if (shop_domain=='tatasimplybetter.myshopify.com')
      {
         if (page=='cart')
         {
           if ($('.cart__total__money').length>=1)
           {
             $('.cart__total__money').text($('.spn_fin_subtot').text())
           }
         }
         
         if ( $('.cart__total__money').find('strong').length>=2)
         {
           $($('.cart__total__money').find('strong')[1]).text( $('.spn_fin_subtot').text());
         }
         else{
           if ( $('.drawer-subtotal').find('.cart__total__money').length==1)
           {
             $('.drawer-subtotal').find('.cart__total__money').text( $('.spn_fin_subtot').text());
           }
         }
        
       
      }
    $('.discountify_tag').remove();
    $('.discountify_status_msg').hide();
    bombay_total(1);
    $("body").find(".discountApplied").remove();
    if (feat_cart_cpn_status=='on')
    {
      
      $("body").find(".discountify_manual_wrap").removeClass('main_cpn_hide');
      $("body").find(".discountify_manual_wrap").show();
      $('.dscnt_manual_field').val('');
      $($('.ms_vl_rd_change')[1]).prop("checked", true);
    }
    hideElements(false);
    $('.discountify_fourth_tag').show();
    open_mini_cart_drw(isLoading);
    removentAttach();
 
 }

 function cpn_delete()
 {
  $('body').on('click',".discountify_tag button.cpn_tag_close", function (e) {
    
    e.preventDefault();
    e.stopPropagation();
    $('.savings_price').find('span').html(' ₹ 0.00');
    $('.total').find('.money').html($('.sub').find('.money').html());
     localStorage.removeItem("dscnt_cookie");
     let c_coupon_code='';
     document.cookie = "discount_code="+c_coupon_code;
     
     $('.discountify_tag').remove();
     $('.discountify_status_msg').hide();
    
     $("body").find(".discountApplied").remove();
     
     hideElements(false);
    
     open_mini_cart_drw(false);
   
  
   });
 }
  function check_coupon_code(coupon_code)
 {
  
  let no_need_stores=['uncomplicated-clothing.myshopify.com'];
  if (no_need_stores.includes(shop_domain))
  {
    console.log('revalidated stopped');
    return;
  }
  if ( (shop_domain=='ldu-letsdressup-staging.myshopify.com')|| 
      (shop_domain=='ldu-letsdressup.myshopify.com') 
    )
  {
      console.log('started discount rev')
      coupon_code=coupon_code.replace('%','%25');
  }
  
   var chckout_url = "/checkout/?discount="+coupon_code;
   if ((actual_check_out_url== undefined))
   {
     actual_check_out_url='';
   }
   if (shop_domain=='fancy-fluff-india.myshopify.com')
    {
      actual_check_out_url='';
    }
   if (shop_domain=='salvationteas.myshopify.com')
   {
    console.log('salvationteas.myshopify.com enter reval')
   }
   if (actual_check_out_url=='') 
   {
     $.ajax({
       type: 'POST',
       url: chckout_url,
       dataType: 'text',
       async:true,
       success: function(response)
       {
        
        if (shop_domain=='fancy-fluff-india.myshopify.com')
        {
          console.log('checking codess...');
          let graph_ql=$(response).find('div').attr('data-serialized-value');
          console.log(graph_ql);
        }
        if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
        {
            console.log(response)
        }
          actual_check_out_url= $(response).find('.edit_checkout').attr( 'action' );
          if (fourth_stores.includes(shop_domain))
          {
             var expres_check_buttext=$(response).find('.dynamic-checkout__content');
             if (expres_check_buttext.length>0)
             {
               console.log($(expres_check_buttext[0]).html());
               //$('.dynamic-checkout__content').html($(expres_check_buttext[0]).html());
             }

          }
        
       }
        
     });

   }
   else{
    if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
    {
        console.log('Else statemnt')
    }
     $.ajax({
       type: 'get',
       url: actual_check_out_url+"?discount="+coupon_code,
       dataType: 'text',
       async:true,
       success: function(response)
       {
        if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
        {
            console.log('Else statemnt success')
        }
         if (fourth_stores.includes(shop_domain))
          {
             var expres_check_buttext=$(response).find('.dynamic-checkout__content');
             if (expres_check_buttext.length>0)
             {
              // console.log($(expres_check_buttext[0]).html());
              // $('.dynamic-checkout__content').html($(expres_check_buttext[0]).html());
             }
             

          }
         
       }
        
     });
   }
   
  
 }
 

 function check_coupon_applie_or_not(coupon_code,json_cart_array)
 {
    return new Promise(function(resolve, reject) {
   var is_applicable=false;
  
  var w_data= '{"checkout":{"discount_code":"'+coupon_code+'","line_items":'+ JSON.stringify(json_cart_array)+'}}';
  const authorization_header_value = 'Basic ' + btoa(sh_acc_token);
   $.ajax({
     type: "post",
     headers: {
       'Authorization':authorization_header_value,
       
       'Content-Type':'application/json'
   },
     url: window.location.origin+"/wallets/checkouts/",
     data:w_data,
     dataType: 'json',
     async:true,
     success: function(response){
       
         var c_app_obje=response['checkout']['applied_discount'];
         if (c_app_obje['applicable']==true)
         {
           if (response.checkout.discount_violations.length>0)
           {
              if (response.checkout.discount_violations[0].applicable===false)
              {
                  resolve(false);
              }
           }
           is_applicable=true;
           resolve( true);
         }
         else{
          resolve(false);
         }
       },
       error: function(response)
       {
        resolve(false);
       }
     });
    });
  
 }
 
 function keysrt(key) {
   return function(a,b){
    if (a[key] > b[key]) return 1;
    if (a[key] < b[key]) return -1;
    return 0;
   }
 }
 function change_currency_copon_description(coupon_meta_in)
 {
    if (coupon_meta_in.indexOf("{{voila_price")>0)
    {
      try{

        let pric_split =coupon_meta_in.split("{{voila_price_");
        if (pric_split.length>1)
        {
            let se_split_price=pric_split[1].split("}}");
            let price=parseFloat(se_split_price[0]);
            let cu_rate=parseFloat(Shopify.currency.rate);
            let fin_pop_price=Math.round(price*cu_rate);
            let amount_replace_text="{{voila_price_"+price +"}}" ;
            coupon_meta_in= coupon_meta_in.replace(amount_replace_text ,  fin_pop_price);
        }
      }
      catch(ex)
      {

      }

    }
    coupon_meta_in= coupon_meta_in.replace("{{voila_currency}}" ,  discountify_store_currency(Shopify.currency.active));
    return coupon_meta_in;
  }
 async function  check_applicable_coupons(local_cpn_data,current_cart_itmes)
 {

   var valid_coupon='';
   coupons_check_count=0;
   local_cpn_data.sort(keysrt('order_by'));
   let start = Date.now();

 const promises = [];
  for (let i = 0; i < local_cpn_data.length; i++) {
    // Don't await the promise here, just start it and add it to the array.
    promises.push( check_coupon_applie_or_not(local_cpn_data[i].title,current_cart_itmes));
  }
let result=[];
   await Promise.all(promises).then(function(values) {
  result=values;
   
      let timeTaken = Date.now() - start;

}).catch(function(reason) {
   console.log('prom failes')
    console.log(reason);
});
 console.log('hello',result)

    for (var i=0; i < local_cpn_data.length; i++) {
       let v_stauts=  result[i];
      local_cpn_data[i].is_cpn_valid=v_stauts;
      if (v_stauts==true)
      {
         valid_coupon  =local_cpn_data[i].title;
      }
    }
  /* for (var i=0; i < local_cpn_data.length; i++) {
     var v_stauts=   check_coupon_applie_or_not(local_cpn_data[i].title,current_cart_itmes);
     local_cpn_data[i].is_cpn_valid=v_stauts;
      if (v_stauts==true)
      {
         valid_coupon  =local_cpn_data[i].title;
      }
     
   }*/
  
   //check_coupon_code('+');
   local_cpn_data.sort(function(x, y) {
     // true values first
     if (y.is_cpn_valid==false)
     {
       return -1;
     }
     return 1;
     // false values first
     // return (x === y)? 0 : x? 1 : -1;
 });
 
   cpn_data=local_cpn_data;
   var avl_coupons='';
   var invalid_style='';
   for (var i=0; i < cpn_data.length; i++) {
   
     var coupon_title = cpn_data[i].title; 
     var coupon_id = cpn_data[i].id;
     var coupon_meta = cpn_data[i].meta;
     coupon_meta= change_currency_copon_description(coupon_meta);
     var terms_htm='';
     invalid_style='';
     if (cpn_data[i].is_cpn_valid===false)
     {
       invalid_style='pointer-events: none;opacity: 0.6;'
     }
     if ( cpn_data[i].is_terms_enable=="on")
     {
      terms_htm="<div style='text-align:right !important;color:blue !important;' class=\"coupon_description\">\
                <a style='font-size:15px !important;text-align:right !important;color:"+  cpn_data[i].terms_txt_color +" !important' target='_blank' href='"+ cpn_data[i].terms_url+"'>"+cpn_data[i].terms_txt+"</a></div>";

     }
     var ra_opacity=''
     var condtion_prepare=` data-show-condition="${cpn_data[i].show_on_condition}" 
     data-condition-type="${cpn_data[i].condition_type}"
     data-condition-value="${cpn_data[i].con_value}" `;
    
  
     coupon_meta= change_currency_copon_description(coupon_meta);
     avl_coupons +="<div " + condtion_prepare +" style='"+invalid_style +"' class=\"grid_row coupon_grid\">\
                        <div class=\"grid_col span_1_of_3\">\
                          <div class=\"coupon_title_wrap\" style=\"border:none;\">\
                            <label class=\"check_label_vl \"><input style='" +ra_opacity+ "' type=\"radio\" class=\"coupon_check\" name=\"coupon_id\" value="+coupon_id+" data-coupon='"+coupon_title+"'>\
                            <span class=\" check_vl \"></span>\
                            <span class=\"coupon_title\">"+coupon_title+"</span>\
                            </label>\
                          </div>\
                        </div>\
                        <div class=\"grid_col span_2_of_3\">\
                          <div class=\"coupon_description\">"+coupon_meta+"</div>"+ terms_htm+
                        "</div>\
                      </div>";
    }
  
 return avl_coupons;

 }
 function get_cart_line_details()
 {
   var json_cart_array=[];
   $.ajax({
     type: "get",
    
     url: window.location.origin+"/cart.js",
    
     dataType: 'json',
     async:false,
     success: function(response){
       if (response.items.length>0)
       {
           
           
           for(var i=0;i<response.items.length;i++)
           {
               var json_cart={};
               cart_currency_code=response.currency;
               cart_items_subtotal_price=response.items_subtotal_price/100;
               json_cart.variant_id=response.items[i].variant_id;
               json_cart.quantity=response.items[i].quantity;
               json_cart_array.push(json_cart);
           }
         }}
       });

       return json_cart_array;
 }
 function set_popup_height()
 {
  var divInner =  $('body').find('.discountify_pop_body').outerHeight();
  
    $('.discountify_modal_content').css('height', divInner+90+45+'px');
 }
 async function cpns_enable_disable(api_path,shop_data,api_data)
 {

   if (popup_coupons_enb_dis=='on')
   {
     var current_cart_itmes= get_cart_line_details();
     if (current_cart_itmes.length>0)
     {
       avl_coupons=await check_applicable_coupons(global_cpns_list,current_cart_itmes);
     

       coupon_count=global_cpns_list.length;
       $('body').find('.discountify_pop_body').html(avl_coupons);
     
       if(avl_status == "on")
       { 
          if(coupon_count > 0 && coupon_count == 1) { 
               replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
               $('.coupon_check').prop('checked',true);
             
          } else { 
               replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
          }
             if(check_plan(api_data)==true)
             {
                 if ((shop_domain=='xaestheticnation.myshopify.com')||(shop_domain=='dilli999.myshopify.com'))
                 {
                 /* var ae_html='<span style="color:#ff6600">'+coupon_count + ' COUPONS </span>' +
                             '<span style="color:black">AVAILABLE</span>' ;
                   coupon_body +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"
                   +apply_logo+"<span class=\"show_availablity\" style="+avl_txtcolor+avl_txtsize+">"
                   +ae_html+"</span></a>";
                   $('.show_availablity').text(ae_html);*/
                 }
                 else if (fourth_stores.includes(shop_domain))
                 {
   
                 }
                 else{
                   $('.show_availablity').text(replace_avail);
   
                 }
             }
       }
     

     }
     
   }
  return avl_coupons;
 }
 async function prepare_coupon_popup(api_path,shop_data,api_data)
 {
   avl_coupons='';
   if (global_cpns_list.length>0)
   {
   avl_coupons= await cpns_enable_disable(api_path,shop_data,api_data);
     return;
   }
   if (api_data['coupons_list'].length==0)
   {
     return;
   }
     cpn_data=api_data['coupons_list'];
     global_cpns_list=cpn_data;
     if (popup_coupons_enb_dis=='on')
     {
       var current_cart_itmes= get_cart_line_details();
       if (current_cart_itmes.length>0)
       {
         avl_coupons=await check_applicable_coupons(data,current_cart_itmes)
        
       }
       
     }
     else{
       for (var i=0; i < cpn_data.length; i++) {
   
         var coupon_title = cpn_data[i].title; 
         var coupon_id = cpn_data[i].id;
         var coupon_meta = cpn_data[i].meta;
         coupon_meta= change_currency_copon_description(coupon_meta);
         var terms_htm='';
         if ( cpn_data[i].is_terms_enable=="on")
         {
          terms_htm="<div style='text-align:right !important;color:blue !important' class=\"coupon_description\">\
                    <a style='font-size:15px !important;text-align:right !important;color:"+  cpn_data[i].terms_txt_color +" !important' target='_blank' href='"+ cpn_data[i].terms_url+"'>"+cpn_data[i].terms_txt+"</a></div>";
    
         }
         var ra_opacity=''
       
         var condtion_prepare=` data-show-condition="${cpn_data[i].show_on_condition}" 
                               data-condition-type="${cpn_data[i].condition_type}"
                               data-condition-value="${cpn_data[i].con_value}" `;
         avl_coupons +="<div class=\"grid_row coupon_grid\" " + condtion_prepare+ ">\
                            <div class=\"grid_col span_1_of_3\">\
                              <div class=\"coupon_title_wrap\" style=\"border:none;\">\
                                <label class=\"check_label_vl \"><input style='" +ra_opacity+ "' type=\"radio\" class=\"coupon_check\" name=\"coupon_id\" value="+coupon_id+" data-coupon='"+coupon_title+"'>\
                                <span class=\" check_vl \"></span>\
                                <span class=\"coupon_title\">"+coupon_title+"</span>\
                                </label>\
                              </div>\
                            </div>\
                            <div class=\"grid_col span_2_of_3\">\
                              <div class=\"coupon_description\">"+coupon_meta+"</div>"+ terms_htm+
                            "</div>\
                          </div>";
        }
     }
   
   coupon_count=cpn_data.length;
   
   display_popup_cpns_based_on_conditions(0);
   if(avl_status == "on")
   { 
      if(coupon_count > 0 && coupon_count == 1) { 
           replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
           $('.coupon_check').prop('checked',true);
         
      } else { 
           replace_avail = avl_text.replace("[available coupons]",coupon_count+" ");
      }
         if(check_plan(api_data)==true)
         {
             if ((shop_domain=='xaestheticnation.myshopify.com')||(shop_domain=='dilli999.myshopify.com'))
             {
             /* var ae_html='<span style="color:#ff6600">'+coupon_count + ' COUPONS </span>' +
                         '<span style="color:black">AVAILABLE</span>' ;
               coupon_body +="<a href='#' class='discountify_discount_apply_popup dscnt_availability'>"
               +apply_logo+"<span class=\"show_availablity\" style="+avl_txtcolor+avl_txtsize+">"
               +ae_html+"</span></a>";
               $('.show_availablity').text(ae_html);*/
             }
             else if (fourth_stores.includes(shop_domain))
             {

             }
             else{
               $('.show_availablity').text(replace_avail);

             }
         }
   }
 
 
 }
 function check_plan(api_data)
 {
   if (api_data['charge_details'].plan_id>=6)
   {
     return true;

   }
     if ((api_data['charge_details'].plan_price==0)||(api_data['charge_details'].plan_price==2.99))
     {
       return false;
     }
     else{
       return true;
     }
 }
 
 function change_pop_button_style()
 {
     //$(".apply_voucher_btn").removeAttr("style");
     $(".apply_voucher_btn").css("width","");
 }
 function calculate_popup(RESPONSE,cpn_data,msgcpn_body='',isfrom_popup,is_from_cookie=false){
      var ajx_popup = document.getElementById("discountify_modal");      
      var shopify_money_format = discountify_store_currency(Shopify.currency.active);
      var coupon_tag ="";
      var coupon_dscnt = "";
      var coupon_title = cpn_data.title.toUpperCase();
      var discnt_val=0;
      
     
    
          discnt_val=revlaidate_coupon_code(coupon_title,false);
      
        
      if (discnt_val <= 0)
      { remove_style();
       change_pop_button_style();
               $(".apply_voucher_btn").html(voucher_btntxt);
               $(".discountify_aply_voucher").html(cpn_btntxt);

               if (discnt_val==-1)
               {
                 discountify_snackbar("ERROR",cpn_invld_err);
               }
               else if (discnt_val==0)
               {
                 discountify_snackbar("ERROR",cpn_not_applicable);
               }
           // discountify_snackbar("ERROR","Not applicable");
        return;
      }
      var is_total_calucat_req=1;
      var tmp_pop_applied_suc_text=pop_applied_suc_text.replace("[Coupon Code]","`"+coupon_title+"`");
     if(RESPONSE.length > 0){
         var RESP =  RESPONSE[0];
         //var t_discount = RESP.discount;
           var t_discount = discnt_val;
         var cart_subtotal = RESP.cart_total;
         var discount_round = t_discount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
         discount_round=my_money_format.formatMoney(discount_round,currency_format);
         if(cart_subtotal == t_discount ) { 
           is_total_calucat_req=0;
             $(".discpon_wrap").remove();
             coupon_dscnt = free_shipping_text;
             if(msgcpn_body){ $('body').append(msgcpn_body); }
             $('.discpon_applied').text(tmp_pop_applied_suc_text);
             $('.discpon_price_pt').text(free_shipping_text);
             $('.discpon_price_pt').css({"font-size":"30px", "margin-bottom":"15px"});
             $('.discpon_price_txt').hide();
             $('.discpon_success').text("You have availed Free shipping");
             $(ajx_popup).remove();     
               coupon_title=coupon_title.replace('%','%25');
             $('.discpon_btn').attr('href','/checkout?discount='+coupon_title+'');
             
        } else { 
         
             $(".discpon_wrap").remove();
             coupon_dscnt = "- "+shopify_money_format+""+discount_round;
             if(msgcpn_body){ $('body').append(msgcpn_body); }
             $('.discpon_applied').text(tmp_pop_applied_suc_text);
             $('.discpon_price_pt').text(shopify_money_format+""+discount_round);
             $('.discpon_success').text("Discount is calculated at checkout");
             $(ajx_popup).remove(); 
               coupon_title=coupon_title.replace('%','%25');
             $('.discpon_btn').attr('href','/checkout?discount='+coupon_title+'');
        }
         localStorage.removeItem("dscnt_cookie");
         var dscnt_cookie = {"shop": Shopify.shop, "couponData":cpn_data, "couponID":cpn_data.id}; 
         setWithExpiry('dscnt_cookie', JSON.stringify(dscnt_cookie));
         var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie"));
         if(discnt_cookie !== null){ 
           setTimeout(() => {
             update_coupon_analytics(isfrom_popup,coupon_title);
           }, 2);
         
             coupon_tag +="<div class=\"discountify_tag\">"+
             "<span class=\"cpn_tag \">"+
                 "<span class=\"cpn_tag_wrap\">"+
                   "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" class=\"cpn_tag_label\">"+
                   "<path d=\"M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z\" fillopacity=\".55\"></path><path d=\"M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z\"></path></svg>"+
                   "<span class=\"cpn_title\">"+ori_cpn_title+"</span>"+
                   "<span class=\"cpn_dcnt_price\">"+coupon_dscnt+"</span>"+
                   "<button type=\"button\" class=\"cpn_tag_close\">✕</button>"+
                 "</span>"+
             "</span>";
             if (is_total_details==1)
             {
               var dis_text_spl=discount_cstm_txt;
               if(Shopify.shop == "watchdropmx.myshopify.com") { 
                 dis_text_spl='Descuento';
               }
               var totl_width= $('.discountify_manual').width();
               if (totl_width==null)
               {
                totl_width="100%";
               }
               else{
                 if (totl_width<300)
                 {
                   totl_width=300;
                 }
                totl_width=totl_width+"px";
               }
             
               if (right_left_stores.includes(shop_domain))
               {
               
                 coupon_tag += "<span class='div_tbl_tot ' style='max-width:300px !important; text-align:left;display: inline-block;width:"+ totl_width+ "'>"+
                 "<div class='dis_tot'     style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>"+
                   dis_text_spl+" <br/><span class='cpn_dcnt_price' style='background-color: rgba(113, 113, 113, .11);padding: 4px;border-radius: 4px;line-height: 20px;margin-left:0px !important'>"+
                  "<span>"+ori_cpn_title +"</span>"+
                 "<button type=\"button\" class=\"cpn_tag_close\" style='font-weight:600;font-size:12px !important;cursor:pointer'>✕</button>"+
                 "</span>"+
                 "</div>"+
                 "<div class='spn_dis_dt'  style='padding-top: 7px;text-align:right;font-weight:600;font-size:16px !important;width:35% !important;float:left'></div>"+

                 "<div class='spn_total_dt' style='padding-top: 7px;text-align:right;font-weight:600;font-size:18px !important;width:75% !important;float:left'>"+
                 "<span class='spn_fin_subtot' style='font-size:12px !important;text-decoration: line-through;'></span>"+
                 "<span class='spn_fin_tot' ></span>"
                 "</div>"+

                 "<div class='dis_tot'     style='padding-top: 7px;font-weight:600;font-size:18px !important;text-align:left;clear:both;width:25% !important;float:left'>"+total_cstm_txt+"</div>"+
                
             "</span>";
   

               }
              else{
               coupon_tag += "<span class='div_tbl_tot div_tbl_tot1 ' style='max-width:300px !important; text-align:left;display: inline-block;width:"+ totl_width+ "'>"+
               "<div class='dis_tot'     style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>"+
                 dis_text_spl+" <br/><span class='cpn_dcnt_price' style='background-color: rgba(113, 113, 113, .11);padding: 4px;border-radius: 4px;line-height: 20px;margin-left:0px !important'>"+
                "<span>"+ori_cpn_title +"</span>"+
               "<button type=\"button\" class=\"cpn_tag_close\" style='font-weight:600;font-size:12px !important;cursor:pointer'>✕</button>"+
               "</span>"+
               "</div>"+
               "<div class='spn_dis_dt'  style='padding-top: 7px;text-align:right;font-weight:600;font-size:16px !important;width:35% !important;float:left'></div>"+
               "<div class='dis_tot'     style='padding-top: 7px;font-weight:600;font-size:18px !important;text-align:left;clear:both;width:25% !important;float:left'>"+total_cstm_txt+"</div>"+
               "<div class='spn_total_dt' style='padding-top: 7px;text-align:right;font-weight:600;font-size:18px !important;width:75% !important;float:left'>"+
               "<span class='spn_fin_subtot' style='font-size:12px !important;text-decoration: line-through;'></span>"+
               "<span class='spn_fin_tot' ></span>"
               "</div>"+
           "</span>";
 
              }            }
            
             coupon_tag +="</div><div style='"+dis_txt_box_btn +"' class=\"discountify_divider\"></div>";
             $('.discountify_tag').remove();
             $('.discountify_status').append(coupon_tag); 
             $('.discountify_status_msg').show();
             bombay_total(0);
             $("body").find(".discountApplied").remove();
             $("body").find(".discountify_discount_wrap").after("<input type='hidden' name='discount' class='discountApplied' value='"+coupon_title+"'>");
             if(RESP.type == "BUY-XY")
             {
              // is_total_calucat_req=0;
             }
             if (is_total_calucat_req==1)
           {
             display_total_details(discnt_val,ori_cpn_title,shopify_money_format,is_from_cookie);
           }
            else{
             $('.div_tbl_tot').hide();
            }
           }
         if(RESP.type == "BUY-XY"){ 
             $('.discpon_price').remove();
             $('.discpon_success').html("Discounts will be calculated at checkout");
             if (is_total_details==0)
             {
               $('.discountify_tag .cpn_dcnt_price').remove();
             }
             
         }
         firworks_stop();
     }
      remove_style();
     $(".discountify_aply_voucher").html(cpn_btntxt);
     $('.discountify_discount_wrap').find('.lds-dual-ring').hide();
 }
 function intiate_analytycs()
 {
   
   $.getJSON('/cart.js', function(cart) { 
     //cart.total_price
     if (cart.items.length>0)
     {
       cart_token=cart.token;
      
       
     }
     get_voila_data('voila_data');
   });
 
 }
 function barraenthusiasts_get_actual_cart_price(cart)
 {
   $extra_price=0;
   if (shop_domain=='barraenthusiasts.myshopify.com')
   {
       for(var cb=0; cb< cart.items.length;cb++)
       {
           if (cart.items[cb].hasOwnProperty('properties'))
           {
             let bar_valuesArray = Object.values(cart.items[cb].properties);
             for (let barValue of bar_valuesArray) {
               const bar_spli_arr = barValue.split(" | ");
               if (bar_spli_arr.length==2)
               {
                   let bar_prop_value=  bar_spli_arr[1].substring(1); 
                   $extra_price=$extra_price+ parseFloat(bar_prop_value)*cart.items[cb].quantity;
               }
              
             }

           }
       }

   }
   return parseFloat($extra_price)*100;
 }
 function analytys_should_proceed(cart_token,isfrom_popup,coupon_title)
 {
    let prepare_analy_cookie = {"shop": Shopify.shop, "isfrom_popup":isfrom_popup, 
                          "coupon_title":coupon_title,"cart_token":cart_token};
    let analy_cookie = JSON.parse(getWithExpiry("ms_analytys_discount"));
    if (analy_cookie==null)
    {
      setWithExpiry('ms_analytys_discount', JSON.stringify(prepare_analy_cookie));
      return true;
    }
    
    if ((analy_cookie.cart_token!='') && (analy_cookie.cart_token ==cart_token))
    {
        if (coupon_title=='')
        {
          return false
        }
        if ((analy_cookie.cart_token ==cart_token)&&
            (analy_cookie.isfrom_popup ==isfrom_popup)&&
            (analy_cookie.coupon_title ==coupon_title)
           )
        {
          return false;
        }
        
            
    }
    localStorage.removeItem("ms_analytys_discount");
    setWithExpiry('ms_analytys_discount', JSON.stringify(prepare_analy_cookie));
    return true;
   
      
      
 }
 function update_coupon_analytics(isfrom_popup,coupon_title)
 { //return ;
  if(shop_domain=='whats-up-wellness.myshopify.com')
  {
    return;
  }
  if (dis_app_plan_id != 8)
  {
    return;
  }
  if (dis_analtys_required =='N')
  {
    return;
  }
  if (shop_domain=='vapouroxide.myshopify.com')
  {
    return;
  }
  if (shop_domain=='buy-wow-health.myshopify.com')
  {
    return;
  }
   if (global_app_enable=='')
   {
     return;
   }
   if (cart_token=='')
   {
     return;
   }
   if (analytys_should_proceed(cart_token,isfrom_popup,coupon_title)==false)
   {
    return;
   }
   $.ajax({
     type: 'POST',
     url: api_path+"/update_analytics.php?an_from=cart",
     dataType: 'text',
     data:{isfrom_popup:isfrom_popup,coupon_title:coupon_title,cart_token:cart_token,shop_domain:shop_data},
     async:true,
     success: function(response){
      
      
     }
   });
   
   
 }

 
function discount_code_apply_in_checkout_page(coupon_code)
{
    $('#checkout_reduction_code').val(coupon_code);
    $('#checkout_reduction_code').trigger('keypress');
    $('#checkout_submit').removeClass('btn--disabled');
    
    $('#checkout_submit').removeAttr('disabled');
    $('#checkout_submit').click();
     
       setTimeout(() => {
         $(".discountify_modal").remove();
       
       }, 100);
    
}
 function direct_validation(coupon_title,isfrom_popup,isfromcookie)
 {
    if (page=='checkout')
    {
      discount_code_apply_in_checkout_page(coupon_title);
      return;
    }
   original_cart_total=0;
   
   var discnt_val=revlaidate_coupon_code(coupon_title,false);
   if (isfromcookie==true)
      {
       $('#discpon_ajax_popup').hide();
      }
   if (discnt_val <= 0)
   { 
     if (discnt_val==-1)
     {
       discountify_snackbar("ERROR",cpn_invld_err);
     }
     else if (discnt_val==0)
     {
       discountify_snackbar("ERROR",cpn_not_applicable);
     }
     remove_style();
     change_pop_button_style();
            $(".apply_voucher_btn").html(voucher_btntxt);
            $(".discountify_aply_voucher").html(cpn_btntxt);
            if ( is_cart_change_action==1)
            {
              
              is_cart_change_action=0;
              if ($('.cpn_tag_close').length>=1)
              {
                console.log('vlaidation mswe sfdd')
                $('.cpn_tag_close').click();
              }
            }
     return;
   }
   else{
     var is_total_calucat_req=1;
     var coupon_tag ="";
     var coupon_dscnt = "";
     var ajx_popup = document.getElementById("discountify_modal");   
     var shopify_money_format = discountify_store_currency(Shopify.currency.active)+" ";
     var t_discount = discnt_val;
     var cart_subtotal =original_cart_total;
     var discount_round = t_discount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
     discount_round=my_money_format.formatMoney(discount_round,currency_format);

     $.getJSON('/cart.js', function(cart) { 

       cart_token=cart.token;
      
       ori_cpn_title=coupon_title.toUpperCase();
      var cart_price = (Math.round(cart.total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);
      total_cart_price_disp=cart_price;
      cart_subtotal=cart_price;
      if (shop_domain=='bsc-women.myshopify.com')
      {
        cart_price = (Math.round(cart.total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);

        let cart_level_discount= (Math.round(cart.total_discount+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);
        
        if (cart_level_discount>0)
        {
          
          discnt_val= cart_level_discount -t_discount;
          if (discnt_val<0)
          {
            discnt_val=discnt_val*-1;
          }
       
        }
      }

      if (price_issue_stores.includes(shop_domain))
      {
        cart_price = (Math.round(cart.original_total_price+barraenthusiasts_get_actual_cart_price(cart)) / 100).toFixed(2);

        cart_subtotal=cart_price;
        total_cart_price_disp=cart_price;
      }
      
      total_cart_price_disp=Math.round(cart. original_total_price/100).toFixed(2);
      let no_round_off_stores=['ease2dayy.myshopify.com'];
      if (no_round_off_stores.includes(shop_domain))
      {
        total_cart_price_disp=(cart. original_total_price/100).toFixed(2);
      }
      var tmp_pop_applied_suc_text=pop_applied_suc_text.replace("[Coupon Code]","`"+coupon_title+"`");
      if ((cart_subtotal == t_discount )||(is_freeshipping==1)) { 
       is_total_calucat_req=0;
         $(".discpon_wrap").remove();
         coupon_dscnt = free_shipping_text;
         
         if (isfromcookie==false)
         {
           if(msgcpn_body){ $('body').append(msgcpn_body); }
         }
         $('.discpon_applied').text(tmp_pop_applied_suc_text);
         $('.discpon_price_pt').text(free_shipping_text.replace(" ", ""));
         $('.discpon_price_pt').css({"font-size":"30px", "margin-bottom":"15px"});
         $('.discpon_price_txt').hide();
         $('.discpon_success').text("You have availed Free shipping");
         $(ajx_popup).remove();     
           coupon_title=coupon_title.replace('%','%25');
         $('.discpon_btn').attr('href','/checkout?discount='+coupon_title+'');
         
    } else { 
     
         $(".discpon_wrap").remove();
         coupon_dscnt = "- "+shopify_money_format+""+discount_round;
         if (isfromcookie==false)
         {
           if(msgcpn_body){ $('body').append(msgcpn_body); }
         }
         $('.discpon_applied').text(tmp_pop_applied_suc_text);
         var dis_tex=shopify_money_format.replace(" ", "")+discount_round;
         if ((dis_tex.length>=13) )
         {
           $('.discpon_price_pt').css({"font-size":"32px"});
         }
         else if (dis_tex.length>12)
         {
           $('.discpon_price_pt').css({"font-size":"36px"});
         }
         else if (dis_tex.length>10)
         {
           $('.discpon_price_pt').css({"font-size":"38px"});
         }
         $('.discpon_price_pt').text(shopify_money_format.replace(" ", "")+discount_round);
         $('.discpon_success').text("Discount is calculated at checkout");
         $(ajx_popup).remove(); 
           coupon_title=coupon_title.replace('%','%25');
         $('.discpon_btn').attr('href','/checkout?discount='+coupon_title+'');
    }

  
     localStorage.removeItem("dscnt_cookie");
     var dscnt_cookie = {"shop": Shopify.shop, "couponData":{title:ori_cpn_title}, "couponID":coupon_title}; 
     setWithExpiry('dscnt_cookie', JSON.stringify(dscnt_cookie));
     var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie"));
     if(discnt_cookie !== null){ 
       
       setTimeout(() => {
         update_coupon_analytics(isfrom_popup,coupon_title);
       }, 2);
       
         coupon_tag +="<div class=\"discountify_tag\">"+
         "<span class=\"cpn_tag \">"+
             "<span class=\"cpn_tag_wrap\">"+
               "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" class=\"cpn_tag_label\">"+
               "<path d=\"M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z\" fillopacity=\".55\"></path><path d=\"M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z\"></path></svg>"+
               "<span class=\"cpn_title\">"+ori_cpn_title+"</span>"+
               "<span class=\"cpn_dcnt_price\">"+coupon_dscnt+"</span>"+
               "<button type=\"button\" class=\"cpn_tag_close\">✕</button>"+
             "</span>"+
         "</span>";
         if (is_total_details==1)
         {
           var dis_text_spl=discount_cstm_txt;
           if(Shopify.shop == "watchdropmx.myshopify.com") { 
             dis_text_spl='Descuento';
           }
          var totl_width= $('.discountify_manual').width();
          if (totl_width==null)
          {
           totl_width="100%";
          }
          else{
           totl_width=totl_width+"px";
          }
          var discnt_details_width=['viralim.myshopify.com','hellomida.myshopify.com','motiongrey.myshopify.com'];
          if (discnt_details_width.includes(shop_domain))
          {
           totl_width="100%";
          }
          var shp_price_html='';
          if (shop_domain=='bombay-shaving.myshopify.com')
          {
           shp_price_html= `<div class='dis_tot1'   
           style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>
            Shipping
            
           </div>
           <div class='spn_dis_dt1'  style='padding-top: 7px;text-align:right;font-weight:600;
                   font-size:16px !important;width:35% !important;float:left'>₹ 0</div>`;
                   shp_price_html='';
          }
          if (fourth_stores.includes(shop_domain))
         {
          coupon_tag = prepare_fourhtstore_discount_html(total_cstm_txt,dis_text_spl,ori_cpn_title,totl_width,dis_txt_box_btn,coupon_dscnt,ori_cpn_title);
         }
         else{
           var font_weight='600';
           if (shop_domain=='vw-vanity-wagon.myshopify.com')
           {
             font_weight='400';
           }
           if (shop_domain=='masori.myshopify.com')
           {
             font_weight='normal';
           }
           var div_tbl_tot_max_width='100px !important;'
           var div_tbl_tot_width=totl_width ;
           if ($(window).width()<600)
           {
             div_tbl_tot_max_width='100% !important;' ;
             div_tbl_tot_width='100% !important;' ;
           }
           if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
           {
            div_tbl_tot_max_width='100% !important;' ;
            div_tbl_tot_width='100% !important;' ;
           }
           if (shop_domain=='ldu-letsdressup.myshopify.com')
           {
            div_tbl_tot_max_width='100% !important;' ;
            div_tbl_tot_width='100% !important;' ;
           }
          
          
          
          if (right_left_stores.includes(shop_domain))
          {
           coupon_tag += "<span class='div_tbl_tot ' style='max-width:"+div_tbl_tot_max_width+"min-width:280px !important;text-align:left;display: inline-block;width:"+ div_tbl_tot_width+ "'>"+
           shp_price_html+
           "<div class='spn_dis_dt'  style='padding-top: 7px;text-align:right;font-weight:"+font_weight+";font-size:16px !important;width:35% !important;float:left'></div>"+

           "<div class='dis_tot'     style='font-weight:"+font_weight+";font-size:16px !important;display: inline-block;width:65% !important;float:left;text-align:right !important'>"+
             dis_text_spl+" <br/><span class='cpn_dcnt_price' style='background-color: rgba(113, 113, 113, .11);padding: 4px;border-radius: 4px;line-height: 20px;margin-left:0px !important'>"+
            "<span>"+ori_cpn_title +"</span>"+
           "<button type=\"button\" class=\"cpn_tag_close\" style='font-weight:"+font_weight+";font-size:12px !important;cursor:pointer'>✕</button>"+
           "</span>"+
           "</div>"+
          
          
           "<div class='spn_total_dt' style='padding-top: 7px;text-align:right;font-weight:"+font_weight+";font-size:18px !important;width:75% !important;float:left;text-align:left !important;clear:both;'>"+
           "<span class='spn_fin_subtot' style='font-size:12px !important;text-decoration: line-through;'></span>"+
           "<span class='spn_fin_tot' ></span>"+
           "</div>"+
          
           "<div class='dis_tot'     style='padding-top: 7px;font-weight:"+font_weight+";font-size:18px !important;text-align:left;width:25% !important;float:left;text-align:right !important;'>"+ total_cstm_txt+"</div>"+
          
       "</span>";
  
          }
          else{
            var t_left_txt_color='#777777 !important';
            var t_right_txt_color='#777777 !important';
            var div_tbl_tot_min_width='min-width:280px !important;';
            if(shop_domain=='jaipurkurti-com.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#3a517b !important';
              font_weight=500;
            }
            var cpn_sel_color_style='';
            if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
              cpn_sel_color_style='color:#072a40 !important;';
            }
            if (shop_domain=='ldu-letsdressup.myshopify.com')
            {
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
              cpn_sel_color_style='color:#072a40 !important;';
            }
            if (shop_domain=='the-amyra-store.myshopify.com')
            {
              if ($(window).width()<500)
              {
                div_tbl_tot_min_width='';
              }
            
            }
            var left_tot_font_size="font-size:18px !important;";
            var right_tot_font_size="font-size:18px !important;";
            var right_strike_tot_font_size="font-size:12px !important;";
            if (shop_domain=='livspace-store-sgp.myshopify.com')
            {
              left_tot_font_size="font-size:24px !important;";
              right_tot_font_size="font-size:24px !important;";
              right_strike_tot_font_size="font-size:18px !important;";
              t_left_txt_color='#000000 !important';
              t_right_txt_color='#000000 !important';
            }
            if (shop_domain=='fynnushop.myshopify.com')
            {
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_width="100% !important;";
            }
            if (shop_domain=='fancy-fluff-india.myshopify.com')
            {
              if ($(window).width() <500)
              {
                div_tbl_tot_max_width="100% !important;";
                div_tbl_tot_width="100% !important;";
                div_tbl_tot_min_width='min-width:90% !important;'
              }
              
            }

            if (shop_domain=='skinbae-in.myshopify.com')
            {
              if ($(window).width() <500)
              {
                div_tbl_tot_max_width="100% !important;";
                div_tbl_tot_width="100% !important;";
                div_tbl_tot_min_width='min-width:90% !important;'
              }
              
            }
            if (shop_domain=='bombay-shaving.myshopify.com')
            {
              $('.dscnt_manual_field').val(ori_cpn_title);
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_width="100% !important;";
              div_tbl_tot_min_width='min-width:90% !important;';
              left_tot_font_size="font-size:14px !important;";
              right_tot_font_size="font-size:14px !important;";
              if (page=='cart')
              {
                if ($(window).width()>500)
                {
                  div_tbl_tot_max_width="35% !important;";
                  div_tbl_tot_min_width='min-width:35% !important;';

                }
              }
             
             
             
              
            }
            if (shop_domain=='crystallineme-de.myshopify.com')
            {
              div_tbl_tot_max_width="100% !important;";
              div_tbl_tot_min_width='min-width:100% !important;';
              left_tot_font_size="14px";
            }
           

            if (entire_gloabal_api_data.discountify_coupon.t_right_txt_color !='')
            {
              t_right_txt_color=entire_gloabal_api_data.discountify_coupon.t_right_txt_color;
            }
            if (entire_gloabal_api_data.discountify_coupon.t_left_txt_color !='')
            {
              t_left_txt_color=entire_gloabal_api_data.discountify_coupon.t_left_txt_color;
            }
            if (entire_gloabal_api_data.discountify_coupon.right_strike_tot_font_size !='')
            {
              right_strike_tot_font_size=entire_gloabal_api_data.discountify_coupon.right_strike_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.right_tot_font_size !='')
            {
              right_tot_font_size=entire_gloabal_api_data.discountify_coupon.right_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.left_tot_font_size !='')
            {
              left_tot_font_size=entire_gloabal_api_data.discountify_coupon.left_tot_font_size;
            }
            if (entire_gloabal_api_data.discountify_coupon.div_tbl_tot_min_width !='')
            {
              div_tbl_tot_min_width=entire_gloabal_api_data.discountify_coupon.div_tbl_tot_min_width;
            }
            if (entire_gloabal_api_data.discountify_coupon.div_tbl_tot_max_width !='')
            {
              div_tbl_tot_max_width=entire_gloabal_api_data.discountify_coupon.div_tbl_tot_max_width;
            }
            let total_left_width='25%';
            let total_right_width='75%';
            if (shop_domain==='9twentyfivej.myshopify.com'){
               total_left_width='55%';
               total_right_width='45%';
              if ($(window).width()<800)
              {
                total_left_width='58%';
                total_right_width='42%';
              }
            }
       
            if (shop_domain==='identiti-com.myshopify.com'){
              font_weight='normal';

            }
            let left_disc_font_weight=font_weight;
            let right_disc_font_weight=font_weight;
            let left_total_font_weight=font_weight;
            let right_total_font_weight=font_weight;
            if (shop_domain=='packie-1.myshopify.com')
            {
              left_disc_font_weight="normal";
              right_disc_font_weight="normal";
              if ($(window).width()<800)
              {
                right_tot_font_size="font-size:14px;";
                left_tot_font_size="font-size:14px;";
               
              }
              
            }
            let next_linse_dsictont='<br/>';
            let right_discount_styles=`padding-top: 7px;text-align:right;font-weight:${right_disc_font_weight};
                                      ${right_tot_font_size}
                                      width:35% !important;
                                      float:left;color:${t_right_txt_color} `;
            
            let discount_in_same_line_stores=['packie-1.myshopify.com'];
            
            if (discount_in_same_line_stores.includes(shop_domain))
            {
              next_linse_dsictont="";
            }

            
           coupon_tag += "<span class='div_tbl_tot div_tbl_tot2  ' >"+
           shp_price_html+
           "<div class='dis_tot dis_tot_main'>"+
             dis_text_spl+ next_linse_dsictont+" <span class='cpn_dcnt_price'>"+
            "<span>"+ori_cpn_title +"</span>"+
           "<button type=\"button\" class=\"cpn_tag_close\">✕</button>"+
           "</span>"+
           "</div>"+
           "<div class='spn_dis_dt'></div>"+
           "<div class='dis_tot second_line_text'>"+ total_cstm_txt+"</div>"+
           "<div class='spn_total_dt' >"+
           "<span class='spn_fin_subtot' ></span>"+
           "<span class='spn_fin_tot'></span>"+
           "</div>"+
       "</span>";
          }
          
         }
          
         }
         if (fourth_stores.includes(shop_domain)==false)
         {
         coupon_tag +="</div><div style='"+dis_txt_box_btn +"' class=\"discountify_divider\"></div>";
         }
         $('.discountify_tag').remove();
         $('.discountify_status').append(coupon_tag); 
         $('.discountify_status_msg').show();
         bombay_total(0);
         $("body").find(".discountApplied").remove();
         $("body").find(".discountify_discount_wrap").after("<input type='hidden' name='discount' class='discountApplied' value='"+coupon_title+"'>");
       if (feat_cart_cpn_status=='on')
       {
         $("body").find(".discountify_manual_wrap").addClass('main_cpn_hide');
         if (fourth_stores.includes(shop_domain))
         {
           
         }
         else{
           
         }
        
       }
       change_widht_for_total();
         if (is_total_calucat_req==1)
       {
       
         display_total_details(discnt_val,ori_cpn_title,shopify_money_format,isfromcookie);
       }
        else{
         $('.div_tbl_tot').hide();
        }
       }
       firworks_stop();
    /* if(RESP.type == "BUY-XY"){ 
         $('.discpon_price').remove();
         $('.discpon_success').html("Discounts will be calculated at checkout");
         if (is_total_details==0)
         {
           $('.discountify_tag .cpn_dcnt_price').remove();
         }
         
     }*/
     
     });
    
 }
 
  remove_style();
 $(".discountify_aply_voucher").html(cpn_btntxt);
 $('.discountify_discount_wrap').find('.lds-dual-ring').hide();
 open_mini_cart_drw(isfromcookie);
 }
 function prepare_fourhtstore_discount_html(total_cstm_txt,dis_text_spl,ori_cpn_title,totl_width,dis_txt_box_btn,coupon_dscnt,ori_cpn_title1)
 {
   var shp_price_html="";
   var main_sub_total="-";
  if ( $('.cart-subtotal__price').find('span').length>0)
  {
   main_sub_total= $('.cart-subtotal__price').find('span').last().text();
  }

   var fourth_coupon_tag = "<div class=\"discountify_tag\">"+
   "<span class=\"cpn_tag \">"+
       "<span class=\"cpn_tag_wrap\">"+
         "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" class=\"cpn_tag_label\">"+
         "<path d=\"M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z\" fillopacity=\".55\"></path><path d=\"M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z\"></path></svg>"+
         "<span class=\"cpn_title\">"+ori_cpn_title+"</span>"+
         "<span class=\"cpn_dcnt_price\">"+coupon_dscnt+"</span>"+
         "<button type=\"button\" class=\"cpn_tag_close\">✕</button>"+
       "</span>"+
   "</span><span class='div_tbl_tot ' style='max-width:300px !important;min-width:280px !important;text-align:left;display: inline-block;width:"+ totl_width+ "'>"+
 
   "<div class='dis_main_tot'     style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>Subtotal</div>"+
   "<div class='dis_main_tot_val'     style='padding-top: 7px;text-align:right;font-weight:600;font-size:16px !important;width:35% !important;float:left''>"+main_sub_total+"</div>"+
  

   "<div class='dis_tot'     style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>"+
     dis_text_spl+" <br/><span class='cpn_dcnt_price' style='background-color: rgba(113, 113, 113, .11);padding: 4px;border-radius: 4px;line-height: 20px;margin-left:0px !important'>"+
    "<span>"+ori_cpn_title +"</span>"+
   "<button type=\"button\" class=\"cpn_tag_close\" style='font-weight:600;font-size:12px !important;cursor:pointer'>✕</button>"+
   "</span>"+
   "</div>"+
  
   "<div class='spn_dis_dt'  style='padding-top: 7px;text-align:right;font-weight:600;font-size:16px !important;width:35% !important;float:left'></div>"+

   "<div style='display: inline-block;width:100%;margin-top:20px !important;float:left;clear:both;border-top:1px solid black;max-height:3px !important'>&nbsp;<hr/></div>"+

   "<div class='dis_tot'     style='padding-top: 7px;font-weight:600;font-size:18px !important;text-align:left;clear:both;width:25% !important;float:left'>"+ total_cstm_txt+"</div>"+
   "<div class='spn_total_dt' style='padding-top: 7px;text-align:right;font-weight:600;font-size:18px !important;width:75% !important;float:left'>"+
   "<span class='spn_fin_subtot' style='font-size:12px !important;text-decoration: line-through;display:none'></span>"+
   "<span class='spn_fin_tot' ></span>"
   "</div>"+
"</span>";
fourth_coupon_tag +="</div><div style='"+dis_txt_box_btn +"' class=\"discountify_divider\"></div>";
   return fourth_coupon_tag;
 }
 function prepare_fourhtstore_withoutdiscount_total_html()
 {
   var totl_width= $('.discountify_manual').width();
   if (totl_width==null)
   {
    totl_width="100%";
   }
   else{
     if (totl_width<300)
     {
       totl_width=300;
     }
    totl_width=totl_width+"px";
   }
  
   var main_sub_total="-";
  if ( $('.cart-subtotal__price').find('span').length>0)
  {
   main_sub_total= $('.cart-subtotal__price').find('span').last().text();
   main_sub_total=main_sub_total.replace("Rs.", "₹");
  }
  else{
   if ( $('span.cart-subtotal__price').length>0)
   {
    main_sub_total= $('span.cart-subtotal__price').text();
    main_sub_total=main_sub_total.replace("Rs.", "₹");
   }
  }
$('div.cart-subtotal').hide();
  
   
   var fourth_coupon_tag = "<div class=\"discountify_fourth_tag\">"+
     "<span class=' ' style='max-width:300px !important;min-width:280px !important;text-align:left;display: inline-block;width:"+ totl_width+ "'>"+
 
   "<div class=''     style='font-weight:600;font-size:16px !important;display: inline-block;width:65% !important;float:left'>Subtotal</div>"+
   "<div class=''     style='padding-top: 7px;text-align:right;font-weight:600;font-size:16px !important;width:35% !important;float:left''>"+main_sub_total+"</div>"+
  

   "<div style='display: inline-block;width:100%;margin-top:20px !important;float:left;clear:both;border-top:1px solid black;max-height:3px !important'>&nbsp;<hr/></div>"+

   "<div class='dis_tot'     style='padding-top: 7px;font-weight:600;font-size:18px !important;text-align:left;clear:both;width:25% !important;float:left'>"+ total_cstm_txt+"</div>"+
   "<div class='' style='padding-top: 7px;text-align:right;font-weight:600;font-size:18px !important;width:75% !important;float:left'>"+
  
   "<span class='' >"+main_sub_total+"</span>"
   "</div>"+
"</span>";
fourth_coupon_tag +="</div><div style='"+dis_txt_box_btn +"' class=\"discountify_divider\"></div>";
   $('.discountify_subtotal_sec').html( fourth_coupon_tag);
 }
 function change_widht_for_total()
 {
   if(Shopify.shop == "valentina-rio.myshopify.com") { 
  
     $('.apply_voucher_btn').attr('style',  $('.apply_voucher_btn').attr('style') + '; ' + 'padding-top:0px !important');
     $('.proceed_checkoutbtn').attr('style',  $('.proceed_checkoutbtn').attr('style') + '; ' + 'padding-top:1px !important');
   }
     if (shop_domain=='alphabootic.myshopify.com')
     {
       $('.div_tbl_tot ').css('min-width','220px');
       $('.div_tbl_tot ').width(220)
     }
     if (shop_domain=='ldu-letsdressup-staging.myshopify.com')
     {
       $('.div_tbl_tot ').css('max-width','100%');
       $('.div_tbl_tot ').width('100%');
     }
     if (shop_domain=='ldu-letsdressup.myshopify.com')
     {
       $('.div_tbl_tot ').css('max-width','100%');
       $('.div_tbl_tot ').width('100%');
     }
     if (shop_domain=='jaipurkurti-com.myshopify.com')
     {
       $('.div_tbl_tot ').css('min-width','250px');
       $('.div_tbl_tot ').width(250)
      
       
     }
     if(Shopify.shop == "crystallineme-uk.myshopify.com") { 
      $('.second_line_text').css('width','45%');
      $('.spn_total_dt ').css('width','55%');
    }

     if(Shopify.shop == "mondokoro.myshopify.com") { 
       $('.div_tbl_tot ').css('min-width','100%');
       $('.div_tbl_tot ').css('width','100%');
     }
     if(Shopify.shop == "uyyala-com.myshopify.com") { 
       $('.div_tbl_tot ').css('min-width','100%');
       $('.div_tbl_tot ').css('width','100%');
     }
     if(Shopify.shop == "octics-fashion.myshopify.com") { 
       $('.div_tbl_tot ').css('min-width','100%');
       $('.div_tbl_tot ').css('width','100%');
     }
     if (fourth_stores.includes(shop_domain))
     {
       $('.discountify_txtbox_title').hide();
       prepare_fourhtstore_withoutdiscount_total_html();
     }
 }
function firworks_stop()
{
 setTimeout(function () {

   $('.fire_before').hide()
   },1000);
}
function change_width_for_totals()
{
   if (shop_domain=='bsc-women.myshopify.com')
   {
     $('.sticky-footer').find('.div_tbl_tot') .css('max-width','360px');
     $('.sticky-footer').find('.div_tbl_tot') .css('width','360px');
     $('.sticky-footer').find('.spn_fin_tot') .css('font-weight','600');
     $('.div_tbl_tot') .css('max-width','360px')
   
   
   }
   if ((shop_domain=='crystallineme-uk.myshopify.com'))
    {
        $('.div_tbl_tot').css('min-width','240px');
        $('.cart__subtotal').hide();
    
    }
    if ((shop_domain=='crystallineme-de.myshopify.com'))
    {
        $('.div_tbl_tot').css('min-width','240px');
        $('.cart__subtotal').hide();
    
    }
}
 function display_total_details(coupon_dscnt,ori_cpn_title,shopify_money_format,is_from_cookie=false)
 {
   if (is_total_details==1)
   {
     var discount_round = coupon_dscnt.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
     discount_round=parseFloat(discount_round).toFixed(2);
     //total_cart_price_disp=total_cart_price_disp.toFixed(2);
     var tot_valu=(total_cart_price_disp-discount_round).toFixed(2);
     discount_round=my_money_format.formatMoney(discount_round,currency_format);
     tot_valu=my_money_format.formatMoney(tot_valu,currency_format);
     $('.cpn_tag').hide();
     
    hideElements(true);
     if (shop_domain=='whats-up-wellness.myshopify.com')
     {
        shopify_money_format="Rs. ";
     }
    let final_discount_text=shopify_money_format+ ""+discount_round;
    let minus_add_stores=['packie-1.myshopify.com'];
    if (minus_add_stores.includes(shop_domain))
    {
      final_discount_text ="- "+final_discount_text;
    }
     $('.spn_dis_dt').text(final_discount_text);
     if (fourth_stores.includes(shop_domain))
     {
       var main_sub_total=my_money_format.formatMoney(total_cart_price_disp,currency_format);
       $('.dis_main_tot_val').html(shopify_money_format+""+main_sub_total);
       $('.discountify_fourth_tag').hide();
     }
    if (shop_domain=='edrio-india.myshopify.com')
    {
      $('.total').hide();
    }
     $('.spn_fin_subtot').text(shopify_money_format+""+total_cart_price_disp );
     $('.spn_fin_tot').text(" " + shopify_money_format+""+tot_valu);
     $('.div_tbl_tot').show();
     change_width_for_totals();

     if(Shopify.shop == "plumgoodness-2.myshopify.com") {
      $('.discountify_tag').hide(); 
      $('.savings_price').find('span').html(final_discount_text);
      $('.drop-cart_discount').find('.savings_label').after(
        `<span class="discountify_tag">${$('.dis_tot').find('.cpn_dcnt_price').html()}`);
      $('#total_order_Price').find('.money').html(" " + shopify_money_format+""+tot_valu)
      
      cpn_delete();
    }
     if (shop_domain=='artemis-aparels.myshopify.com')
     {
       $('.cart-cost').find('.money').text( $('.spn_fin_tot').text());
     }
     if (shop_domain=='vw-vanity-wagon.myshopify.com')
     {
       $('.saso-cart-original-total').find('.money').text( $('.spn_fin_tot').text());
     }

     if (shop_domain=='tatasimplybetter.myshopify.com')
     {
      if (page=='cart')
      {
        if ($('.cart__total__money').length>=1)
        {
          $('.cart__total__money').text($('.spn_fin_tot').text())
        }
      }
      if ( $('.cart__total__money').find('strong').length>=2)
      {
        $($('.cart__total__money').find('strong')[1]).text( $('.spn_fin_tot').text());
      }
      if (page!=='cart')
      {
          if ( $('.cart__total__money').find('strong').length>=2)
        {
          $($('.cart__total__money').find('strong')[1]).text( $('.spn_fin_tot').text());
        }
        else{
          if ( $('.drawer-subtotal').find('.cart__total__money').length==1)
          {
            $('.drawer-subtotal').find('.cart__total__money').text( $('.spn_fin_tot').text());
          }
        }
      }
      
     }
   }
   else{
     $('.dis_tot').hide();
   }
   
      const disCountAppliedEvent = new CustomEvent('disCountAppliedEvent',{
        detail:{
          discount_code:ori_cpn_title,
          discount_val:$('.spn_dis_dt').text(),
          before_disc_total:$('.spn_fin_subtot').text(),
          after_disc_total:$('.spn_fin_tot').text(),
          is_from_cookie:is_from_cookie
   
         }
      } );
      document.dispatchEvent(disCountAppliedEvent);
   
 }
 const carturlArray = ['/cart/add.js', '/cart/change.js', '/cart/change', '/cart/update.js'];

 function containsAnyForFetch(url, substrings) {
  try{
    return substrings.some(substring => url.includes(substring));
  }
  catch(ex)  
  {
     return false;
  }
}
 var originalFetch = fetch;

// Override the fetch function to add a global completion event
window.fetch =function(url, options) {
  if (containsAnyForFetch(url, carturlArray)) {
      let fetchPromise = originalFetch.apply(this,  [url, options]);
      fetchPromise.then(function (response) {
        response.clone().text().then(function (responseData) {
        let completionEvent = new CustomEvent('fetchComplete',{
            detail:{
            url: response.url
      
            }
          } );
          // You can add your custom project-level notification logic here.
          document.dispatchEvent(completionEvent); // Dispatch the custom completion event
        });
      });
    
      return fetchPromise;
    
  }
  return originalFetch.apply(this, [url, options]);
};
document.addEventListener("fetchComplete", function (e) {
  fetchReponse(e.detail,100);
 
});
if (shop_domain=='nyumi-store.myshopify.com')
{
  var myElement = document.querySelector('.minct_subtotal__price');

  var observer = new MutationObserver(function(mutations) {
    if (document.contains(myElement)) {
      manage_coupon_storage();
     }
 });
 
 observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});

}


var originalSend = XMLHttpRequest.prototype.send;

// Override the send method to add a global completion event
XMLHttpRequest.prototype.send = function () {
  if (shop_domain=='nyumi-store.myshopify.com')
  {
    return;
  }
  let xhr = this;

  // Create a custom event to notify completion
  let completionEvent = new Event("xhrComplete");

  // Add an event listener for the custom completion event
  xhr.addEventListener("xhrComplete", function () {
    newxhrResponse(xhr,800)
    // You can add your custom project-level notification logic here.
  });

  // Call the original send method
  originalSend.apply(xhr, arguments);

  // Listen for the 'load' event, which signifies a successful response
  xhr.addEventListener("load", function () {
    xhr.dispatchEvent(completionEvent); // Dispatch the custom completion event
  });
};


function fetchReponse(res,setTime)
{
     
      
                update_cpns_status(res.url,setTime);
                 
     
           if(res.url.indexOf('/cart/add.js')>=0)
           {
            is_cart_change_action=1;
               console.log(5457);
               setTimeout(() => {
                set_auto_discount_code_stoarge();
                 on_cart_update_terms();
               }, setTime);      
           }
           if ((res.url.indexOf('/cart/change.js')>=0) ||
           (res.url.indexOf('/cart/change')>=0) ||
           (res.url.indexOf('/cart/update.js')>=0))
           {
            is_cart_change_action=1;
               setTimeout(() => {
                 on_cart_update_terms();
               }, setTime);      
           }
           if (shop_domain=='banarasee.myshopify.com')
           {
            if(res.url.indexOf('/cart/change')>=0)
           {
            is_cart_change_action=1;
               setTimeout(() => {
                 on_cart_update_terms();
               }, setTime);      
           }
           }
           
    
}

function newxhrResponse(realXHR,setTime)
{
     if (realXHR.readyState == 4 && realXHR.status == 200) {
          
       var final_url_str= '';
       if ( realXHR._url===undefined)
       {
         final_url_str=realXHR.responseURL
       }
       else{
         final_url_str= realXHR._url;
       }
      
                update_cpns_status(final_url_str,setTime);
             
     
    if (  (final_url_str.indexOf('/cart/change.js')>=0) ||
         (final_url_str.indexOf('/cart/change')>=0) ||
        (final_url_str.indexOf('/cart/update.js')>=0)
        ) 
      {
        is_cart_change_action=1;     
           setTimeout(() => {
             on_cart_update_terms();
           }, setTime);  
       }
     
     }
}
function update_cpns_status(resp_url,setTime)
{
 if (resp_url==undefined)
 {
   return;
 }

 if ((resp_url.indexOf('/cart/change')>=0)||(resp_url.indexOf('/cart/add')>=0)) {
   setTimeout(() => {
    
     display_popup_cpns_based_on_conditions(0);
   }, setTime); 
   if (global_api_data!=null)
   {
     setTimeout(() => {
       cpns_enable_disable(api_path,shop_data,global_api_data);
       display_popup_cpns_based_on_conditions(0);
     }, setTime); 
   }
   
   
   
 }
 
}
function on_cart_update_terms()
{
  $.getJSON('/cart.js', function(cart) { 
     //cart.total_price
     if (cart.items.length==0)
     {
        removing_coupon_complete(true);
        return;
       
     }
    $('.discountify_discount_wrap').find('.lds-dual-ring').show();
 $('.inln_msg').hide();
 $('.div_tbl_tot').hide();
 $('.cpn_tag').hide();
 $('.discountify_status_msg').hide();
 bombay_total(1);

 var discnt_cookie = JSON.parse(getWithExpiry("dscnt_cookie")); 
 if(discnt_cookie !== null){ 

   var active_coupon = discnt_cookie.couponData.title;
   active_coupon=active_coupon.replace('%','%25');
 
     if(active_coupon){ 
   $('.dscnt_manual_field').val(active_coupon);
   $('.discountify_aply_voucher').click();
     }

 }
 fourth_store_hide_sections();
 
     
   });
 
 
}

function fourth_store_hide_sections()
{
 if (fourth_stores.includes(shop_domain))
 {
   $('.cart__footer').find('.rte').hide();
 }
}
 function update_coupon_analytics_checkout(coupon_title)
 {
  if(shop_domain=='whats-up-wellness.myshopify.com')
  {
    return;
  }
  if (dis_app_plan_id != 8)
  {
    return;
  }
  if (dis_analtys_required == 'N')
  {
    return;
  }
  if (shop_domain=='vapouroxide.myshopify.com')
  {
    return;
  }
  if (shop_domain=='buy-wow-health.myshopify.com')
  {
    return;
  }
   if (global_app_enable=='')
   {
     return;
   }
   if (cart_token!='')
   {
     $.ajax({
       type: 'POST',
       url: api_path+"/update_analytics.php?an_from=checkout",
       dataType: 'text',
       data:{coupon_title:coupon_title,cart_token:cart_token,shop_domain:shop_data},
       async:true,
       success: function(response){
        
        
       }
     });

   }

   
   
 }
 function discountify_snackbar(msg_type, msg){
   $('.inln_msg').html('').hide();
  
   if ($('.discountify_discount_wrap').find('.lds-dual-ring').is(':visible'))
   {
     $('.discountify_discount_wrap').find('.lds-dual-ring').hide();
     return;
   }
   var isPopup_opend=$('#discountify_modal').is(':visible');
   if (($(window).width()>desktop_width) ||($(window).width()<=desktop_width))
   //||(shop_domain=='vw-vanity-wagon.myshopify.com')||(shop_domain=='salesify-demo.myshopify.com'))
   {
     if ((isPopup_opend==true))
     {
 
       if ($(window).width()<desktop_width)
       {
         if ( $('.discountify_error').length==0)
         {
           $('.apply_voucher_btn').parent().before(`<div style='text-align:center;padding-bottom:10px !important;width:100% !important;float:left' class="discountify_error">&nbsp;</div>`);
           $('.apply_voucher_btn').parent().width('100%');
           $('.discountify_pop_footer').css('cssText', 'height:90px !important;');
         }
       

         
       }
       $('.discountify_error').html(msg);
       $('.discountify_error').show();
       
        return;
     }
   }
   
  if ((err_message_setting == 'ALERT')||(isPopup_opend==true))
  {
   var msg_class="";
   if(msg_type == "SUCCESS"){ msg_class = " dscnt_success"; }else if(msg_type == "ERROR"){ msg_class = " dscnt_error"; }
   if(msg){
     var snckbar = '<div class="discountify_snackbar'+msg_class+'">'+msg+'<button class="action_close">✕</button></div>';  
     $(".discountify_snackbar").remove();
     
     $('body').append(snckbar);
   }
   setTimeout(function(){ $(".discountify_snackbar").remove(); }, 3000);
  }else{
      if ($('.discountify_manual_wrap').width()==0)
      {
          
      }
      else{
        $('.inln_msg').width('100%');  
      }
      $('.inln_msg').width( $('.discountify_manual').width());  
      
      if (shop_domain=='deesse-cosmique.myshopify.com')
     {
       $('.inln_msg').width('100%');  
     }
     if(shop_domain == "silvertraq.myshopify.com") { 
       $('.inln_msg').width('100%');
       
     }
    $('.inln_msg').html(msg).show();
  }
 }
 
 var discountify_store_currency = function($req_cur=''){
  var currency = {};
  currency['CURRENCY'] = { AUD : '$', CAD : '$', CHF : 'CHF', EUR : '€', GBP : '£', INR : '₹' , JPY : '¥' , USD : '$', JAR : 'R', SGD : '$', RON : 'RON ',ILS:'₪' };
  for (var [key, value] of Object.entries(currency)) {
         for (var [key1, value1] of Object.entries(value)) {
             if(key1 == $req_cur) { 
                 return value1;
             }
         }
   }
   return $req_cur;
 };
 function cuurentUTC(){
  var currentdate = new Date(); 
  var utcdate = currentdate.getUTCFullYear()+"-"+ (currentdate.getUTCMonth()+1)+"-"+ currentdate.getUTCDate()+" "+currentdate.getUTCHours()+":"+currentdate.getUTCMinutes()+ ":" +currentdate.getUTCSeconds();
  return utcdate;
 }
   function setWithExpiry(key, value) {
         const now = new Date()

         // `item` is an object which contains the original value
         // as well as the time when it's supposed to expire
         const item = {
             value: value,
             expiry: now.getTime() + expiryTime,
         }
        
         localStorage.setItem(key, JSON.stringify(item))
     }

     function getWithExpiry(key) {
         const itemStr = localStorage.getItem(key)
      
         // if the item doesn't exist, return null
         if (!itemStr) {
             return null
         }

         const item = JSON.parse(itemStr);
         

         if (item.expiry==undefined)
         {
               localStorage.removeItem(key);
                return null;
         }
         const now = new Date();
         // compare the expiry time of the item with the current time
         if (now.getTime() > item.expiry) {
             // If the item is expired, delete the item from storage
             // and return null
             localStorage.removeItem(key)
             return null
         }
        
         return item.value
     }
 
     
 function get_numeric_value(strFloatValue)
 {
   if (strFloatValue == undefined)
   {
     return 0;
   }
   strFloatValue=  strFloatValue.replace('Rs.','');
   if(Shopify.shop == "watchdropmx.myshopify.com") { 
   
     strFloatValue=  strFloatValue.replace('.','');
     strFloatValue=  strFloatValue.replace(',','.');

   }
    var doublenumber = Number(strFloatValue.replace(/[^0-9\.]+/g,""));
   return doublenumber;
 }
//
function graphql_checkout_unstable(coupon_code,isAsync=false)
{

}

function checkout_url_issue(coupon_code,isAsync=false)
{
  let final_va=0;
  $.ajaxSetup({async: false});  
  $.post('/cart/update.js', 
  {
    attributes: { '_ ': '  ' }
  }, function (data) {
  
    $.ajaxSetup({async: true});  
    final_va=revlaidate_coupon_code_aa(coupon_code,isAsync=false);
   
  },'json');
 
  return final_va;
}

function revlaidate_coupon_code(coupon_code,isAsync=false)
 {
  
 
 
  const abandon_issues=['bombay-shaving.myshopify.com','bsc-women.myshopify.com',
     
   'cptoothbrush.myshopify.com','buy-wow-health.myshopify.com'];
   const checkout_url_issue_stores=['equine-and-country-pikeur.myshopify.com','fancy-fluff-india.myshopify.com', 'the-indian-ethnic-company.myshopify.com'];
   if (checkout_url_issue_stores.includes(shop_domain))
  {
    revlaidate_coupon_code_aa('+',false)
   // return revlaidate_coupon_code_aa(coupon_code,isAsync);
    // return revlaidate_coupon_code_aa(coupon_code,isAsync);
  }
  if (abandon_issues.includes(shop_domain))
  {
    return revlaidate_coupon_code_aa(coupon_code,isAsync);
  }
 
     var discount_val=-1;
var cart_currency_code="";
var cart_items_subtotal_price=0;
is_freeshipping=0;
   $.ajax({
     type: "get",
    
     url: window.location.origin+"/cart.js",
    
     dataType: 'json',
     async:false,
     success: function(response){
  if (response.items.length>0)
  {
      
      var json_cart_array=[];
      for(var i=0;i<response.items.length;i++)
      {
         var json_cart={};
         cart_currency_code=response.currency;
         cart_items_subtotal_price=response.items_subtotal_price/100;
         json_cart.variant_id=response.items[i].variant_id;
         json_cart.quantity=response.items[i].quantity;
         json_cart_array.push(json_cart);
      }

      const authorization_header_value = 'Basic ' + btoa(sh_acc_token);
    var checkout_total_line_items_price=0;
    var check_out_currency='';
    let wallet_url=window.location.origin+"/wallets/checkouts/";
    if (wallet_check_out_shops.includes(shop_domain))
    {
      if (wallet_check_out_url!='')
      {
         wallet_url+=wallet_check_out_url;
      }
    }
    
$.ajax({
 type: "post",
 headers: {
   'Authorization':authorization_header_value,
   
   'Content-Type':'application/json'
},
 url: wallet_url,
 data:'{"checkout":{"discount_code":"'+coupon_code+'","line_items":'+ JSON.stringify(json_cart_array)+'}}',
 dataType: 'json',
 async:false,
 success: function(response){
   
     var c_app_obje=response['checkout']['applied_discount'];

     try{
      for(let k=0;k<response['checkout']['applied_discounts'].length;k++)
      {
         if (response['checkout']['applied_discounts'][k].title==coupon_code)
         {
           c_app_obje=response['checkout']['applied_discounts'][k];
           if (c_app_obje.discount_class=="SHIPPING")
           {
              c_app_obje.value_type='shipping';
           }
           break;
         }
      }
     }
     catch(ex)
     {
      console.log('ms disc discounts new function')
     }

     if (c_app_obje['applicable']==true)
     {
    
      
       if (
            (shop_domain=='ldu-letsdressup-staging.myshopify.com')||
            (shop_domain=='ldu-letsdressup.myshopify.com')
          )
       {
         
        document.cookie = "discount_code="+coupon_code;
       }
       else if (shop_domain=='whats-up-wellness.myshopify.com')
       {
        var now = new Date();
var time = now.getTime();
time += 3600 * 1000;
now.setTime(time);
document.cookie = 
'discount_code=' + coupon_code + 
'; expires=' + now.toUTCString() + 
'; path=/';
      //  document.cookie = "discount_code="+coupon_code+";domain=whatsupwellness.in;expires=;SameSite=none;Secure=true";
        
       }
       else{
        document.cookie = "discount_code="+coupon_code+'; path=/';
       }
    
      if (response.checkout.discount_violations.length>0)
      {
        if (response.checkout.discount_violations[0].applicable===false)
        {
          discount_val=0;
          return ;
        }
      }
         if (c_app_obje['value_type']=='shipping')
         {
             is_freeshipping=1;
             discount_val=response['checkout']['total_line_items_price'];
         }
         else
         {
           discount_val= c_app_obje['amount'];
           checkout_total_line_items_price=response['checkout']['total_line_items_price'];
              if (response['checkout']['currency']!=cart_currency_code)
              {
                  if (checkout_total_line_items_price!=cart_items_subtotal_price)
                  {
                      var div_per=cart_items_subtotal_price/checkout_total_line_items_price;
                       discount_val=c_app_obje['amount']*div_per;
                  }
              }
              else{
                    discount_val= c_app_obje['amount'];
              }
              
         }
         setTimeout(() => {
          
           check_coupon_code(coupon_code);
         }, 2); 
       
     }
     else{
       discount_val=0;
     }
     

 },
 error: function(response)
 {
       remove_style();
                     $(".discountify_aply_voucher").html(cpn_btntxt);
  return discount_val;
 }
 });

  }
   
     }
     });

     return discount_val;
 }
 function revlaidate_coupon_code_aa(coupon_code,isAsync=false)
 {
    coupon_code=coupon_code.replace('%','%25');
   var chckout_url = "/checkout/?discount="+coupon_code;
   var reval_coupon_value=0;
   var final_url=chckout_url;
   var method_type_ch='POST';
   let no_new_checkout_urls=['fancy-fluff-india.myshopify.com','uncomplicated-clothing.myshopify.com'];
   if ((actual_check_out_url== undefined))
   {

     actual_check_out_url='';
    
   }
   if (no_new_checkout_urls.includes(shop_domain))
   {
    actual_check_out_url='';
    method_type_ch='POST';
   }
   else{
    if (actual_check_out_url!='')
    {
      final_url=actual_check_out_url+"?discount="+coupon_code;
      method_type_ch='GET';
    }
   
   }
   $.ajax({
     type: method_type_ch,
     url: final_url,
     dataType: 'text',
     async:isAsync,
     success: function(response){
      
       var original_price =0;
       var sales_price=0;
       var original_html_ele=$(response).find('.total-recap__original-price');
       var sales_html_ele=$(response).find('.total-recap__final-price');
       var notice__text=$(response).find('.notice__text');
       summary_html= $(response).find('.order-summary__section--total-lines');
       actual_check_out_url= $(response).find('.edit_checkout').attr( 'action' );
      var invalid_html= $(response).find('.field__message--error');

      
      if (invalid_html.length==1)
      {
       reval_coupon_value= -1;
       return;
      }
       if (notice__text.length==1)
       {
         if (notice__text.text()=='There was a problem processing the payment. Try refreshing this page or check your internet connection.')
         {
             notice__text.text('');
         }
       }
    
       if ((notice__text.text() == undefined)|| (notice__text.text().length==0))
       {
             if (original_html_ele != undefined)
             {
               original_price=get_numeric_value(original_html_ele.html());
             
             }
             if (sales_html_ele != undefined)
             {
               sales_price=get_numeric_value(sales_html_ele.html());
   
             }

             reval_coupon_value = original_price-sales_price;
             original_cart_total=original_price;
             var shipping=$(response).find("[data-discount-type=shipping]");
           
             if ((shipping!=undefined)&&(shipping.length>0))
             {
                 var subtotal_value=$(response).find("[data-checkout-subtotal-price-target]");
              
                 is_freeshipping=1;
                 reval_coupon_value = get_numeric_value(subtotal_value[0].innerHTML);
                 original_cart_total=reval_coupon_value;
             }
          
         }
       else{
        
         if (notice__text.length>1)
         {
           discountify_snackbar("ERROR",$(notice__text[0]).text());
          
         }
         else{
           discountify_snackbar("ERROR",notice__text.text());
         }
        
           reval_coupon_value=0;

       }
      
     
    

     }
   });
   
   return reval_coupon_value;
 }
/* prepare functions */
}; 
var loadScript = function(url, callback){
var script = document.createElement("script");
script.type = "text/javascript";
if (script.readyState){ 
 script.onreadystatechange = function(){
   if (script.readyState == "loaded" || script.readyState == "complete"){
     script.onreadystatechange = null;
     callback();
   }
 };
} else {
 script.onload = function(){
   callback();
 };
}
script.src = url;
document.getElementsByTagName("head")[0].appendChild(script);
};
if ((typeof jQuery === 'undefined') || (parseInt(jQuery.fn.jquery) === 1 && parseFloat(jQuery.fn.jquery.replace(/^1\./,'')) < 7.1)) {
loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
 var jQuery191 = jQuery.noConflict(true);
 manageDiscountifyApp(jQuery191);
});
} else {
manageDiscountifyApp(jQuery);
}
})();
